/* ============================================================
   Sümer Art Decoration — İmmersive Ev Turu (Shopify sürümü)
   Bu dosya sumer-art-immersive-v2.html prototipinden üretildi.
   Prototipte değişiklik yapıldığında buraya yeniden aktarılmalıdır.

   Prototipten FARKLARI (yalnızca bu üçü):
   1. Büyük medya (video/fotoğraflar) base64 gömülü değil; tema
      window.immersiveTourAssets ile enjekte ediyor (bkz. section).
   2. Ürünler sabit değil; Shopify koleksiyonlarından etiketle çekiliyor
      (bkz. PRODUCT_DATA / roomItems).
   3. Taşan parçalar (sticker) ürünün kendi galerisinden geliyor: alt text'i
      "vitrin-sticker" olan görsel. Yön ve kaydırma, görselin şeffaflık
      sınırlarından ölçülür (bkz. stickerGeo) — ürün başına liste/kod yok.
   ============================================================ */
/* Yapı işareti: hangi sürümün çalıştığını anında görmek için. Bir görüntü
   sorununda "yayındaki kod mu yanlış, yoksa tarayıcı eski paketi mi sunuyor"
   sorusunu ölçmeden ayırt etmeyi sağlar (konsolda: immersiveTourBuild). */
window.immersiveTourBuild = '2026-08-14-sira-tarama30';
/* Tema tarafından enjekte edilen medya; boşsa ilgili görsel gösterilmez. */
const ASSETS = window.immersiveTourAssets || {};
gsap.registerPlugin(ScrollTrigger);
const mm = gsap.matchMedia();
/* Eser/etiket belirme animasyonu (layoutRoom içinden çağrılır): tam
   harekette power3.out + "önce oda, sonra eser" için .22s gecikme;
   azaltılmış harekette anlık (animasyonsuz) geçiş. */
let revealFrame = (el, active) => { el.style.opacity = active ? '1' : '0'; };
mm.add('(prefers-reduced-motion: no-preference)', () => {
  revealFrame = (el, active) => {
    /* Mobilde daha kısa: hızlı kaydırmada 0.6sn'lik geçiş yetişemeyip
       eser "hiç gelmemiş" gibi görünüyordu. Mobilde geçiş SIRALI: giden
       eser 0,22 sn'de tamamen söner, yeni eser 0,24 sn'de belirmeye başlar —
       iki eser hiçbir an yarı saydam üst üste görünmez. Masaüstü aynen. */
    const dar = window.innerWidth < 768;
    gsap.to(el, { opacity: active ? 1 : 0, duration: dar ? (active ? .32 : .22) : .6, ease: 'power3.out', delay: active ? (dar ? .24 : .22) : 0, overwrite: 'auto' });
  };
});
mm.add('(prefers-reduced-motion: reduce)', () => {
  revealFrame = (el, active) => { gsap.set(el, { opacity: active ? 1 : 0 }); };
});
const FACADE_B64 = ASSETS.facade || ''; // yeni giriş videosunun ilk karesi (kapı cephesi) — poster + videosuz yedek

const ENTRANCE_VIDEO_B64 = ASSETS.entranceVideo || ''; // yeni giriş videosu (10sn 720p, ses yok, her kare anahtar kare: -g 1 -crf 19, akıcı scroll taraması için)
const CERCEVE1_B64 = ASSETS.cerceve1 || ''; // videonun son karesiyle aynı sahnenin yüksek çözünürlüklü hali — Çerçeveyi Aşanlar odasının 1. görünümü

const SALON_B64 = (ASSETS.salon && ASSETS.salon.length) ? ASSETS.salon : [
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Last.png?v=1783663322',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Last.png?v=1783663322',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Last.png?v=1783663322',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Last.png?v=1783663322',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Last.png?v=1783663322',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Last.png?v=1783663322'
];

const BANYO_B64 = (ASSETS.banyo && ASSETS.banyo.length) ? ASSETS.banyo : [
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Banyo_1.png?v=1783664659',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Banyo_2.png?v=1783664661',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Banyo_3.png?v=1783664660',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Banyo_4.png?v=1783664665',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Banyo_5.png?v=1783664665',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Banyo_6.png?v=1783664666'
];

const MUTFAK_B64 = (ASSETS.mutfak && ASSETS.mutfak.length) ? ASSETS.mutfak : [
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Mutfak_1.png?v=1783663311',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Mutfak_2.png?v=1783663305',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Mutfak_3.png?v=1783663304',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Mutfak_4.png?v=1783663303',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Mutfak_5.png?v=1783663310',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Mutfak_6.png?v=1783663312'
];

const COCUK_B64 = (ASSETS.cocuk && ASSETS.cocuk.length) ? ASSETS.cocuk : [
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Cocuk_1.png?v=1783663296',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Cocuk_2.png?v=1783663296',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Cocuk_3.png?v=1783663316',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Cocuk_4.png?v=1783663319',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Cocuk_5.png?v=1783663300',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Cocuk_6.png?v=1783663325'
];
const SEVIMLI_B64 = (ASSETS.sevimli && ASSETS.sevimli.length) ? ASSETS.sevimli : [
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Sevimli_Dostlar_1.png?v=1783663295',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Sevimli_Dostlar_2.png?v=1783663295',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Sevimli_Dostlar_3.png?v=1783663298',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Sevimli_Dostlar_4.png?v=1783663295',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Sevimli_Dostlar_5.png?v=1783663297',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Sevimli_Dostlar_6.png?v=1783663297'
];
const ROMANTIK_B64 = (ASSETS.romantik && ASSETS.romantik.length) ? ASSETS.romantik : [
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Love_is_1.png?v=1783663300',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Love_is_2.png?v=1783663303',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Love_is_3.png?v=1783663303',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Love_is_4.png?v=1783663303',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Love_is_5.png?v=1783663306',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Love_is_6.png?v=1783663312'
];
const CICEK_B64 = (ASSETS.cicek && ASSETS.cicek.length) ? ASSETS.cicek : [
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Birth_Flowers_1.png?v=1783663292',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Birth_Flowers_2.png?v=1783663325',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Birth_Flowers_3.png?v=1783663307',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Birth_Flowers_4.png?v=1783663325',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Birth_Flowers_5.png?v=1783663309',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Birth_Flowers_6.png?v=1783663305'
];
const YILBASI_B64 = (ASSETS.yilbasi && ASSETS.yilbasi.length) ? ASSETS.yilbasi : [
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Yilbasi_1.png?v=1783663304',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Yilbasi_2.png?v=1783663300',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Yilbasi_3.png?v=1783663301',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Yilbasi_4.png?v=1783663305',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Yilbasi_5.png?v=1783663305',
  'https://cdn.shopify.com/s/files/1/0948/2112/2352/files/Yilbasi_6.png?v=1783663312'
];

const LEAF_B64 = ASSETS.leaf || '';

/* =====================================================================
   GÖRSEL AYARLARI — Buraya kendi görsellerinizi ekleyin
   ---------------------------------------------------------------------
   facade      : Evin dış cephesi / kapı fotoğrafı (yatay, min 1920px)
   facadeDoor  : Kapının fotoğraftaki konumu (% olarak) — kamera bu
                 noktaya doğru "yürür". x: soldan, y: üstten.
   rooms[...]  : İKİ SEÇENEK:
                 a) Tek panorama (string): 'img/mutfak.jpg' — kamera
                    fotoğraf üzerinde kayarak gezer.
                 b) Görünüm dizisi (array): ['m1.jpg','m2.jpg',...] —
                    her tabloda odanın o bölümünün fotoğrafı gösterilir,
                    geçişler yumuşak crossfade olur. (Önerilen: 6 adet,
                    aynı odanın soldan sağa farklı açıları.)
                 Boş bırakılırsa stilize yedek sahne gösterilir.
   Ürün görselleri: aşağıdaki ROOMS -> items -> img alanına URL ekleyin.
===================================================================== */
const IMAGES = {
  entranceVideo: ENTRANCE_VIDEO_B64, // KAPIDAN GİRİŞ VİDEOSU (gömülü). Dolu ise
                                    // fotoğraf yerine scroll ile taranan
                                    // video kullanılır (önerilen yöntem).
  facade: FACADE_B64,               // gömülü cephe fotoğrafı (aşağıda)
  facadeDoor: { x: 50, y: 45 }, // kapı aralığındaki ışığın ölçülen merkezi (yeni cephe karesi)
  rooms: {
    /* cerceveyiasanlar: şimdilik TEK görünüm — videonun son karesiyle aynı
       sahne (taş duvar + lamba). 1 elemanlı dizi: her adım aynı kareyi tam
       ekran gösterir, video bitişiyle birebir örtüşür. Kullanıcı 6 gerçek
       fotoğrafı (aynı duvarın devam açıları) verdiğinde bu dizi 6 elemana
       çıkarılacak — başka kod değişikliği gerekmez. */
    cerceveyiasanlar: [CERCEVE1_B64],
    salon:  SALON_B64,              // 6 görünüm (Shopify CDN)
    mutfak: MUTFAK_B64,             // 6 görünüm (Mutfak_1..6)
    banyo:  BANYO_B64,              // 6 görünüm (Banyo_1..6)
    cocuk:  COCUK_B64,
    sevimli: SEVIMLI_B64,           // 6 görünüm (Sevimli_1..6)
    romantik: ROMANTIK_B64,          // 6 görünüm (Love is_1..6)
    cicek: CICEK_B64,                // 6 görünüm (Birth Flowers_1..6)
    yilbasi: YILBASI_B64             // 6 görünüm (Yılbaşı_1..6)
  },
  /* Her görünümde tablonun asılacağı nokta (ekran yüzdesi) ve ölçeği.
     Fotoğraftaki boş duvar alanına göre görünüm başına ayarlanır. */
  /* Ölçek kalibrasyonu: her odanın fotoğrafındaki referans nesnelere
     (dolap/tezgah/küvet/raf yüksekliği) göre gözle ölçülüp eserin
     gerçekte 40-55cm bandında bir çerçeveli baskı gibi durması için
     düşürüldü — önceki değerler duvara göre belirgin şekilde büyüktü. */
  /* light: {x,g} — her GÖRÜNÜMÜN kendi fotoğrafındaki ışık yönü (canvas
     piksel parlaklık analiziyle sol/sağ yarı karşılaştırılarak ölçüldü).
     x: -1 ışık sağdan (gölge sola), 1 ışık soldan (gölge sağa), 0 dengeli/
     tepeden. g: cam parlamasının açısı, x ile tutarlı. */
  frameSpots: {
    /* cerceveyiasanlar: şimdilik tek fotoğraf (taş duvar, lamba solda,
       sehpa sağda). Etiket sağda (wl-r) durduğu için eser+etiket bloğunun
       görsel merkezi, eserin merkezinden ~76px sağda kalıyor; x bu yüzden
       telafili: duvar merkezi ~%50 iken eser %41'e çekildi ve blok 1280px
       ekranda tam ortalandı (ölçüm: sapma 0px). Işık soldaki lambadan,
       gölge sağa. 6 gerçek fotoğraf gelince görünüm başına yeniden
       kalibre edilecek — telafi kuralı: etiket sağdaysa x -= ~6,
       soldaysa (lab:'l') x += ~6. */
    /* y 39 -> 45: taşan eserler (kanat/balon/dal ucu) oda başlığının üstündeki
       metne biniyordu (ölçüm: Kanat Açılışı'nda kanat ucu "Çerçeveyi Aşanlar"
       açıklama metnine değiyordu). Çerçeveyi duvarda biraz aşağı kaydırmak
       metinle eser arasına pay açıyor; taş duvar alanı geniş olduğu için altta
       koltuk/sehpaya değecek kadar aşağı inmiyor. */
    cerceveyiasanlar: [
      {x:41, y:45, s:.60, light:{x:1,g:112}}, {x:41, y:45, s:.60, light:{x:1,g:112}}, {x:41, y:45, s:.60, light:{x:1,g:112}},
      {x:41, y:45, s:.60, light:{x:1,g:112}}, {x:41, y:45, s:.60, light:{x:1,g:112}}, {x:41, y:45, s:.60, light:{x:1,g:112}}
    ],
    salon: [
      {x:50, y:41, s:.60, light:{x:-1,g:248}}, {x:50, y:41, s:.60, light:{x:-1,g:248}}, {x:50, y:41, s:.60, light:{x:-1,g:248}},
      {x:50, y:41, s:.60, light:{x:-1,g:248}}, {x:50, y:41, s:.60, light:{x:-1,g:248}}, {x:50, y:41, s:.60, light:{x:-1,g:248}}
    ],
    banyo: [
      {x:62, y:40, s:.53, lab:'r', light:{x:1,g:112}},  // B1: ayna+lavabo ortada, tablo sağdaki boş mermere — sol yarı belirgin parlak
      {x:48, y:45, s:.62, light:{x:0,g:100}},    // B2: geniş boş orta duvar — dengeli
      {x:53, y:44, s:.62, light:{x:1,g:112}},    // B3: küvet solda, orta duvar boş — sol parlak
      {x:55, y:44, s:.59, lab:'l', light:{x:1,g:112}},  // B4: lavabo solda, etiket sola — sol belirgin parlak
      {x:46, y:45, s:.62, light:{x:1,g:112}},    // B5: havlu merdiveni sağda, tablo orta-sola — sol parlak
      {x:50, y:40, s:.59, light:{x:0,g:100}}   // B6: tabure altta, tablo duvarın üst-ortasına — dengeli
    ],
    mutfak: [
      {x:50, y:42, s:.58, light:{x:-1,g:248}},  // M1: pencere sağda belirgin parlak
      {x:50, y:42, s:.58, light:{x:0,g:100}},   // M2: dengeli
      {x:51, y:42, s:.58, light:{x:1,g:112}},   // M3: sol hafif parlak
      {x:49, y:42, s:.58, light:{x:-1,g:248}},  // M4: sağ hafif parlak
      {x:50, y:42, s:.58, light:{x:0,g:100}},   // M5: dengeli
      {x:54, y:42, s:.58, light:{x:0,g:100}}    // M6: kahve barı solda, tablo orta-sağa — dengeli
    ],
    cocuk: [
      {x:50, y:44, s:.52, light:{x:1,g:112}},              // Ç1: dolaplar solda, kitaplık sağda — sol parlak
      {x:50, y:43, s:.52, light:{x:0,g:100}},              // Ç2: çadır solda, dolaplar sağda — dengeli
      {x:48, y:43, s:.52, light:{x:-1,g:248}},             // Ç3: oyuncaklar solda, çadır sağda — sağ belirgin parlak
      {x:50, y:42, s:.52, light:{x:1,g:112}},              // Ç4: beşik solda, koltuk sağda — sol belirgin parlak
      {x:50, y:42, s:.52, light:{x:1,g:112}},              // Ç5: beşik solda, çadır sağda — sol parlak
      {x:44, y:41, s:.51, lab:'r', light:{x:-1,g:248}}     // Ç6: raf sağ-altta, tablo orta-sola — sağ belirgin parlak
    ],
    /* sevimli: 6 gerçek fotoğraf (aynı köşenin farklı pan açıları), her
       görünümün boş duvar konumu ve gerçek ışık yönü (canvas parlaklık
       analiziyle ölçüldü) ayrı ayrı kalibre edildi. */
    sevimli: [
      {x:30, y:38, s:.62, light:{x:-1,g:246}},  // S1: sol/orta çok geniş boş duvar — sağdan gün ışığı, gölge sola
      {x:64, y:38, s:.60, light:{x:-1,g:250}},  // S2: kulp/tasma rafı ile kedi köşesi arası boş duvar — sağdan belirgin ışık
      {x:44, y:38, s:.60, light:{x:-1,g:254}},  // S3: tasma rafı ile mama tabağı/kedi ağacı arası — pencereden sağdan en güçlü ışık
      {x:51, y:38, s:.60, light:{x:1,g:110}},   // S4: kapı çerçevesi öncesi boş duvar — pencere artık solda, ışık soldan
      {x:51, y:38, s:.62, light:{x:1,g:114}},   // S5: kapı ile tasma rafı arası geniş boş duvar — soldan yumuşak ışık
      {x:48, y:37, s:.60, light:{x:0,g:100}}    // S6: geniş cephe görünümü, orta sütun boş duvar — iki pencereden dengeli ışık
    ],
    /* romantik: 6 gerçek fotoğraf (bordo aksan duvar + ampul dizisi köşesi,
       farklı pan/zoom açıları). Duvar hep aynı bordo panel; sandalye/bar
       arabası/masa konumuna göre boş alan kaydı. Işık: V1'de sağdan (koridor
       tarafı), V2-V6'da soldan (pirinç lamba + krem duvar tarafı) geliyor. */
    romantik: [
      {x:43, y:42, s:.62, light:{x:-1,g:246}},  // R1: bar arabası yok, en geniş boş duvar — sağdan
      {x:41, y:37, s:.58, light:{x:1,g:110}},   // R2: bar arabası sağda belirdi, üst alan daraldı — soldan
      {x:40, y:38, s:.58, light:{x:1,g:112}},   // R3: aynı kompozisyon, pencere daha aydınlık — soldan
      {x:42, y:37, s:.57, light:{x:1,g:112}},   // R4: koltuk mor/gri, örtü daha yukarı — soldan
      {x:43, y:38, s:.56, light:{x:1,g:114}},   // R5: kamera geri çekildi, sağda mumlar eklendi — soldan belirgin
      {x:44, y:39, s:.56, light:{x:1,g:118}}    // R6: en geniş açı, gün batımı camdan — soldan en güçlü
    ],
    /* cicek: 6 gerçek fotoğraf (krem/bej spa koridoru, çift taraflı konsol/
       lavabo mockup duvarları). Çoğu görünüm dengeli/yumuşak ışıklı; V2/V3/V5
       hafif soldan pencere parlaması gösteriyor. */
    cicek: [
      {x:54, y:40, s:.65, light:{x:0,g:100}},   // Ç1: konsol solda, en geniş boş duvar — dengeli
      {x:41, y:38, s:.60, light:{x:1,g:108}},   // Ç2: kahve barı sağda, pencere solda — hafif soldan
      {x:48, y:38, s:.60, light:{x:1,g:106}},   // Ç3: kahve barı sol, lavabo sağ — hafif soldan
      {x:48, y:38, s:.60, light:{x:0,g:100}},   // Ç4: lavabo sol, havlu bankı sağ — dengeli
      {x:54, y:38, s:.62, light:{x:1,g:114}},   // Ç5: havlu bankı sol, başka banyoya geçiş sağda — soldan belirgin
      {x:53, y:38, s:.62, light:{x:0,g:100}}    // Ç6: duş/lavabo sol, bank sağ — dengeli
    ],
    /* yilbasi: 6 gerçek fotoğraf (koyu yeşil duvar, ampul dizisi + çam
       ağacı/şömine köşesi). Işık yönü görünüme göre değişiyor — bazılarında
       şömine/ağaç sağda parlak, bazılarında pencere solda parlak. */
    yilbasi: [
      {x:64, y:40, s:.60, light:{x:-1,g:248}},  // Y1: çam ağacı+çorap solda, sütun duvar sağda geniş boş — sağdan
      {x:42, y:36, s:.60, light:{x:1,g:114}},   // Y2: konsol sağda, pencereler solda — soldan
      {x:51, y:37, s:.60, light:{x:1,g:112}},   // Y3: şömine sağda, konsol solda — soldan
      {x:52, y:38, s:.60, light:{x:-1,g:250}},  // Y4: şömine solda, çam ağacı+pencere sağda — sağdan
      {x:53, y:34, s:.60, light:{x:0,g:100}},   // Y5: çam ağacı sol, koltuk+lamba sağ — dengeli
      {x:54, y:40, s:.62, light:{x:1,g:120}}    // Y6: pencere+odun sepeti solda, geniş orta duvar — soldan en güçlü
    ]
  }
};

/* Oda fotoğrafındaki gerçek ışık kaynağına göre eser üzerindeki gölge/
   parlama yönü — fotoğrafta ışık sağdan geliyorsa gölge sola düşer.
   shadowX: -1 sola, 1 sağa, 0 düz aşağı düşen gölge yönü.
   glareDeg: cam parlaması gradyanının açısı (ışık kaynağının yönü). */
const ROOM_LIGHT = {
  cerceveyiasanlar: { shadowX: 1, glareDeg: 112 }, // soldaki ayaklı lambadan sıcak ışık, gölge sağa
  salon:    { shadowX: -1, glareDeg: 248 }, // sıcak lamba ışığı sağdan
  mutfak:   { shadowX:  1, glareDeg: 112 }, // lavabo üstü pencereden soldan gün ışığı
  banyo:    { shadowX:  0, glareDeg:  95 }, // mermer yüzeyden yansıyan, tepeden dengesiz ışık
  cocuk:    { shadowX:  1, glareDeg: 112 }, // pencereden yumuşak sol-üst gün ışığı
  sevimli:  { shadowX:  1, glareDeg: 112 }, // sıcak, yumuşak köşe ışığı
  romantik: { shadowX: -1, glareDeg: 250 }, // mum/lamba ışığı, samimi sağdan
  cicek:    { shadowX:  0, glareDeg: 100 }, // vitrin ışığı, dengeli/önden
  yilbasi:  { shadowX:  1, glareDeg: 115 }  // şömine/ışık dizisi sıcaklığı soldan
};

/* ============ SHOPIFY BAĞLANTISI ============
   Bu deneyim Shopify sayfası olarak barındırıldığında (aynı alan adı)
   sepete ekleme GERÇEK mağaza sepetine gider; dosya olarak açıldığında
   demo sepet çalışır ve ürün linkleri mağazaya yönlendirir.
   Ürünleri bağlamak için: her ürüne Shopify handle'ını yazın
   (örn. handle:'slow-down-you-re-doing-fine-sanatsal-motivasyon-poster-tablo') */
const SHOPIFY = {
  domain: 'sumerartdecoration.com',
  locale: ''  // İngilizce vitrin için '/en'
};
SHOPIFY.hosted = location.hostname.replace('www.','') === SHOPIFY.domain;
function shopUrl(path){ return 'https://' + SHOPIFY.domain + SHOPIFY.locale + path; }

/* "Kalan N Ürüne Ulaşın" sayısı sunucudan gelir: snippet, koleksiyonun
   toplam ürün sayısından duvarda gösterilenleri düşerek "remaining"
   üretir (bkz. roomRemaining). Ürün henüz Shopify'a girilmemişse
   FALLBACK'teki temsili sayı kullanılır. */
function remainingCount(room){ return room.extra; }

/* ============ ÜRÜN FİYATI (Shopify — en ucuz varyant) ============
   sumerartdecoration.com'da fiyatlar 13x18 çerçevesiz (en ucuz) varyanta
   göre gösteriliyor; bu deneyim de mağazada barındırıldığında aynı
   davranışı uygular: duvar etiketi ve modaldeki fiyat, ürünün YAYINDAKİ
   en ucuz (available) varyantından gelir. Dosya olarak açıldığında sabit
   price/old alanlarına düşer. /products/{handle}.js yanıtı handle başına
   bir kez çekilip cache'lenir — hem burada hem shopifyAdd()'de kullanılır. */
const productDataCache = {}; // handle -> Promise<productJson|null>
/* ════════ YORUM PUANI (Judge.me) ════════
   Turdaki ürün penceresi: ürünün yorumu varsa küçük yıldız + puan + "(X yorum)" ve ürün
   sayfasındaki yorumlara bağlantı. Yorum yoksa satır gizli kalır (boş yıldız / "0 yorum" yok).
   Kaynak: /products/<handle>?view=puan → {"puan":4.8,"adet":3} (templates/product.puan.liquid,
   snippets/sumer-yorum-veri). Handle başına önbellekli; başarısız sonuç önbellekte tutulmaz. */
const yorumPuaniOnbellek = {};
function yorumPuaniCek(handle){
  if(!yorumPuaniOnbellek[handle]){
    const istek = fetch(shopUrl('/products/' + handle + '?view=puan'), { headers: { Accept: 'application/json' } })
      .then(r => r.ok ? r.json() : null)
      .catch(() => null)
      .then(v => { if(!v && yorumPuaniOnbellek[handle] === istek) delete yorumPuaniOnbellek[handle]; return v; });
    yorumPuaniOnbellek[handle] = istek;
  }
  return yorumPuaniOnbellek[handle];
}
function yorumPuaniGoster(p){
  const el = document.getElementById('modalPuan');
  if(!el) return;
  el.hidden = true;
  if(!SHOPIFY.hosted || !p || !p.handle) return;
  yorumPuaniCek(p.handle).then(v => {
    if(modalProduct !== p || !v) return;
    const adet = Math.floor(Number(v.adet) || 0), puan = Number(v.puan) || 0;
    if(adet < 1 || puan <= 0) return;
    const puanYazi = puan.toLocaleString('tr-TR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    el.href = '/products/' + encodeURIComponent(p.handle) + '#judgeme_product_reviews';
    el.setAttribute('aria-label', '5 üzerinden ' + puanYazi + ' puan, ' + adet + ' yorum. Yorumları ürün sayfasında okuyun');
    el.innerHTML = '<span class="sumer-yildiz__yildizlar" style="--puan:' + Math.min(100, Math.round(puan * 20)) + '%" aria-hidden="true"></span>'
      + '<span class="sumer-yildiz__puan" aria-hidden="true">' + puanYazi + '</span>'
      + '<span class="sumer-yildiz__adet" aria-hidden="true">(' + adet + ' yorum)</span>';
    el.hidden = false;
  });
}
function fetchProductData(handle){
  if(!handle) return Promise.resolve(null);
  if(productDataCache[handle]) return productDataCache[handle];
  /* BAŞARISIZ sonuç önbellekte TUTULMAZ. Sayfa açılışında 54 ürünün verisi
     aynı anda çekiliyor; mobilde tek bir anlık kesinti (sekmenin arka plana
     atılması, ağ değişimi) eskiden null'u kalıcı önbelleğe alıyordu ve o
     ürün için "Sepete Ekle" sayfa yenilenene dek HER SEFERİNDE başarısız
     oluyordu, /cart/add.js hiç gönderilmeden. Artık bir sonraki çağrı yeniden dener. */
  const p = fetch(shopUrl('/products/' + handle + '.js'))
    .then(res => res.ok ? res.json() : null)
    .catch(() => null)
    .then(prod => { if(!prod && productDataCache[handle] === p) delete productDataCache[handle]; return prod; });
  productDataCache[handle] = p;
  return p;
}
/* SATIŞA KAPALI kombinasyonlar (tema ayarı "Satış kuralları" → window.SUMER_KAPALI, ör. "13x18 / Çerçevesiz"):
   tur penceresinde hiç gösterilmez, varsayılan/en ucuz seçime ve "…'den" fiyatına katılmaz.
   Sunucu tarafındaki karşılığı: snippets/sumer-satis-kurali.liquid. */
const KAPALI = (window.SUMER_KAPALI || []).map(k => normVariant(String(k).trim())).filter(Boolean);
function kapaliBaslik(t){ return KAPALI.includes(normVariant(String(t || '').trim())); }
function kapaliSecim(sizeIdx, frameIdx){ return kapaliBaslik(SIZES[sizeIdx].key + ' / ' + FRAMES[frameIdx]); }
function cheapestVariant(prod){
  if(!prod || !Array.isArray(prod.variants) || !prod.variants.length) return null;
  const available = prod.variants.filter(v=>v.available && !kapaliBaslik(v.title));
  const pool = available.length ? available : prod.variants;
  return pool.reduce((min,v)=> v.price < min.price ? v : min, pool[0]);
}

/* GA4 / Meta Pixel için olay katmanı */
window.dataLayer = window.dataLayer || [];
function track(ev, params){ try{ window.dataLayer.push(Object.assign({event: ev}, params||{})); }catch(e){} }

/* Meta ViewContent (tur penceresi): Meta Pixel, Shopify'ın "Facebook & Instagram" uygulamasının web pikseli
   olarak çalışır ve yalnız Shopify'ın STANDART olaylarını dinler (ürün sayfasında product_viewed →
   ViewContent). Standart olaylar temadan yayımlanamaz; bu yüzden pencere her açılışta TEK bir özel müşteri
   olayı yayımlar: "sumer_tur_urun_goruntulendi" (ürün/varyant kimliği, fiyat, para birimi). Admin → Ayarlar →
   Müşteri etkinlikleri'ndeki "Sümer tur ViewContent" özel pikseli bunu aynı Meta pikseline ViewContent olarak
   iletir (PageView göndermez). Olay, gerçek varyant verisi gelince (varsayılan seçimin varyantı ve fiyatıyla)
   bir kez gönderilir; veri alınamazsa eldeki bilgilerle yine bir kez. */
function turUrunGoruntulendi(p){
  if(!SHOPIFY.hosted || !p || !p.handle) return;
  let gonderildi = false;
  const gonder = (prod) => {
    if(gonderildi) return; gonderildi = true;
    let v = null;
    try{ v = (modalProduct === p && modalVariants) ? eslesenVaryant() : null; }catch(e){}
    if(!v && prod) v = cheapestVariant(prod);
    const fiyat = v ? birimFiyat(v.price) / 100 : (Number(p.price) || 0);
    try{
      if(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function'){
        window.Shopify.analytics.publish('sumer_tur_urun_goruntulendi', {
          product_id: prod && prod.id ? String(prod.id) : '',
          variant_id: v && v.id ? String(v.id) : '',
          handle: p.handle,
          name: p.name || '',
          price: Math.round(fiyat * 100) / 100,
          currency: 'TRY'
        });
      }
    }catch(e){}
  };
  /* fetchProductData handle başına önbellekli: pencerenin kendi isteğiyle aynı yanıt. setTimeout: pencerenin
     kendi .then'i (varsayılan seçimi kurar) önce çalışsın, olay o seçimin varyantını taşısın. */
  fetchProductData(p.handle).then(prod => setTimeout(() => gonder(prod), 0), () => gonder(null));
}

/* ============ SHOPIFY ÜRÜN VERİSİ ============
   Ürünler artık sabit değil: her oda kendi Shopify koleksiyonundan
   "vitrin-{oda}" etiketli en fazla 6 ürünü çeker. Veriyi sayfa render'ında
   Liquid yazıyor (bkz. snippets/immersive-tour-room-products.liquid ->
   #sumer-product-data). "Kalan N Ürüne Ulaşın" sayısı da aynı yerde
   (koleksiyondaki TOPLAM ürün - vitrin edilen) hesaplanıyor. Koleksiyon
   veya etiket yoksa ilgili oda boş dizi/0 alır; sayfa hata vermez. */
const PRODUCT_DATA = (() => {
  const el = document.getElementById('sumer-product-data');
  if(!el) return {};
  try{ return JSON.parse(el.textContent) || {}; }catch(e){ return {}; }
})();
function roomProducts(id){ return (PRODUCT_DATA[id] && PRODUCT_DATA[id].items) || []; }
function roomRemaining(id){
  const v = PRODUCT_DATA[id] && PRODUCT_DATA[id].remaining;
  if(v) return v;
  /* gerçek ürün yoksa temsili "kalan" sayısı */
  return (roomProducts(id).length === 0 && FALLBACK[id]) ? FALLBACK[id].extra : 0;
}
function roomCollection(id){ return (PRODUCT_DATA[id] && PRODUCT_DATA[id].collection) || ''; }

/* ════════ KOLEKSİYONUN KALAN ÜRÜNLERİ ════════
   "Kalan N ürüne ulaşın" ekranı, odanın koleksiyonundaki ürünlerden
   duvarda gösterilmeyenleri (vitrin-{oda} etiketi olmayanları) gösterir.
   Sayfa yükünde taşınmaz; ekran ilk açıldığında bir kez çekilip
   cache'lenir. */
const collectionProductCache = {};
function fetchCollectionProducts(handle){
  if(collectionProductCache[handle]) return collectionProductCache[handle];
  collectionProductCache[handle] = (async ()=>{
    try{
      const res = await fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250');
      if(!res.ok) return null;
      const d = await res.json();
      return Array.isArray(d.products) ? d.products : null;
    }catch(err){ return null; }
  })();
  return collectionProductCache[handle];
}
/* /collections/{handle}/products.json fiyatları BİRİM olarak metin verir
   ("174.99"); /products/{handle}.js ise KURUŞ verir (17499). İkisi
   karıştırılırsa fiyat 100 kat şaşar. */
function birimFiyat(v){ const n = parseFloat(v); return isFinite(n) ? n : 0; }
function ucuzVaryant(p){
  const vs = (p.variants || []).filter(v=>v.available && !kapaliBaslik(v.title));
  const liste = vs.length ? vs : (p.variants || []);
  return liste.reduce((en,v)=> (!en || birimFiyat(v.price) < birimFiyat(en.price)) ? v : en, null);
}
/* Varyant başlığından ("21x30 / Çerçevesiz") pencere seçim indeksleri {s, f}; bulunamazsa null */
function secimIndeksi(baslik){
  const t = normVariant(baslik);
  const s = SIZES.findIndex(sz => t.includes(normVariant(sz.key)));
  const f = FRAME_KEYS.findIndex(k => (FRAME_ALIASES[k] || []).some(a => t.includes(normVariant(a))));
  return (s >= 0 && f >= 0) ? { s, f } : null;
}
/* Varsayılan seçim: kapalı olmayan satılabilir varyantların en ucuzu (eşitlikte varyant sırası) */
function varsayilanSecim(variants){
  const v = (variants || []).filter(x => x.available && !kapaliBaslik(x.title))
    .reduce((en, x) => (!en || birimFiyat(x.price) < birimFiyat(en.price)) ? x : en, null);
  return v ? secimIndeksi(v.title) : null;
}
/* Duvar sahnemize uygun ham görsel (alt text "vitrin-duvar") varsa o
   kullanılır ve raw işaretlenir; yoksa ürünün kendi mockup görseli. */
function urunGorseli(p){
  const duvar = (p.images || []).find(im => (im.alt || '').trim() === 'vitrin-duvar');
  if(duvar) return { src: duvar.src, raw: true };
  const ilk = (p.images && p.images[0]) ? p.images[0].src : '';
  return { src: ilk, raw: false };
}
const KISA_AD = {
  'yasemin-cicegi-palet-bicagi-efektli-poster-tablo': 'Yasemin Çiçeği',
  'good-things-take-time-motivasyonel-yagliboya-poster-tablo': 'Good Things Take Time',
  'keep-your-mind-a-happy-place-motivasyonel-botanik-poster-tablo': 'Keep Your Mind A Happy Place',
  'slow-down-you-re-doing-fine-sanatsal-motivasyon-poster-tablo': 'Slow Down You\'re Doing Fine',
  'dont-be-too-hard-on-yourself-bahce-manzara-poster-tablo': 'Don\'t Be Too Hard On Yourself',
  'you-make-the-world-a-bright-place-sanatsal-mum-isigi-poster-tablo': 'Mum Işığı',
  'more-espresso-less-depresso-portafiltre-temali-poster-tablo': 'More Espresso Less Depresso',
  'have-a-cup-of-positivi-tea-sanatsal-kedi-ve-cay-poster-tablo': 'Have A Cup Of Positivi-Tea',
  'the-only-pain-i-want-is-pain-au-chocolat-esprili-mutfak-poster-tablo': 'Pain Au Chocolat',
  'my-coffee-is-strong-and-so-am-i-kahve-kosesi-poster-tablo': 'My Coffee Is Strong',
  'life-happens-coffee-helps-kahve-kosesi-modern-poster-tablo': 'Life Happens, Coffee Helps',
  'coffee-and-friend-is-the-perfect-blend-sanatsal-kahve-poster-tablo': 'Coffee And Friend',
  'tuvalette-gazete-okuyan-zurafa-esprili-banyo-poster-tablo': 'Gazete Okuyan Zürafa',
  'let-it-snow-komik-kedi-banyo-tablosu': 'Let It Snow',
  'dont-waste-water-esprili-ordek-banyo-poster-tablo': 'Don\'t Waste Water',
  'tuvalette-telefonla-oynayan-kedi-esprili-banyo-poster-tablo': 'Telefondaki Kedi',
  'the-best-seat-in-the-house-esprili-banyo-poster-tablo': 'The Best Seat In The House',
  'wash-your-paws-siyah-kedili-banyo-poster-tablo': 'Wash Your Paws',
  'peri-kizi-ve-sihirli-sato-2li-cocuk-odasi-tablo-seti': 'Peri Kızı ve Şato (2\'li)',
  'lunapark-cocuk-ve-bebek-odasi-2li-dekoratif-tablo-seti': 'Lunapark (2\'li)',
  'born-together-friends-forever-ikiz-bebek-cocuk-odasi-tablo': 'Born Together',
  'here-comes-the-sun-little-darling-kisisellestirilmis-cocuk-odasi-poster-tablo': 'Here Comes The Sun',
  'welcome-to-the-world-little-one-leylek-temali-bebek-odasi-poster-tablo': 'Welcome To The World',
  'every-child-is-an-artist-sanatsal-2-li-poster-tablo-seti': 'Küçük Ressam (2\'li)',
  'wake-me-up-when-im-rich-esprili-ordek-para-poster-tablo': 'Wake Me Up When I\'m Rich',
  'seself-love-club-ordekli-dekoratif-poster-self-love-club-ordekli-dekoratif-poster-tablo-love-club-ordek-motivasyon-tablo': 'Self Love Club',
  'i-am-money-magnet-ordek-figurlu-manifest-poster-tablo': 'I Am Money Magnet',
  'i-am-the-boss-esprili-sari-kedi-poster-tablo': 'I Am The Boss',
  'cat-hair-is-just-part-of-the-decor-esprili-kedi-poster-tablo': 'Cat Hair Is Part Of The Decor',
  'all-guests-must-be-approved-by-the-cat-esprili-kedi-poster-tablo': 'Approved By The Cat',
  'love-is-kisisellestirilmis-isimli-ask-ve-yil-donumu-tablosu': 'Love Is… Yıl Dönümü',
  'soul-mate-kisisellestirilmis-isimli-minimalist-cizgi-sanat-tablosu': 'Soul Mate',
  'love-is-kisisellestirilmis-kutlama-temali-isimli-poster-tablo': 'Love Is… Kutlama',
  'love-is-kisisellestirilmis-kedili-isimli-poster-tablo': 'Love Is… Kedili',
  'love-is-kisisellestirilmis-kamp-temali-isimli-poster-tablo': 'Love Is… Kamp',
  'love-is-kisisellestirilmis-bebek-aile-temali-isimli-poster-tablo': 'Love Is… Bebek & Aile',
  'ocak-ayi-dogum-cicegi-carnation-karanfil-sanatsal-poster-tablo': 'Ocak · Karanfil',
  'subat-ayi-dogum-cicegi-iris-sanatsal-poster-tablo': 'Şubat · İris',
  'mart-ayi-dogum-cicegi-cherry-blossom-kiraz-cicegi-sanatsal-poster-tablo': 'Mart · Kiraz Çiçeği',
  'nisan-ayi-dogum-cicegi-daisy-papatya-sanatsal-poster-tablo': 'Nisan · Papatya',
  'mayis-ayi-dogum-cicegi-lily-zambak-sanatsal-poster-tablo': 'Mayıs · Zambak',
  'haziran-ayi-dogum-cicegi-rose-gul-sanatsal-poster-tablo': 'Haziran · Gül',
  'isiltili-yilbasi-agaci-yagli-boya-poster-tablo': 'Işıltılı Yılbaşı Ağacı',
  'klasik-yilbasi-cami-ve-hediyeler-sanatsal-poster-tablo': 'Pencerede Yılbaşı',
  'noel-baba-ve-geyigi-suluboya-poster-tablo': 'Noel Baba ve Geyiği',
  'suluboya-kar-kuresi-yilbasi-poster-tablo': 'Kar Küresi',
  'the-most-wonderful-time-of-the-year-yilbasi-agaci-poster-tablo': 'The Most Wonderful Time',
  'jingle-all-the-way-suluboya-canli-yilbasi-poster-tablo': 'Jingle All The Way'
};
/* Duvar etiketinde ve kartlarda gösterilen KISA ad. Mağaza başlıkları arama
   için uzun (ör. "\"Wake Me Up When I'm Rich\" Yazılı Zengin Ördek Mizah
   Posteri - Motivasyon/Genç Odası Dekoru") ve etikette "…" ile kesiliyordu.
   Önce elle yazılmış ad (KISA_AD), yoksa: tırnak içindeki söz, o da yoksa
   " - " öncesi. Pencere/sepet/ödeme yine tam adı kullanır. */
function kisaAd(handle, ad){
  if(handle && KISA_AD[handle]) return KISA_AD[handle];
  const t = String(ad || '').trim();
  const tirnak = t.match(/^["“”']([^"“”']{2,60})["“”']/);
  if(tirnak) return tirnak[1].trim();
  const parca = t.split(' - ')[0].trim();
  return parca || t;
}
/* HTML özniteliğine güvenli yazım: tırnakla başlayan adlar aria-label/alt
   değerini bozuyordu (ekran okuyucu boş etiket okuyordu). */
function attr(v){ return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
function koleksiyonKarti(p, catAd){
  const v = ucuzVaryant(p);
  const fiyat = v ? birimFiyat(v.price) : 0;
  const eski = v && v.compare_at_price ? birimFiyat(v.compare_at_price) : 0;
  const g = urunGorseli(p);
  return { name: p.title, kisa: kisaAd(p.handle, p.title), price: fiyat, old: eski > fiyat ? eski : 0,
           handle: p.handle, src: g.src, raw: g.raw, cat: catAd, story: '', vsec: v ? secimIndeksi(v.title) : null };
}

/* Bazı odalarda tüm eserler aynı çerçeveyle asılı — üründen bağımsız,
   odanın tonuna göre alınmış bir vitrin kararı. */
const ROOM_FRAME_STYLE = { cerceveyiasanlar:'black', salon:'black', romantik:'black' };

/* "Çerçeveyi Aşan" serisinin çerçeveden taşan parçaları Shopify ürün
   verisinden GELEMEZ: bunlar posterden ayrı, her esere elle konumlanmış
   kesit katmanları. Bu yüzden temada kalıyor ve ürün BAŞLIĞIYLA eşleniyor —
   Shopify'daki ürün başlığı buradaki anahtarla birebir aynı olmalı, yoksa
   eser taşan parçası olmadan (düz poster olarak) görünür. */

/* ============ TEMSİLİ (YEDEK) ÜRÜNLER ============
   Bir odanın Shopify koleksiyonu/etiketi henüz kurulmamışsa oda boş
   kalmasın diye buradaki temsili ürünler gösterilir. Gerçek ürünler
   eklendiği anda (koleksiyon + "vitrin-{oda}" etiketi) otomatik olarak
   onlar geçerli olur; burası bir daha devreye girmez.
   Temsili ürünlerin handle'ı YOKTUR: sepete ekleme mağaza sepetine
   gitmez, yalnız sayfa içi demo sepete düşer (bkz. shopifyAdd). */
const FALLBACK = {
  cerceveyiasanlar: {extra:6, items:[
    {name:'Bırakma', price:189.99, old:269.99, img:ASSETS.urunBirakma || '', handle:'', story:''},
    {name:'Zirve', price:174.99, old:244.99, img:ASSETS.urunZirve || '', handle:'', story:''},
    {name:'Pati', price:199.99, old:279.99, img:ASSETS.urunPati || '', handle:'', story:''},
    {name:'İlk Uçuş', price:182.99, old:256.99, img:ASSETS.urunIlkUcus || '', handle:'', story:''},
    {name:'Uzanış', price:188.99, old:264.99, img:ASSETS.urunUzanis || '', handle:'', story:''},
    {name:'Filiz', price:196.99, old:275.99, img:ASSETS.urunFiliz || '', handle:'', story:''}
  ]},
  salon: {extra:24, items:[
    {name:'Dinginlik', price:159.99, old:224.99, img:'', handle:'', story:'Sadelik, en derin lüks biçimidir.'},
    {name:'Katmanlar', price:164.99, old:231.99, img:'', handle:'', story:'Her katman, farklı bir anlatı taşır.'},
    {name:'Sessiz Ritim', price:157.99, old:221.99, img:'', handle:'', story:'Bazı hareketler, sessizce büyür.'},
    {name:'Ufuk Çizgisi', price:162.99, old:228.99, img:'', handle:'', story:'Bakış nereye giderse, huzur oraya gider.'},
    {name:'Gölge Oyunu', price:155.99, old:218.99, img:'', handle:'', story:'Işık ve gölge, aynı hikayenin iki yüzü.'},
    {name:'Denge', price:167.99, old:235.99, img:'', handle:'', story:'Kaos içindeki düzen, en gerçek olandır.'}
  ]},
  mutfak: {extra:10, items:[
    {name:'Sabah Kahvesi', price:147.99, old:207.99, img:'', handle:'', story:''},
    {name:'Espresso Ritüeli', price:153.99, old:215.99, img:'', handle:'', story:''},
    {name:'Fesleğen Dalı', price:143.99, old:201.99, img:'', handle:'', story:''},
    {name:'Kahve Köşesi', price:157.99, old:221.99, img:'', handle:'', story:''},
    {name:'Zeytin & Ekmek', price:149.99, old:209.99, img:'', handle:'', story:''},
    {name:'Buharlı Fincan', price:151.99, old:212.99, img:'', handle:'', story:''}
  ]},
  banyo: {extra:10, items:[
    {name:'Sade Kavisler', price:137.99, old:193.99, img:'', handle:'', story:''},
    {name:'Okaliptüs', price:141.99, old:198.99, img:'', handle:'', story:''},
    {name:'Sabun & Su', price:135.99, old:190.99, img:'', handle:'', story:''},
    {name:'Minimal Dalga', price:143.99, old:201.99, img:'', handle:'', story:''},
    {name:'Taş Denge', price:145.99, old:204.99, img:'', handle:'', story:''},
    {name:'Beyaz Sessizlik', price:139.99, old:195.99, img:'', handle:'', story:''}
  ]},
  cocuk: {extra:24, items:[
    {name:'Gökkuşağı Dostlar', price:129.99, old:181.99, img:'', handle:'', story:''},
    {name:'Uykucu Ay', price:133.99, old:187.99, img:'', handle:'', story:''},
    {name:'Balonlu Fil', price:137.99, old:193.99, img:'', handle:'', story:''},
    {name:'Güneşli Gün', price:131.99, old:184.99, img:'', handle:'', story:''},
    {name:'Yıldız Tozu', price:135.99, old:190.99, img:'', handle:'', story:''},
    {name:'Sevimli Tavşan', price:133.99, old:187.99, img:'', handle:'', story:''}
  ]},
  sevimli: {extra:16, items:[
    {name:'Sadakat Anı', price:145.99, old:204.99, img:'', handle:'', story:'Bir bakış, bin kelimeye bedeldir.'},
    {name:'Kuyruk Sallayan Mutluluk', price:149.99, old:209.99, img:'', handle:'', story:'En içten selam, dört ayak üstünde gelir.'},
    {name:'Uykuya Dalan Patiler', price:141.99, old:198.99, img:'', handle:'', story:'Güven, derin bir uykuda saklıdır.'},
    {name:'Meraklı Burun', price:153.99, old:215.99, img:'', handle:'', story:'Her koku, yeni bir hikayenin başlangıcıdır.'},
    {name:'Sadık Bekleyiş', price:147.99, old:207.99, img:'', handle:'', story:'Beklemek, sevginin sessiz hali.'},
    {name:'Oyun Zamanı', price:143.99, old:201.99, img:'', handle:'', story:'Neşe, öğretilmez; sadece hatırlanır.'}
  ]},
  romantik: {extra:20, items:[
    {name:'İki Kalp', price:169.99, old:238.99, img:'', handle:'', story:'Bazı hikayeler, tek bakışta başlar.'},
    {name:'El Ele', price:174.99, old:244.99, img:'', handle:'', story:'Yol uzun olsun, yeter ki beraber olsun.'},
    {name:'Sessiz Söz', price:165.99, old:232.99, img:'', handle:'', story:'Aşk, bazen hiç konuşmadan anlaşılır.'},
    {name:'Öpücük', price:179.99, old:252.99, img:'', handle:'', story:'En kısa mesafe, iki dudak arasındadır.'},
    {name:'Sonsuz An', price:171.99, old:241.99, img:'', handle:'', story:'Zaman durur, sevgi devam eder.'},
    {name:'Biz', price:167.99, old:235.99, img:'', handle:'', story:'Birlikte, her şey biraz daha hafif.'}
  ]},
  cicek: {extra:14, items:[
    {name:'Ocak: Kardelen', price:131.99, old:184.99, img:'', handle:'', story:'Kışın ortasında açan cesaret.'},
    {name:'Nisan: Papatya', price:135.99, old:190.99, img:'', handle:'', story:'Sadelik, en büyük zerafettir.'},
    {name:'Haziran: Gül', price:129.99, old:181.99, img:'', handle:'', story:'Her taç yaprağı bir anıyı saklar.'},
    {name:'Ağustos: Gladyolus', price:139.99, old:195.99, img:'', handle:'', story:'Güçlü duruş, en çok çiçekte anlaşılır.'},
    {name:'Ekim: Kadife Çiçeği', price:133.99, old:187.99, img:'', handle:'', story:'Sıcaklık, bazen turuncudan doğar.'},
    {name:'Aralık: Karanfil', price:137.99, old:193.99, img:'', handle:'', story:'Kış bile, bir demet sevgiyle ısınır.'}
  ]},
  yilbasi: {extra:18, items:[
    {name:'İlk Kar', price:151.99, old:212.99, img:'', handle:'', story:'Her tanesi, yılın son masalı.'},
    {name:'Sıcak Kakao', price:155.99, old:218.99, img:'', handle:'', story:'Kış, bir bardak sıcaklıkla güzelleşir.'},
    {name:'Şenlikli Işıklar', price:149.99, old:209.99, img:'', handle:'', story:'Karanlık, birlikte parlayınca kısalır.'},
    {name:'Aile Sofrası', price:159.99, old:223.99, img:'', handle:'', story:'Yılın en güzel toplantısı, en sade sofrada.'},
    {name:'Yıldızlı Gece', price:153.99, old:215.99, img:'', handle:'', story:'Dilekler, en çok aralıkta gökyüzüne yakın.'},
    {name:'Yeni Yıl', price:157.99, old:220.99, img:'', handle:'', story:'Her son, sıcak bir başlangıcı saklar.'}
  ]}
};

/* bleed: taşan katmanın posterin ÜZERİNE binen payı — kendi ölçüsünün yüzdesi
   (üsttekilerde yüksekliğin, sağdakilerde genişliğin). Her sticker dosyasının
   alt/sol kenarında posterin ilk satırlarını tekrar eden bir şerit var; bu
   şerit posterin üzerine tam oturunca dikiş görünmez.
   Neden yüzde: eskiden CSS'te sabit 11px'ti. Sticker ekranda kendi kaynak
   çözünürlüğünün ~%25-45'i kadar çiziliyor, yani 11px'lik şerit ekranda
   4-5px'e iniyordu ama katman yine 11px aşağı itiliyordu. Fark, posterin
   üstüne koyu bir bant olarak biniyordu (Bırakma'da en belirgin haliyle).
   Zirve'nin sticker'ı yok: dosyadaki 155.800 pikselin yalnız 3.056'sı doluydu
   ve hepsi alt şeritti — zirve tepesi hiç çizilmemişti. Boş katman yerine
   düz poster gösteriliyor; dosya yenilenince satır geri eklenecek. */
/* ============ KAÇIŞ YOLU: MODALDE SADECE MOCKUP ============
   Bazı ürünlerde poster+sticker kompoziti modalin BÜYÜK görsel alanında
   düzgün oturmuyor (Patiler/Dokunuş: sticker saf mürekkep + çizim çerçeve
   kenarında birleşiyor; birkaç turluk denemeye rağmen temiz sonuç alınamadı).
   Bu ürünlerde modalde taşan katman HİÇ kurulmaz, yalnız düz poster gösterilir.
   Koleksiyon grid'i ve küçük resimler etkilenmez — orada kompozit doğru duruyor.

   Kullanım: Shopify'da ürüne "vitrin-sadece-mockup" ETİKETİ ekle, yeter.
   Aşağıdaki handle listesi yalnızca etiket eklenene kadarki tohum; etiketler
   girildikten sonra boşaltılabilir. */
const SADECE_MOCKUP_ETIKET = 'vitrin-sadece-mockup';
const SADECE_MOCKUP_HANDLE = ['patiler', 'dokunus'];
function sadeceMockupMu(p){
  if(!p) return false;
  if(p.sadeceMockup) return true;                       // Liquid/ürün etiketinden
  return SADECE_MOCKUP_HANDLE.indexOf(p.handle) >= 0;   // geçici tohum
}
/* ============ TAŞAN PARÇA (STICKER) YERLEŞİMİ ============
   Kaynak: ürünün galerisinde alt text'i "vitrin-sticker" olan görsel
   (Liquid tarafında bulunup "sticker" alanıyla geliyor). Bu görsel posterle
   AYNI kanvasa 1:1 kayıtlı, tam boy şeffaf PNG'dir; taşan çizim kanvasın
   ilgili kenarında durur.

   Konum/yön/ölçü ARTIK KODA YAZILMIYOR. Katman posterin tam üstüne
   (inset:0, %100×%100) serilir, sonra görselin şeffaflık sınır kutusu
   ölçülüp taşma yönü (içeriğin en yakın olduğu kenar) ve dışarı kaydırma
   miktarı hesaplanır. Örnek ölçüm: Bırakma içerik alt sınırı %13,3 → katman
   %13,3 yukarı kaydırılır ve balonun üstü çerçeveyi aşar; İz içerik üst
   sınırı %68,5 → %31,5 aşağı kaydırılır, damla aşağı sarkar.
   Böylece yeni ürün eklemek için yalnız doğru alt text'le görsel yüklemek
   yeterli; ürün başına kod/liste gerekmez. */
const stickerGeoCache = new Map();
function stickerGeo(url){
  if(stickerGeoCache.has(url)) return stickerGeoCache.get(url);
  const p = new Promise(res=>{
    const img = new Image();
    img.crossOrigin = 'anonymous';   // CDN CORS gönderiyor; canvas okunabilsin
    img.onload = ()=>{
      try{
        const W = 200, H = Math.max(1, Math.round(200 * img.naturalHeight / img.naturalWidth));
        const c = document.createElement('canvas'); c.width = W; c.height = H;
        const cx = c.getContext('2d', {willReadFrequently:true});
        cx.drawImage(img, 0, 0, W, H);
        const d = cx.getImageData(0, 0, W, H).data;
        let minX = W, maxX = -1, minY = H, maxY = -1, renkTop = 0, renkAdet = 0;
        for(let y = 0; y < H; y++) for(let x = 0; x < W; x++){
          const a = d[(y*W + x)*4 + 3];
          if(a > 25){
            if(x < minX) minX = x; if(x > maxX) maxX = x;
            if(y < minY) minY = y; if(y > maxY) maxY = y;
          }
          /* Dolu bölgenin rengi: sticker KAĞIT içeriyor mu, yoksa yalnız
             MÜREKKEP mi? (bkz. kagitAltlikEkle çağrısı) */
          if(a >= 80 && a <= 200){
            renkTop += d[(y*W + x)*4] + d[(y*W + x)*4 + 1] + d[(y*W + x)*4 + 2];
            renkAdet += 3;
          }
        }
        if(maxX < 0) return res(null);                    // tamamen şeffaf: kullanılamaz
        const sol = minX/W, sag = (maxX+1)/W, ust = minY/H, alt = (maxY+1)/H;
        /* Taşma yönü = içeriğin en yakın olduğu kenar */
        const bosluk = {ust: ust, alt: 1-alt, sol: sol, sag: 1-sag};
        let yon = 'ust', enAz = Infinity;
        for(const k in bosluk){ if(bosluk[k] < enAz){ enAz = bosluk[k]; yon = k; } }
        /* Dışarı kaydırma; 1px geri çekme dikişte saç teli boşluk bırakmaz */
        let dx = '0px', dy = '0px';
        let pay = 0;   // taşmanın posterin kendi ölçüsüne oranı (yer ayırmak için)
        if(yon === 'ust')      { pay = alt;   dy = `calc(${(-alt*100).toFixed(2)}% + 1px)`; }
        else if(yon === 'alt') { pay = 1-ust; dy = `calc(${((1-ust)*100).toFixed(2)}% - 1px)`; }
        else if(yon === 'sag') { pay = 1-sol; dx = `calc(${((1-sol)*100).toFixed(2)}% - 1px)`; }
        else                   { pay = sag;   dx = `calc(${(-sag*100).toFixed(2)}% + 1px)`; }
        /* murekkepSade: dolu bolgenin ortalama parlakligi cok koyuysa sticker
           yalniz murekkep demektir (kagit yok). Bu durumda kagit altligi
           siluet degil, kalem darbelerinin sekli olur ve cizim cevresinde
           yapay bir hale birakir — o yuzden uygulanmaz. Olcum: Sabah Molasi
           (132,130,126) kagitli; Pati (5,2,2), Uzanis (3,2,2) murekkep-only. */
        const ortRenk = renkAdet ? renkTop / renkAdet : 255;
        res({dx, dy, yon, pay, sol, sag, ust, alt, murekkepSade: ortRenk < 60});
      }catch(err){ res(null); }                            // CORS vb.: ölçülemedi
    };
    img.onerror = ()=>res(null);
    /* 1200 px PNG'yi ana iş parçacığında çözmek açılışta ~1 sn işlemci yiyordu
       (ölçüldü). 600 px'lik kopya: 6 taşan parçanın 6'sında 1200 px ile BİREBİR
       aynı sınırları veriyor (240/400/800 px bazılarında 1 piksel kaydırıyordu —
       dikiş yeri bozulurdu). */
    img.src = cdnGenislik(url, 600);
  });
  stickerGeoCache.set(url, p);
  return p;
}
/* Posterin ilgili kenarındaki kağıt rengini örnekler — taşan parçanın
   çerçeve üzerine binen kağıt şeridi bu tonu alır ki ek yeri belli olmasın. */
const kenarRenkCache = new Map();
function posterKenarRengi(img, yon){
  const url = img && img.getAttribute('src');
  if(!url) return Promise.resolve(null);
  const anahtar = url + '|' + yon;
  if(kenarRenkCache.has(anahtar)) return kenarRenkCache.get(anahtar);
  const p = new Promise(res=>{
    const im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = ()=>{
      try{
        const W = 120, H = Math.max(1, Math.round(120 * im.naturalHeight / im.naturalWidth));
        const c = document.createElement('canvas'); c.width = W; c.height = H;
        const cx = c.getContext('2d', {willReadFrequently:true});
        cx.drawImage(im, 0, 0, W, H);
        const s = 3;   // en dış 3 piksellik şerit
        const kutu = yon === 'ust' ? [0,0,W,s] : yon === 'alt' ? [0,H-s,W,s]
                   : yon === 'sag' ? [W-s,0,s,H] : [0,0,s,H];
        const d = cx.getImageData(kutu[0], kutu[1], kutu[2], kutu[3]).data;
        let r=0, g=0, b=0, n=0;
        for(let i=0; i<d.length; i+=4){ r+=d[i]; g+=d[i+1]; b+=d[i+2]; n++; }
        res(n ? `rgb(${Math.round(r/n)},${Math.round(g/n)},${Math.round(b/n)})` : null);
      }catch(err){ res(null); }
    };
    im.onerror = ()=>res(null);
    im.src = cdnGenislik(url, 600);   // 1200 px yerine 600 px kopya (bkz. stickerGeo notu)
  });
  kenarRenkCache.set(anahtar, p);
  return p;
}
/* KAĞIT ALTLIĞI — taşan parça çerçeve kenarını geçerken kaybolmasın.
   Ölçüm: sticker PNG'leri saf SİYAH mürekkep + alfa olarak kaydedilmiş
   (Pati/Uzanış'ta RGB her alfa aralığında ~0). Açık zeminde kalem grisi gibi
   görünüyor ama SİYAH çerçeve şeridinin üstünde hiçbir alfada görünmüyor;
   çizgi tam orada kopuyordu (ince parmak/pençede belirgin, geniş dağ/balonda
   değil).
   Çözüm: sticker'ın KENDİ SİLUETİNDE opak bir kağıt altlığı. Dikdörtgen bir
   şerit denenmişti — çerçeveyi siliyor ve yapay düz kenar bırakıyordu; bu
   yüzden siluet maskesi kullanılıyor: kağıt yalnız çizimin olduğu yerde var,
   çerçevenin geri kalanı görünür kalıyor.
   Alfa yükseltme: maskelenmiş katman yarı saydam kalırdı; dıştaki
   filter:opacity(6) alfayı çarparak opaklaştırır (filtre maskeden SONRA
   uygulanabilsin diye iç içe iki eleman). Kağıt rengi posterin kendi
   kenarından örneklenir. */
/* Mürekkep-only sticker'da varsa eski kağıt altlığını temizle. */
function kagitAltligiKaldir(el){
  const kap = el && el.parentElement; if(!kap) return;
  const a = kap.querySelector('.art-overflow-kagit'); if(a) a.remove();
}
function kagitAltlikEkle(el, g){
  const kap = el.parentElement; if(!kap) return;
  const src = el.getAttribute('src'); if(!src) return;
  const KAT = 5;   // üst üste yığılan maskeli katman sayısı (aşağıdaki nota bak)
  let alt = kap.querySelector('.art-overflow-kagit');
  if(!alt){
    alt = document.createElement('span');
    alt.className = 'art-overflow-kagit';
    for(let k = 0; k < KAT; k++) alt.appendChild(document.createElement('i'));
    kap.insertBefore(alt, el);
  }
  alt.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;' +
    'z-index:4;pointer-events:none;transform:' + el.style.transform;
  /* Alfa yükseltmeyi filter:opacity() ile yapmayı denedim; CSS bu filtreyi
     0-1 arasına KIRPIYOR (ölçüm: opacity(6) -> computed "opacity(1)"), yani
     hiç etki etmiyordu. Bunun yerine aynı maskeli katman üst üste yığılıyor:
     n katmanda etkin opaklık 1-(1-a)^n olur; a=0,5 ve n=5 için %97. Yumuşak
     dış kenarlar (düşük alfa) kısmen saydam kalır — istenen de bu. */
  const mask = 'url("' + src + '")';
  const temel = 'position:absolute;inset:0;display:block;background:#e9e5dc;' +
    '-webkit-mask-image:' + mask + ';mask-image:' + mask + ';' +
    '-webkit-mask-size:100% 100%;mask-size:100% 100%;' +
    '-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat';
  const katmanlar = alt.querySelectorAll('i');
  katmanlar.forEach(ic=>{ ic.style.cssText = temel; });
  posterKenarRengi(kap.querySelector('.art-img, .card-img'), g.yon)
    .then(renk=>{ if(renk) katmanlar.forEach(ic=>{ ic.style.background = renk; }); });
}
const CA_V3 = {
  'zirve': { kazanc: 1, duvar: 1, kesik: 0.1515, serit: 0.05, maske: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAAoCAYAAAAi24Q0AAAEl0lEQVR42u3dz6tUZRjA8e/MnbmCGZpKaLi8VKBQmm6iEK8QgRSB5KVNi/6CEoKCov4GcVO0UBeJpu36QVIXREmwH0QLc1MtdCG5atV1Zs5p8T4HT2NE3pkzd86Z7wde5uryzHnP+8zzPu9zQFLddYAW8CqQA734dNRz9OPzfHy3HW9xqX7aXgKp9oqFeaeXolHP5eeA+Qi4Wl4WqV7mvARSIxbjR4ATsSC3XZBrrQUMgHXAAvBF/FuSGSxJE5zDGXAUeDAWYoOrZvz4zYElUmZy4A9iSZImtwi3gP3AX6StpMwapsaMQXynV4EtZiYltwglMdHs1QfAY/G3c5pGbRVmwA5gA/AZqeA989JI9ZjAkuq7vb8VuAZsivnsnG6efgRWi8ByBNHWZEnWYEmqMLtxHNhM2lIyuGrud50D73opJEmi8q39l4f6Jjma3xvrecs7JMxgSaosm7GelL3KzFw1XhbP6p+A66XaO0kGWJIYX9f2jLRd9HAEW87j5gdYLeAS8Ft837mXRTLAksTYtgZ7wF7gLVKhs3PY57YkJ6qkEYKrDNgDfF5qKOr24Gw8p3PgWVI/rDvWYEnYpkHS2BbYeeB3YFupLkfMVB3Wj6R3FN62XYNkBkvSeH4EnYrgqu/cnclndR/YDVwgZbIMriRJWmVw1SUVtp/FlgyOVIOXA9+RXgS90a1iSZJYVb+rj2JRXTHAcJSCrBvA45HdMqMpSdJ9BFdLpK2gO/giZ0e6FwbAL8BTWOohYQ2WpPstat8GnCRt/3TcBlKp79k14Ht7YkkGWJL433VXRUuGd4B13G3JIBX3xkvAuQi8294f0vRuQ0hiajq194H3gTcjuOp4WTQUhPeAXcCfwOVSh39JkjS0aBaB1Hv8s5jZ4RgeWdwfKxFotf3BLEkS/5q5gpS5KoIri9od/zWKlh2n497pOo0kSTJz5Rg9i1WcMN07FKhLkjTTwVXbzJWD0ds2/EHq8m6QJUnCAyYpwDJz5Rg1yMpJ7yd8ErcLJUnMdr3VVuCKmSsH46vHMpMlSWIWtwSLfkUHgB/MXDkqCLJuA6+UMqX2yJKwD5bU5OAqj8/XgE+B7djnSoy1cXQGPAAcjnttOe4vu71LBlhSY7uzd4GPgbcjsHIOqqpAvg8sxv8tl161ZKAlGWBJjdGNBe8N4HXSsfqOr6pSxadTBxFktYBvIriaM8iSDLCkpsyxPnAI+JC0hdO1LkYTDLIOAE8DN4Fffa2ONLlJKKnarcFNwLfAQixsZq40SYPSj+kjwCfAPCmTKolqj4tLqmZ+9Ug1Vwvxt/2JxBplUdvAmQj8z5YCfbNZkluEUu0Wtd3AsQi2PDIv1vCEYeEwsAH4ilSP5ZahZIAl1eq4/AJwEXhoqAeWxBqXhDxD6vr+M3Ar1oK2BfCSAZY07fNqDjgBPEHKZDnXNE3NbnvATmAJWOHuGwVaBlqSJKa4rnHJLu0O6tH5PQe+BA56AEqSNM1H43cA12MBG7iQO6Z4ZEOB1tfAPu6t25LE6gsfJTHy1mAGvAA8GguWc0x1aCUyiHt3EbgAvFhqTCppFf4GAJXNJTlypPMAAAAASUVORK5CYII=' },
  'birakma': { kazanc: 0.9, duvar: 0.9, kesik: 0.133, serit: 0.05, maske: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAAoCAYAAAAi24Q0AAADn0lEQVR42u3dO4tdVRjH4d+ZiVqICVhZCNZeGjs/kN9EJJWdrWBlRCEo2EQUCy8omhghBBWDMRAVVFBjbiaTsdgbckgnzDmz957naXIm5WId1v+8611rrQI2bVXtVyeqK9Xx8e+VoWGC7lbHqteqF8fPdw0L/D87hgC2Zr/61zAwE7cMAQhYMPVgday6Vr03/t+eYWHC68J+9cba/AUELJh00FIVoJlsa9sWBAELZuNRQ8DEfwRUXa/+UcECAQvm4vxahQCm5t64LlyoLo6f7xkWELBg6pWB950gpHlsEQICFszGCYsXM/CQIQABC5rJ1suq+r66PH629cJU/WoIQMCCZrJFuKp+q66uXT4KU5un61c0WCNAwILm0tty3DAw4fva/qrO5L42ELBgZk/mnDMUTNgjeXEABCyY4cmsT3K/EE2yT7Dq8+rm2o3ugIAFzeGqhstjhcD3jynOz/PmJwhYMMcKwacqBEz4DcLTKqwgYEEz7XG5bRhomtvY+q9AwILmekrrw/Fvp7SY0vbgzbxBCAIWzHgxOztWC9zqThN6g/DLvEEIAhbMuA/rnepOLhxlWhWsd60NIGDBXAPWbnWpemv8DtomZAprwe3qa9uDIGDB3L3Z/SoWdIjVq51xLn7xQKUVELCguW0TftxwYmtXxYAJbA9eGcO+dQEELJh1xeBWw6WOKgZMIWC9VF13PxsIWLCEnpdThoIO/+6ru9UF/VcgYEELqRp89sA7hbBNe+M6cLH6zqELELCgBfRhraofGk4UrmwTcohB/1RDk7s1AQQsWEQf1rWGO7H0YXGYfjcEIGBBC+p9qTpni5BDCvm71R8NTzcJ+SBgQUvpf1lVZ6qfx8XOAsc251/j/Pux4Z1M8w8ELGhJFYRXPJtD26+grhquClFBhQ1tUQCH+x18rPq2emKtPwva8CGLX6qnG3oBXdEAqWBBC2t2/7v6QB8MWw5YH41zz+WiIGBBS92qeXvtM2w61N+sTmZrGmwRwsJ/7DxcfVU9Y5uQLdx99Wf1ZHVDyAIVLFjyd/FW9bLFjrZzevX1cc4dM98gFSxYeMjabbgX69mGPpldw0IHW73ab7gW5IXxX68IgAoWLP4Hz53uV7GgDb09eLK66u41UMGCo9TsvludrZ5LLxYdeO/VjYYK6ZVUryAVLDg6p7vuVKctfrSZqxlerX5SvQIVLDhqP3r2q6caThQ+7rvKAQasner56pvx855hgc34D/vHz1VAVCR3AAAAAElFTkSuQmCC' },
  'kanat-acilisi': { kazanc: 1, duvar: 1, kesik: 0.2, serit: 0.05, maske: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAAoCAYAAAAi24Q0AAAEB0lEQVR42u3dv0uVURzH8ff1ar9UKASpxYiCILS1pQgyIRrCILX+k6Ch2pqaW9ska3WoJaihQbJEGiLaoqGCwLLS+6PhnIvXtsDn8Z7zvF9w8cHNc7zP+Tznx/cBSVJO6vHndWADaABtP0l/On24FPu2z3/z3mcnSVI+akALGAXuAwPxd8rDb5vAgCVJ2p17ehsYA47EsOV9Pn2dmax5x24DliSJXZnBArjWNSgrn75dsxnS+zJKktJ/YG4RZq7eA4Pe57PQjH37HLgCrBuencGSJJX/wHwTGIoDs+GKLJYHa8AK8KNrGVgGLElSSQMxwHlnrrLq0z7CadCHXYcYZMCSJJWoH9i0GchtefAWsEwowWHAwj1YkiRKq33VBE4Dr+O93QfotHVOgH4GTgI/ce8VzmBJksp+WK4BN5zlILcl33uE04PuvTJgSZJ2aUA+ZDNkt8L04p/AJQOWJKnE6u2DwAm3f5DT3qtV4EO8btosBixJEqXuv2oRiotOEt5bV7dZsrHGVqkGGbAkSSUbdhkpu9A8DiywfZ+dDFiSJMo5bQYw6yCc3fjcJMxMznfNYtm/kiSV9JA8TniFSjMGrrafbD4b8eejrnBlyHIGS5JE8SfN+oH9Dr5ZGiAUj50hzGQNOpNlwJIklWMCi1DmHrIahGXgcbaKkMqAJUmiuBmsC/HagJX/nizLNRiwJEkFh6smMASc855OVU4XWoLDgCVJovjq7QPAYfdfVeK1OX8IdbGs7G7AkiQV7BfhpJnIvrL7beAd4VCD75s0YEmSCrx/nyWcLGvhDFbuvtsEBixJEqVscD8O7HFGoxJj9UdcHjRgSZIoel9ODRixKajC8uBT4JkvfjZgSZKKD1htYBo3uFdhg/sntk4SyoAlSSro3t0GxoCj8dr7eZ7hqtPXi2x/96QMWJIkdn7/VRs4Box2LReKLJcHHwCPCacHXR40YEmSCt7gfjWGK2c18g7SBwlLg74iJ8EvqSQprfv2ILBKWCJ04M1Xp28XgLnY//WKniRspfQw0e//riSR+glCH5bJeqVpE5iJ/T5HtWcs+1L5+w1YkpTmS38vAfvitSfL8jYANIBZQs2zxdjnzYpt9n/JViX7hgFLkkQBS4TDqQw02rHxukUoyzFd0Tb4BkwBy8DeGDDbvRo0DViSlGZdpFM2BVWdvazq/qsRQrHVi8CbXl82dN1ektLcg7ICTLhEKKpVtqIOfAWexOsFQpX7Wq8FTwOWJKUZsF4BZwxYopoHPLrdBe702kyWx3olyTqGEonVBmsA6/F3U704aeQXVJIkpRayasAB4C1h03/P7cMyYEmSJBLb8F4HloBJ4AvbD4AYsCRJkv4zXNUI9bAuE0o31HvxFOFfjhKgI8Di4VYAAAAASUVORK5CYII=' },
  'filiz': { kazanc: 1, duvar: 1, kesik: 0.1875, serit: 0.05, maske: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAAoCAYAAAAi24Q0AAAOgElEQVR42u2da6wdVRmGn305rS23alsMIhTBHwhKaakQMYYfNdBoTDB4QDAkBCIaMSXKJaQJaaMWCglEFBM0ES8ItNWIRkIgIPIDEsC2XAT1Bw1yUQo9UtpGLj17ZvtjrY+9ujqz957rnr3ne5PJTnvOmT2zZs1a73q/d30fKBSKSUTbfq4AZoAACIHuhB+hvdcZe+9uWyRFy36eY8+9r4Trn7Wf38x47XlB2uDT9rqCGvShQc9mQ0WeTdFo2M/DgLec90vaIsyxnzbt0QD+aM/dyem5ydj3KnCw/Y6GThEKhSINpuznUmCHNzB2a0Kyuvbel9q2mJNiUG3YQX8usMWbZIu67hDYCxzrTDxKsKrRp0JgF3C00zfqSLDkeA84Lod+2nLI1d0F9DMhalfUhBgrFIqCBkQhV8usilPVSTGwA9/sEEfHHmHC83dtGyzzlL1GwpV1A1gIbCuYZMn97QIO8ia5UROsU2tOsGSS/oPXLnUkWPIuPuwoT1n7F8Dmgt6vwKrPVVm0KBSKMYM7UJ0P7PQmhqqQqtmMapp7jnDISXEncBlwTMSqeViSBbAIeNwLkRRBsN4CFlSIYDUtSa0zwZLnfal9Ju2aE6wusCqjIiR/dwJwT0HkSs531yiIsUplCgUT4bfqAIcDP7QECzsYVmWl3bHXKWRlq72+R4F/2P8PPVITAouBs+0gudw7h5y3FUNEWvbvFgG3AtcBPwV+DLzihQGDPtce2t+ZAU4HrgXWOfdUBLoVeW5NO0ktrth1jYJsNKy62K1ZOzQi3oWXgSftzwLS2RhmgZOBhzAKcRHvU9Oed33N+69CocjgtzrXkoZuinBa0d4VWUU+ZwnOqpT3ejzwBeB24A1PTemnjoXeyngXcBO9kIEMxK0BipHru1lXgJLlKliHpVCwGjkfMtmdjPGzBTXz8vnh5i0YL1+zZsRqnkMs5T16JGW4ze9XMwWG3QNn3GlraFChUCTBHPs57e3uqdrE1AVusUqST1ZadvDrd0T5PA61itYa4CUODAsEMQTGDZm+bVfPZ0UoX40hJoi1Obd5VoJVBJbRCzcHNd89eBv1ivyI+r0SY2gPnLa4PEWo1O3LZ5ZgY5CF5rkasVMoFCTc0izKlaQmCCpoCt4JrPYUt1aG+25FDJQLHGVrd4SRPhxAtLrA/XYimRfjayPGXpGnkpWVYC20f5f1+KBt09MchaFT4/QMYpJeVSODu9vHv00vTYnscl2SUMFq2vPNt4utbgmkXc59Ss2em0KhyMHMfqMTtgkrSK5mMGGANLv3hk2h4JOtYzCG9qdjVrNRRMsd5LcD3/VM5u0hlaxRESzpE+stwZyx58h6BJr76v2+/Lca7kCT/n2xlwduNyafVJIFgFgZri9wk0hU7quXgA+jua8UCkWKXTfBGJCrORTvFfGVrTbwWeBOYA8H7gbrDiBgLwNXD/BouSTrGuDdjGQkLcGSSf+jwDsUs7Ox7slF766hCiJ9+zKPYO1M2D/9hch7JTw3Uduu1fCgQqFgSL+VawzdRzXNwL5yRcnhU/87FwNXeWGuTgwZCrzfe5j9Q5y+GjflGPD/m5HwZknTIPd8gzfBZD26NT8CS5xPqKGCJTngHrNt8a79/FUC/9VURCi9rKSwXeCkmiSFVSgUGVeSRe+6yTqodTC7zZZVYNUoqparOJxkFa3dQxAtf+fhVk/R8knvmzkoPm6i0UMSEixR1z7Vx+SvR7rcV/fU1MMjpOQJh2CFwI+GfL9bjrpb5oJQEhivVe+VQqEYhlytpprJQ/3Q4LneypWKbDdve4rWzzFhwH7G966TRV7+/WeMR+tD5L/Lzi2V85EUK29R755VY3qu4cH1NUou6nsc5wHPe+1xxhDERQj/csxu3bJIv4T6n1VypVAoGEJev6akXTdZDaXP2WtuV9RQ2vQG3AWWLG3vEyL082zJv1/FhD125Exm5DtuTjFByO9eGXG9eqQjuzuAo2oYZpK+9DmPuLzO4FqM8u7PBV4redySPn9VDUmxQqFIOMAtc1aAnYrvtPramBhK/clhHiZFw/0pFK28jeBCVl/A5PpqJiCrDYc4vq0m9Vz69Jaa1q+Td/gnnv/qySHao2UXWhtLVlLlex6z5K416oWeGr8UimoqLaElVw9aAtCsqNzdtde2B/iLHdDCirevEA/xab2DCf2tssdDzs9C735azv/LgN7I+dl3geOschImGKe79tr20ttlGurrlKlU0faab/FvOSVywBS77qdete0i4RzgPKeUVZm4A7NTsaGlcRQKRZQ5uwH8vaKGdn87dBdTemZcPQ+NiOLPKzF1HQcpWkWuxL8fYdQfdkL8jOawyqUw+Yk1FSNEhfqdbQ9J/3FJH5Va3qNFwD/7bCAp8p15UL1XCoVi0AS5cQzIVeiED46YEJ+KH1ZYjsmBNCg7fBHtOovJqp5EQZFnMB/Y5mT5V9KUjFwF9DyFzRou8sAo53ucPrmXXv3OZp+w4k0lj12iMu/B5ILTtAwKhSKWXE2PyS6wjlWwzpvAVaOvHPmKVtETiHjuvpPC1+aXOFGzezo15PyaJqmUfv95u3iS9tgDHBSTPkS8gkdi0qCUWXBevmcvyTPMKxSKGm2LPgyzUyeouPIgOYLumvBJqBmhaN3grOyDgoiwmN1ftavyJIZdueYlmLxpmjQ0Obn6U8a6mUyAwf0bTlH0LiZc2I5pk1GpV+4z29Tn+hQKBZrv6vIxCQ3K9Z3oFZ+e5FW9O3AvYf+itUWE4qSNbyV5bjHpT3eqipWoX0th5+NrvBFMyPwaj2DdGrOYEkJ/hF14BCWrVx2Mqf2T6r9SKBRx6tXBwKMlG6qzrBivr+GA5pfiOQtjrO0WENaVfvBv4OMJJ3zJRXaFJh1NXXewXeNdzGBSMrgpGu6IaRd5/28eAZmXTTZXas1BhULRT224aAzUBvFWPIMxUrdq6ndoRni0thXw/IQY3euQuyQFoI+zk1CgYcKh1KvQKiGNmiohokYdg7EquGr1hRELKndTxQslb6qQd+M/dnHaVO+VQqGII1jfiqiBV9VJ6HSV49+/fyEzC4GnCiBZs0Nske9nVv5NxftVlfr1dM37dVSaj8ApnOy3zajSgsj37KRX+1R3DioUCuJqfj1V8XI4gVdvUL0OHFDWaFEBzzG0KtRsQmIrROxL6sMa6CcMtV/vd+8rHOIp/fi0CGWvbY87SwxFS46y1zGF1pVcKRSKoWp+BRUOC7orfPU6xD/LxcAjOYdL5DzPWDLeHnJSaQIfoOen0ZxY0R6e8ypYpHyUffjUiIXVCq+NpP/Np7zSTIHzzFbqM1MoFMOYkW+pYBjHrbvXcVb4OqDFY479/F4BK3p/c8FUggnzBMxOq1n1Yh3Qnhu1X0fWQHUJVgj8FRMGxyH4Ddt+nRLUK3dxsFYXegqFggHhwYadlF+smMLgDpaPE+2/GOd2b+d8TDkT9LoCwyX7Ukww8jtX2r99T8nV++240ekPapDu9ZX1XlhZxqVtmDC4jAWbSxq3Zh3P1WoNCyoUimHzzZxRocSi7nX8HviKM+i2JqgMSFFYV1KW9679rmGUF/HNzHUmxE7NDe1dTPqLuTUv5hxHsH4Z0Y9nnTD10fRKSO0riVy9Qc9z1R6nxlQoFKOZ7EWNaNqBfxRwydWUnYQuAX5Brxr9KK+PHLegh7bdL8px/Gs62/tX23Yqcmxt20lnLSZH0QZLoII+zzd0yhrJRoVOjeYAIVay63MjcLVtx4b9uaKHPTH9LsSo2c9iqk6EBYZWZSEwZRcGV2AqG0zZ56ZQKBQDUzOMYodXGOObeMXxWjXHeAJueiG8lkNqN1GOT6SMnVRv2wlvmLxN4pmZC7xWkvpQBbXKV2G+WqKiOY47mg+il9Mt6NPHg5KU9M3Oc9KdywqFYqiJ7mRMrbiyS0v4ZO4dYDumFMbhY6xuD0rEucgJkYnhO+9jFD65x5zJsTFk3q5ltu8JyQoniFR1Ip7Fi7Z/L42pManotcd84H8DdgWGBY5NHYdkXez0bfVcKRSKoXcOXlqCiuAqVbPeCvEJTHHWj9lBlTE2j/rXvAxj1P0ZcBvwW/Yv0DxpO+E2JSAOTWdn4T0Flfkp2zPYiZj038Skp7gaOGTM+zcl7iBciQk9ByPaVBOlpCsZVigUiQayDQWlZogKjcjxliUbZ/chfuO26pb2XI4pULslYwgvHNMaepsTKlmCG4HdEaGZqof9oq5zl+3f64GjIvq3kqvBtoXLSrAtRD3H3cDtwBeBBeoTVygUacODR9oBJcxpQg9jwlT77Cr+Poyxe3FEPb1xXSE2nAF4nTfhhhHhuzDBDrNwTNMObEpAstzfWQI8EEHaqkgk3eMlq8TeZ5WXBTE1I1UBGZ5gfb3APhC38HvA9kFUaVQoFFkHsZtyHMTCPp6qpTHqRWsCiKq05Vpv8A4ymtM7YxpK3JdCyfJVgjOBfzn9KqyIauU+m23ADzDZxhf06Rs6Qacbmy4siGD579hWqzSe4l2DEmKFQpFavToK4wfKw9weOscajK/rWEx5FPd7mxOUTLEZk3cqzOj/mAG+jAk1zoypLymNkoVnIj4UuMrrW6MkV6IsrrHPphVz7Toxk4t14dcF9H0ha1utQnaK9x43lBArFIo8BrB7c1ohupPfdMyKdNIGLbmfhfRCWp0cVtUzGGM8jkl+ZgKUrKTpCFzyMj1iJatf/26r+bmwd+uZnAmWnOdpp9SO+uIUCkXu6tXRmN1NWdWr0EkeOe3UwZvkiUcybh9hB+usJFXafwe9UOqUEypZisn2HYyxJ2szpjh0kj7RcGoqTjtpHMIRkCu/fyupKp5gPZ4jwZLFiVvHUJ+jQqGgCH/DhpzUK6kqf0FNCtXKgPwJjLE5D3IVWJVqRYQXSdrzrDFOYSA1B69LuSNL2uAC29eCktMv1Kl/V4lgPZlTn5eFyfP0NtfUKlHo/wH6ITjVUiqChQAAAABJRU5ErkJggg==' },
  'iz': { kazanc: 0.92, duvar: 0.64, kesik: 0.686, serit: 0.05, maske: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAAoCAYAAAAi24Q0AAACgklEQVR42u3dv45UZRjH8e8waxQSNMRgL4UNBXgFWhlvwVh7RdwDXAOhobIkoaOzoCBACCYad43OjMWcTWaH+bMzewpiPp/mbHZP9RRvfvu87/ucAvh/Oxmev1SL6p/hOR+ev1dfDO9MlAsYwzUlAAAQsACOoTsFCFgAI/tbCQABC2Aci+H5tVIAAhbAuO5mqxAQsAAas4N1SykAAQtgXAIWIGABjGyuBICABZBbhICABfAxr3OPungmC0DAAriis3YfggcQsAAaZ5L7idENgIAFcJxP23zo/XH1RzVNNwsQsAA65Pbgr9XpsO4tVsLUm2qWLhYgYAF06KDRFy1vEq6ve1MlAgQsgI7eItzUpfpMaQABC6ArdbJaO/T+XGkAAQugUW8VPjGuARCwAMYd03BDaQABC+A4/7a5S+UbhYCABXDkOvdjdbMPRzJYBwEBC6Djtga/bPMw0VMlAgQsgONMt9wqvKc0gIAF0MGT3CfVz13saJ0HrB/2HIIHELAA2jwDa9vE9vfKAwBw2D+Rk+pO9bplN2s+BK7Z8HxWXV95FwCA9p+7+nYtVC1WgtZf1a1sEwK2CAE65Abh9yvBat1ZyxlZAAIWwAHuD2FrsRa+ZtXn1XdtvmkIIGABbHG65/D7T75HCAhYAOOsdZOVWVhTAQsQsACuvtZNWx52/2YIWXPbhICABXA5Z3v+/kl1okyAgAXQpQaMVj0cfr624725cgECFsDlzdo942rSsosFAED752BNqq+q31p2qVaHjc6G372sbq+8D5AOFkBbt/4m1Zvq1YZZWOcfgn5Qvc1NQkDAAuiQTtauLcB3OleAgAXQwZ2sxZYho39WTx10B8b0H8/jZcCvpz39AAAAAElFTkSuQmCC' }
};
/* ════════ ÇERÇEVEYİ AŞANLAR v3: ÇERÇEVE POSTERİN ÜSTÜNDE, NESNE ŞERİDİN ÖNÜNDE ════════
   Gerçek çerçevedeki gibi çerçeve şeridi posterin dış kenarının ÜSTÜNE biner (posterin
   dış ~10 px'i şeridin arkasında kalır). Nesnenin şeritle kesiştiği yerde şeridin
   ÖNÜNE posterin o bölgedeki GERÇEK pikselleri, nesnenin silueti maskesiyle çizilir
   (aynalama / sentetik dolgu yok; sayfadaki poster görselinin kendisi). Taşan
   (yalnız mürekkep) katman posterin kenarından başlar; çizgi koyuluğu ürün başına
   ölçülen kazançla posterin mürekkebine eşitlenir. Maske ve kazanç: bkz. CA_V3
   (mevcut dosyalardan çevrimdışı ölçüldü). Verisi olmayan ürün eski görünümde kalır. */
function v3Uygula(el, g){
  const veri = CA_V3[el.dataset.handle || ''];
  const cer = el.closest('.art-frame'), mat = el.parentElement;
  if(!veri || !cer || !mat || (g.yon !== 'ust' && g.yon !== 'alt')) return false;
  if(cer.closest('.modal-img-wrap.photo-mode')) return false;
  if(!cer.classList.contains('ca-v3')){
    const pay = parseFloat(getComputedStyle(cer).paddingTop) || 10;
    cer.style.setProperty('--ca-pad', pay + 'px');
    cer.classList.add('ca-v3');
  }
  const pay = parseFloat(cer.style.getPropertyValue('--ca-pad')) || 10;
  el.style.setProperty('--ov-dx', g.dx); el.style.setProperty('--ov-dy', g.dy);
  el.style.left = '0'; el.style.top = '0'; el.style.width = '100%'; el.style.height = '100%';
  el.style.transform = `translate(${g.dx},${g.dy})`;
  el.style.opacity = String(Math.min(1, el.closest('.modal-img-wrap') ? veri.kazanc : veri.duvar));   // tuval hazır olana kadar (ekranda ölçülen kazanç)
  el.dataset.yon = g.yon;
  el.classList.add('ov-ready');
  kagitAltligiKaldir(el);
  /* TEK TUVAL: taşan parça + şerit önündeki gerçek poster parçası aynı bitmapte çizilir.
     İki ayrı katman olunca sınır satırı ekran pikselinin ortasına düştüğünde iki kenar
     yumuşatması arkadaki siyah şeridi 1 px gösteriyordu (yatay dikiş). Tuval, taşan
     parçanın tepesinden şeridin iç kenarına kadar uzanır; altı clip-path ile kesilir. */
  let on = mat.querySelector('.art-overflow-on');
  if(!on){ on = document.createElement('canvas'); on.className = 'art-overflow-on'; on.setAttribute('aria-hidden', 'true'); mat.insertBefore(on, el); }
  on.classList.remove('hazir'); el.classList.remove('ov-tuvalde');
  /* taşmanın poster yüksekliğine oranı: katmanın kesik kenarı tam çözünürlükte ölçüldü (CA_V3.kesik);
     sayfadaki 200 px'lik kaba ölçüm (g.pay) sınırda 1–3 px boşluk bırakıp siyah şeridi gösteriyordu */
  const p = g.yon === 'ust' ? veri.kesik : 1 - veri.kesik;
  const ust = g.yon === 'ust';
  /* kırpma şeridin iç kenarından 2 px öteye: orada tuval posterin AYNI piksellerini çizer ve
     şeridin iç kenarındaki yarım pikseli de örter (aksi halde ince koyu çizgi kalıyordu) */
  const kirp = ust ? `inset(0 0 calc(${(100 / (1 + p)).toFixed(4)}% - ${pay + 2}px) 0)`
                   : `inset(calc(${(100 / (1 + p)).toFixed(4)}% - ${pay + 2}px) 0 0 0)`;
  on.style.cssText = `position:absolute;left:0;top:${ust ? (-p * 100).toFixed(4) : 0}%;width:100%;height:${((1 + p) * 100).toFixed(4)}%;z-index:5;pointer-events:none;clip-path:${kirp};-webkit-clip-path:${kirp}`;
  const poster = mat.querySelector('.art-img');
  const kazanc = Math.min(1, el.closest('.modal-img-wrap') ? veri.kazanc : veri.duvar);
  const maske = new Image();
  const hazirMi = im => im && im.complete && im.naturalWidth;
  const ciz = () => {
    if(!hazirMi(poster) || !hazirMi(maske) || !hazirMi(el) || !on.isConnected) return;
    const mw = mat.offsetWidth || 300, r = (mat.offsetHeight || mw * 4 / 3) / mw;
    const kat = el.closest('.modal-img-wrap') ? 2 : 1;      // pencerede yakınlaştırma (2,4×) var: tuval daha keskin çizilir
    const W = Math.max(600, Math.min(1400, Math.ceil(mw * (window.devicePixelRatio || 1) * kat)));
    const H = Math.round(W * r), CH = Math.round(H * (1 + p)), pY = ust ? CH - H : 0, sY = ust ? 0 : CH - H;   // katman kutusu: üstte -p·H, altta +p·H kaydırılmış (içeriği poster kenarında başlar)
    const mh = Math.round(H * veri.serit);
    const ara = document.createElement('canvas'); ara.width = W; ara.height = mh;
    const ax = ara.getContext('2d');
    ax.drawImage(poster, 0, ust ? 0 : -(H - mh), W, H);     // posterin kesik kenar şeridi
    ax.globalCompositeOperation = 'destination-in';
    ax.drawImage(maske, 0, 0, W, mh);                        // nesne silueti (alfa)
    on.width = W; on.height = CH;
    const cx = on.getContext('2d');
    cx.clearRect(0, 0, W, CH);
    /* Önce taşan parça (kesik kenarı tam poster kenarında), SONRA şerit önündeki poster parçası:
       sınırda iki katman üst üste binmez, mürekkep iki kez çizilmez (gri çizgi olmaz). */
    cx.globalAlpha = kazanc;                                 // ton eşitleme (ekranda ölçülen)
    cx.drawImage(el, 0, sY, W, H);
    cx.globalAlpha = 1;
    cx.drawImage(ara, 0, ust ? pY : pY + H - mh);
    /* Kenar yumuşatması: çerçevenin dış kenarı ekran pikselinin ortasına düşerse o pikselin yarısı
       siyah şerittir; nesnenin içi (yalnız mürekkep katmanı) orada şeffaf olduğundan 1 satırlık koyu
       çizgi görünür. Posterin kesik kenar satırı ~1 ekran pikseli dışarı uzatılarak bu piksel örtülür. */
    const k = Math.max(2, Math.ceil(1.5 * W / (mw * (window.devicePixelRatio || 1))));
    if(ust) cx.drawImage(ara, 0, 0, W, 1, 0, pY - k, W, k);
    else    cx.drawImage(ara, 0, mh - 1, W, 1, 0, pY + H, W, k);
    on.classList.add('hazir'); el.classList.add('ov-tuvalde');
  };
  maske.onload = ciz; maske.src = veri.maske;
  for(const im of [poster, el]) if(im && !hazirMi(im)) im.addEventListener('load', ciz, { once: true });
  ciz();
  /* modal: taşan parçaya yer açma mantığı (aşağıdaki kod) v3'te de çalışsın */
  const wrap = el.closest('.modal-img-wrap');
  if(wrap){
    wrap.classList.remove('ov-ust','ov-alt','ov-sag','ov-sol');
    wrap.classList.add('ov-' + g.yon);
    wrap.style.setProperty('--ov-pay', (g.pay + .04).toFixed(4));
  }
  return true;
}
/* Ölçüp katmanı yerleştirir. Ölçülemezse katman GİZLENİR — yanlış yerde
   göstermek, hiç göstermemekten kötü. */
function stickerYerlestir(el){
  if(!el || !el.getAttribute('src')) return;
  stickerGeo(el.getAttribute('src')).then(g=>{
    if(!g){ el.style.display = 'none'; return; }
    /* Konumu SATIR İÇİ yaz — yalnız CSS'e güvenme. Neden: tarayıcı JS'in yeni
       ama CSS'in eski (ya da tersi) sürümünü önbellekten sunduğunda katman
       yanlış yerleşiyordu; kaydırma uygulanmamış gibi görünüp taşan parça
       posterin içinde kalıyor, Uzanış/Pati gibi ürünlerde çizim ikizlenip
       "fazladan kontur" veriyordu. Satır içi stil her CSS sürümünü yener,
       böylece yarım güncellenmiş önbellek bile bozuk render üretemez. */
    el.style.setProperty('--ov-dx', g.dx);
    el.style.setProperty('--ov-dy', g.dy);
    el.style.left = '0'; el.style.top = '0';
    el.style.width = '100%'; el.style.height = '100%';
    /* MÜREKKEP-ONLY sticker'da çerçeve şeridini HİÇ geçme: bu dosyalarda çizim
       saf siyah olduğu için çerçevenin siyah kenarı üzerinde yutuluyor ve o
       ~10px'lik parça kayboluyordu (kopuk/bozuk görünüm). Kaydırmaya çerçeve
       payı eklenince taşan parça, kenarın DIŞ hizasından başlar — gerçek
       çerçevede kağıdın kenar altından çıkması gibi, temiz bir geçiş.
       Kağıt içeren sticker'larda (ör. Sabah Molası) gerek yok: orada altlık
       zaten şeridi kapatıyor. */
    /* v3 (ürün başına ölçülmüş veri varsa ve çerçeveli görünümdeyse): çerçeve posterin
       kenarının ÜSTÜNE biner; taşan katman posterin kenarından başlar (ek kaydırma yok) */
    if(v3Uygula(el, g)) return;
    let ekX = '0px', ekY = '0px';
    if(g.murekkepSade){
      const cer = el.closest('.art-frame');
      if(cer){
        const ccs = getComputedStyle(cer);
        const pay = parseFloat({ust:ccs.paddingTop, alt:ccs.paddingBottom,
                                sag:ccs.paddingRight, sol:ccs.paddingLeft}[g.yon]) || 0;
        if(g.yon === 'ust') ekY = (-pay) + 'px';
        else if(g.yon === 'alt') ekY = pay + 'px';
        else if(g.yon === 'sag') ekX = pay + 'px';
        else ekX = (-pay) + 'px';
      }
    }
    el.style.transform = `translate(calc(${g.dx} + ${ekX}),calc(${g.dy} + ${ekY}))`;
    el.dataset.yon = g.yon;
    el.classList.add('ov-ready');
    /* Kagit altligi YALNIZ gercekten kagit iceren sticker'lara (bkz. murekkepSade) */
    if(g.murekkepSade) kagitAltligiKaldir(el); else kagitAltlikEkle(el, g);
    /* ÇERÇEVE KENARI HER ZAMAN GÖRÜNÜR KALIR; sticker yalnızca ONUN ÜSTÜNDE
       çizilir, çerçeveyi silmez — sticker üstte, çerçeve altında ama görünür.
       Not: bir ara buraya, sticker'ın çerçeveyi geçtiği yere opak bir "kağıt
       şeridi" konmuştu (mürekkep yarı saydam olduğu için siyah kenarda
       kayboluyordu). O çözüm iki yeni sorun doğurdu: çerçeve çizgisi o aralıkta
       tamamen yok oluyordu ve şeridin DİKDÖRTGEN kenarı çizimde yapay bir
       kontur bırakıyordu (Uzanış'ta parmak uçlarının hemen üstünde). Kaldırıldı. */
    /* MODALDE: taşan parçaya YÖNÜNE göre yer aç. Sabit boşluk yetmiyordu —
       büyük üst taşmalar modalin dışına taşıp kırpılıyor, aşağı taşanlar
       galeri şeridiyle çakışıyordu (bkz. CSS .has-overflow.ov-*).
       Duvar sahnesi bundan etkilenmez; orada .modal-img-wrap yok. */
    const wrap = el.closest('.modal-img-wrap');
    if(wrap){
      wrap.classList.remove('ov-ust','ov-alt','ov-sag','ov-sol');
      wrap.classList.add('ov-' + g.yon);
      wrap.style.setProperty('--ov-pay', (g.pay + .04).toFixed(4));  // +pay: kenara yapışmasın
    }
  });
}
/* Oda içi sıralama: ürünün "vitrin-duvar" alt text'inin sonundaki SAYI
   (vitrin-duvar1, vitrin-duvar2 ...) küçükten büyüğe önce gelir; numarasız
   (eski format) ürünler bunların ARDINDAN, Shopify koleksiyon sırasıyla
   eklenir. Aynı sayı birden fazla üründe varsa koleksiyon sırası tie-breaker
   olur (bkz. sirala + konsol uyarısı). */
function odaSirala(liste){
  const cift = {};
  liste.forEach(p=>{ const n = Number(p.sira) || 0; if(n > 0) (cift[n] = cift[n] || []).push(p.name); });
  const tekrar = Object.keys(cift).filter(n=>cift[n].length > 1);
  if(tekrar.length) console.warn('[vitrin] Aynı sıra numarası birden fazla üründe:',
    tekrar.map(n=>n + ' -> ' + cift[n].join(', ')).join(' | '));
  return liste
    .map((p, i)=>({p, i, n: Number(p.sira) || 0}))
    .sort((a, b)=>{
      if(a.n && b.n) return a.n - b.n || a.i - b.i;   // ikisi de numaralı
      if(a.n) return -1;                              // numaralı önce
      if(b.n) return 1;
      return a.i - b.i;                               // ikisi de numarasız: eski sıra
    })
    .map(x=>x.p);
}
/* Duvarda gösterilecek eser sayısı. Liquid tarafı sıralama için daha fazla
   ürün gönderiyor (tarama sınırı 30); seçimi burada yapıyoruz ki numaralı
   ürünler koleksiyon sırasından bağımsız olarak öne geçebilsin. */
const ODA_ESER_SAYISI = 6;
function roomItems(id){
  const fstyle = ROOM_FRAME_STYLE[id];
  const gercek = odaSirala(roomProducts(id)).slice(0, ODA_ESER_SAYISI);
  const kaynak = gercek.length ? gercek : ((FALLBACK[id] && FALLBACK[id].items) || []);
  return kaynak.map(p => {
    const ek = { kisa: kisaAd(p.handle, p.name) };
    if(fstyle) ek.fstyle = fstyle;
    /* Taşan parça artık ÜRÜN ADINA göre değil, ürünün kendi galerisindeki
       "vitrin-sticker" alt text'li görselden geliyor (bkz. snippet + stickerGeo).
       Eskiden sabit bir isim→tema-asset haritası vardı; listede olmayan her yeni
       ürün (Zirve, Sabah Molası, İz ...) taşan parçasız kalıyordu. */
    if(p.sticker) ek.overflow = {src: p.sticker};
    /* 2'li setin ikinci tablosu: "vitrin-ikinci" alt text'li görsel varsa
       duvarda iki çerçeve yan yana çizilir (bkz. frame-wrap şablonu ve
       .frame-wrap.is-pair CSS'i). Yoksa (p.ikinci boş string) davranış
       hiç değişmez. */
    if(p.ikinci) ek.ikinci = p.ikinci;
    return Object.keys(ek).length ? Object.assign({}, p, ek) : p;
  });
}

/* Bir eserin çerçeve sınıfları. raw === false: ürünün "vitrin-duvar" alt
   text'li ham baskısı yok, featured_image'a düşüldü — o görsel büyük
   olasılıkla kendi mockup çerçevesini zaten içeriyor, bu yüzden kendi
   çerçevemizi uygulamayıp çift çerçeveyi önlüyoruz (bkz. .fw-mockup). */
function frameClasses(it){
  const c = [];
  if(it.fstyle) c.push('fw-' + it.fstyle);
  if(it.raw === false) c.push('fw-mockup');
  return c.length ? ' ' + c.join(' ') : '';
}

/* Oda metaverisi (isim/ikon/açıklama/sıra) sabit; yalnız items ve extra
   Shopify'dan geliyor. */
/* ── ODA İKONLARI ──
   Emoji yerine ince çizgili SVG set: emoji her işletim sisteminde
   farklı çiziliyor, renkleri marka paletiyle uyuşmuyor ve galeri
   diline yabancı duruyordu. Bu ikonlar currentColor ile boyanır,
   yani alt navigasyonda, menüde ve oda başlığında bulundukları
   yerin rengini alır. */
const ODA_IKON = {
  cerceveyiasanlar: '<svg class="rico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3.5" y="4" width="12.5" height="16" rx="1.2"/><circle cx="17" cy="14.5" r="4.2"/></svg>',
  salon: '<svg class="rico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12V9.2A2.2 2.2 0 0 1 6.2 7h11.6A2.2 2.2 0 0 1 20 9.2V12"/><rect x="2.6" y="12" width="18.8" height="5.2" rx="1.6"/><path d="M6 17.2v2.2M18 17.2v2.2"/></svg>',
  mutfak: '<svg class="rico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4.2 9.2h11.6v4.9a4.2 4.2 0 0 1-4.2 4.2H8.4a4.2 4.2 0 0 1-4.2-4.2z"/><path d="M15.8 10.4h1.9a2.4 2.4 0 0 1 0 4.8h-1.9"/><path d="M8.2 3.2v2.6M12 3.2v2.6"/></svg>',
  banyo: '<svg class="rico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2.8 12.2h18.4v2.6a4.2 4.2 0 0 1-4.2 4.2H7a4.2 4.2 0 0 1-4.2-4.2z"/><path d="M6.2 12.2V6.6A2.4 2.4 0 0 1 8.6 4.2a2.4 2.4 0 0 1 2.4 2.4"/><path d="M6.6 19v1.8M17.4 19v1.8"/></svg>',
  cocuk: '<svg class="rico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M18 14.6A7.2 7.2 0 0 1 9.4 5.2a7.4 7.4 0 1 0 8.6 9.4z"/><path d="M16.6 3.6l.66 1.54 1.54.66-1.54.66-.66 1.54-.66-1.54-1.54-.66 1.54-.66z"/></svg>',
  sevimli: '<svg class="rico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><ellipse cx="7.9" cy="8.9" rx="1.7" ry="2.2"/><ellipse cx="12.6" cy="7.4" rx="1.7" ry="2.3"/><ellipse cx="17" cy="9.6" rx="1.6" ry="2.1"/><path d="M12.2 12.4c2.6 0 4.7 1.9 4.7 4.1 0 1.6-1.2 2.7-2.8 2.7-1 0-1.4-.5-1.9-.5s-.9.5-1.9.5c-1.6 0-2.8-1.1-2.8-2.7 0-2.2 2.1-4.1 4.7-4.1z"/></svg>',
  romantik: '<svg class="rico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.2s-7.4-4.6-7.4-9.6A4.3 4.3 0 0 1 12 7.8a4.3 4.3 0 0 1 7.4 2.8c0 5-7.4 9.6-7.4 9.6z"/></svg>',
  cicek: '<svg class="rico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="8.6" r="1.9"/><circle cx="12" cy="4.6" r="2.1"/><circle cx="15.8" cy="7.2" r="2.1"/><circle cx="14.3" cy="11.7" r="2.1"/><circle cx="9.7" cy="11.7" r="2.1"/><circle cx="8.2" cy="7.2" r="2.1"/><path d="M12 13.6v6.8"/></svg>',
  yilbasi: '<svg class="rico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3.2 8.4 8.6h2.2L7.2 13.6h2.4L6.6 18.4h10.8l-3-4.8h2.4l-3.4-5h2.2z"/><path d="M12 18.4v2.6"/></svg>',
};
const ROOMS = [
  {
    id:'cerceveyiasanlar', collectionHandle:'vitrin-cerceveyiasanlar', cls:'room-cerceveyiasanlar', ico:ODA_IKON.cerceveyiasanlar,
    name:'Çerçeveyi Aşanlar', eyebrow:'Oda 1 / 9',
    desc:'Kapıdan girince ilk gördüğün duvar: çerçevenin sınırlarını aşan tablolar.',
    get extra(){ return roomRemaining('cerceveyiasanlar'); },
    get items(){ return roomItems('cerceveyiasanlar'); }
  },
  {
    id:'salon', collectionHandle:'vitrin-salon', cls:'room-salon', ico:ODA_IKON.salon,
    name:'Salon & Oturma Odası', eyebrow:'Oda 2 / 9',
    desc:'Sade ve modern; salonun için soyut kompozisyonlar.',
    get extra(){ return roomRemaining('salon'); },
    get items(){ return roomItems('salon'); }
  },
  {
    id:'mutfak', collectionHandle:'vitrin-mutfak', cls:'room-mutfak', ico:ODA_IKON.mutfak,
    name:'Mutfak & Kahve Köşesi', eyebrow:'Oda 3 / 9',
    desc:'Sıcak tonlar ve kahve ritüelleri; mutfağına ve kahve köşene yakışan tablolar.',
    get extra(){ return roomRemaining('mutfak'); },
    get items(){ return roomItems('mutfak'); }
  },
  {
    id:'banyo', collectionHandle:'vitrin-banyo', cls:'room-banyo', ico:ODA_IKON.banyo,
    name:'Banyo Dekorasyonu', eyebrow:'Oda 4 / 9',
    desc:'Minimalist beyaz-gri denge; banyon için sakin ve esprili tablolar.',
    get extra(){ return roomRemaining('banyo'); },
    get items(){ return roomItems('banyo'); }
  },
  {
    id:'cocuk', collectionHandle:'vitrin-cocuk', cls:'room-cocuk', ico:ODA_IKON.cocuk,
    name:'Çocuk & Bebek Odası', eyebrow:'Oda 5 / 9',
    desc:'Renkli, neşeli ve hayal gücünü besleyen sevimli tasarımlar.',
    get extra(){ return roomRemaining('cocuk'); },
    get items(){ return roomItems('cocuk'); }
  },
  {
    id:'sevimli', collectionHandle:'vitrin-sevimli', cls:'room-sevimli', ico:ODA_IKON.sevimli,
    name:'Sevimli Dostlar', eyebrow:'Oda 6 / 9',
    desc:'Kedi, köpek ve evcil dost sevenler için sevimli tablolar.',
    get extra(){ return roomRemaining('sevimli'); },
    get items(){ return roomItems('sevimli'); }
  },
  {
    id:'romantik', collectionHandle:'vitrin-romantik', cls:'room-romantik', ico:ODA_IKON.romantik,
    name:'Romantik & Love Is', eyebrow:'Oda 7 / 9',
    desc:'Sevgiyi duvarlara taşıyan, samimi ve sıcak romantik seriler.',
    get extra(){ return roomRemaining('romantik'); },
    get items(){ return roomItems('romantik'); }
  },
  {
    id:'cicek', collectionHandle:'vitrin-cicek', cls:'room-cicek', ico:ODA_IKON.cicek,
    name:'Doğum Günü Çiçekleri', eyebrow:'Oda 8 / 9',
    desc:'Her ayın doğum çiçeği, kişiye özel, çiçek gibi bir hediye.',
    get extra(){ return roomRemaining('cicek'); },
    get items(){ return roomItems('cicek'); }
  },
  {
    id:'yilbasi', collectionHandle:'vitrin-yilbasi', cls:'room-yilbasi', ico:ODA_IKON.yilbasi,
    name:'Yılbaşı', eyebrow:'Oda 9 / 9',
    desc:'Yeni yıl için sezonluk, bayram havasında tasarımlar.',
    get extra(){ return roomRemaining('yilbasi'); },
    get items(){ return roomItems('yilbasi'); }
  }
];

const SIZES = [
  {label:'13×18 cm', mult:1,   key:'13x18'},
  {label:'21×30 cm', mult:1.4, key:'21x30'},
  {label:'30×40 cm', mult:1.85,key:'30x40'},
  {label:'40×50 cm', mult:2.3, key:'40x50'}
];
/* Ekranda görünen buton sırası. FRAME_KEYS aynı sırada tutulmalı: seçim
   indeksi (selFrame) her ikisinde de aynı çerçeveyi göstermeli — Shopify
   varyant eşleşmesi FRAME_KEYS[selFrame] üzerinden yapılıyor. */
/* Etiketler mağazadaki varyant adlarıyla birebir ('Siyah', 'Ahşap'...);
   üstlerindeki 'ÇERÇEVE' başlığı zaten bağlamı veriyor. Uzun hâlleri
   4 butonu iki satıra taşırıp modali kaydırmalı yapıyordu. */
const FRAMES = ['Çerçevesiz','Siyah','Ahşap','Beyaz'];
/* Çerçeve düğmelerindeki köşe görseli (sumer-cita): FRAME_KEYS → sınıf eki */
const CITA_SINIFI = { frameless:'yok', black:'siyah', wood:'ahsap', white:'beyaz' };
const FRAME_KEYS = ['frameless','black','wood','white'];
/* Mağazadaki gerçek varyant başlıkları Türkçe ("13x18 / Ahşap"), kodun
   çerçeve anahtarları İngilizce. Her anahtar için kabul edilen yazımlar —
   eşleşme kurulamazsa müşteri yanlış varyantı satın alır. */
const FRAME_ALIASES = {
  frameless: ['cercevesiz','frameless','cerceve yok'],
  black:     ['siyah','black'],
  wood:      ['ahsap','wood','dogal'],
  white:     ['beyaz','white']
};
/* Türkçe karakterleri sadeleştirir; varyant başlığı ile anahtarı aynı
   düzleme indirger (Ahşap → ahsap). */
function normVariant(s){
  return (s||'').toLocaleLowerCase('tr')
    .replace(/ş/g,'s').replace(/ı/g,'i').replace(/ğ/g,'g')
    .replace(/ü/g,'u').replace(/ö/g,'o').replace(/ç/g,'c');
}
/* Modal Çerçevesiz seçiliyle açılır: duvar etiketindeki fiyat en ucuz varyanttan
   (13x18 Çerçevesiz) geliyor — modal Siyah'la açılsaydı ilk görülen fiyat daha
   yüksek çıkıp duvarla modal arasında fiyat tutarsız görünüyordu (müşteriye
   sistem hatası gibi geliyordu). Çerçeveyi Aşanlar serisinde zaten yalnız Siyah
   sunuluyor; renderOpts() içindeki sadeceSiyah kontrolü bu varsayılanı ezip
   Siyah'a sabitliyor, burada dokunmaya gerek yok. */
const DEFAULT_FRAME = FRAME_KEYS.indexOf('frameless');
/* Çerçeveyi Aşanlar serisi ürün penceresinde 30×40 ile açılır (Önerimiz
   ölçüsü); diğer tüm ürünler kalan satılabilir varyantların en ucuzuyla (bkz. varsayilanSecim). Duvar
   etiketleri ve kartlar en düşük fiyatı "…'den" diye gösterir. */
const VARSAYILAN_BOYUT = Math.max(0, SIZES.findIndex(s => s.key === '30x40'));
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ============ SVG PLACEHOLDER (gerçek görsel yoksa) ============ */
function svgWrap(inner, bg){
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 400">
    <defs>
      <filter id="paper"><feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" stitchTiles="stitch"/><feColorMatrix type="saturate" values="0"/><feComponentTransfer><feFuncA type="linear" slope="0.05"/></feComponentTransfer></filter>
      <radialGradient id="vig" cx="50%" cy="46%" r="72%"><stop offset="72%" stop-color="black" stop-opacity="0"/><stop offset="100%" stop-color="black" stop-opacity="0.07"/></radialGradient>
    </defs>
    <rect width="300" height="400" fill="${bg}"/>${inner}
    <rect width="300" height="400" filter="url(#paper)" opacity="0.55"/>
    <rect width="300" height="400" fill="url(#vig)"/>
  </svg>`;
}
const ART_STYLES = {
  cerceveyiasanlar(i){
    /* taş duvar + sıcak ışık teması: kırık beyaz zemin üzerine terracotta/
       altın tonlu, çerçeve sınırından taşan fırça darbesi motifi */
    const pal = ['#B85C38','#C9A227','#8A5A32'];
    const c = pal[i % pal.length];
    const y = 130 + (i%3)*18;
    return svgWrap(`
      <rect x="70" y="${y}" width="160" height="200" rx="2" fill="none" stroke="${c}" stroke-width="2" opacity=".5"/>
      <path d="M55 ${y+40} Q150 ${y-30+(i%2)*40} 255 ${y+60}" stroke="${c}" stroke-width="10" fill="none" stroke-linecap="round" opacity=".85"/>
      <circle cx="${150+(i%3-1)*30}" cy="${y+130}" r="${26+(i%3)*8}" fill="${c}" opacity=".65"/>
    `, '#F2EAD9');
  },
  salon(i){
    const pal = ['#B85C38','#8A8B6C','#2C1810','#D9C7A7','#C9A227'];
    const a = pal[i % pal.length], b = pal[(i+2) % pal.length], c = pal[(i+4) % pal.length];
    const y = 120 + (i%3)*40;
    return svgWrap(`
      <path d="M0 ${y+140} Q150 ${y+40+(i%2)*60} 300 ${y+120} L300 400 L0 400 Z" fill="${b}" opacity=".85"/>
      <circle cx="${90+(i%4)*40}" cy="${y-20}" r="${46+(i%3)*10}" fill="${a}"/>
      <path d="M0 ${y+200} Q150 ${y+120} 300 ${y+190} L300 400 L0 400 Z" fill="${c}" opacity=".9"/>
      <rect x="40" y="${y+230}" width="${120+(i%3)*40}" height="8" fill="#F5F0E8" opacity=".6"/>
    `, '#EFE7D6');
  },
  mutfak(i){
    const cups = ['#6B4526','#B85C38','#8A5A32'];
    const cup = cups[i % cups.length];
    const steam = 60 + (i%3)*12;
    return svgWrap(`
      <path d="M${110+(i%2)*10} ${steam} q14 -22 0 -40 M150 ${steam-6} q14 -22 0 -40 M${188-(i%2)*10} ${steam} q14 -22 0 -40" stroke="${cup}" stroke-width="6" fill="none" stroke-linecap="round" opacity=".55"/>
      <rect x="92" y="170" width="116" height="96" rx="14" fill="${cup}"/>
      <path d="M208 190 q44 8 0 56" stroke="${cup}" stroke-width="12" fill="none"/>
      <ellipse cx="150" cy="176" rx="52" ry="12" fill="#F5EBDB"/>
      <ellipse cx="150" cy="300" rx="${72+(i%3)*8}" ry="12" fill="${cup}" opacity=".3"/>
      <text x="150" y="352" text-anchor="middle" font-family="Georgia" font-size="22" fill="${cup}" font-style="italic">kahve zamanı</text>
    `, '#F7EFDF');
  },
  banyo(i){
    const g = ['#B0AEA4','#8F8D83','#CBC9BF'];
    const t = g[i % g.length];
    return svgWrap(`
      <path d="M60 ${260-(i%3)*20} A90 90 0 0 1 240 ${260-(i%3)*20}" stroke="${t}" stroke-width="10" fill="none"/>
      <path d="M90 ${300-(i%3)*20} A60 60 0 0 1 210 ${300-(i%3)*20}" stroke="#D9CDB8" stroke-width="10" fill="none"/>
      <circle cx="${120+(i%4)*20}" cy="${120+(i%2)*24}" r="${20+(i%3)*8}" fill="${t}" opacity=".7"/>
      <line x1="70" y1="340" x2="230" y2="340" stroke="${t}" stroke-width="4" opacity=".5"/>
    `, '#F4F3EF');
  },
  cocuk(i){
    const pals = [['#F2B6C1','#8EC9E8','#F7D774'],['#A8D8B9','#F2B6C1','#8EC9E8'],['#F7D774','#A8D8B9','#E8A2C8']];
    const [p1,p2,p3] = pals[i % pals.length];
    return svgWrap(`
      <circle cx="150" cy="140" r="56" fill="${p3}"/>
      ${Array.from({length:8},(_,k)=>{
        const ang = k*Math.PI/4;
        return `<line x1="${150+Math.cos(ang)*72}" y1="${140+Math.sin(ang)*72}" x2="${150+Math.cos(ang)*92}" y2="${140+Math.sin(ang)*92}" stroke="${p3}" stroke-width="8" stroke-linecap="round"/>`;
      }).join('')}
      <path d="M40 300 Q150 ${210+(i%3)*16} 260 300" stroke="${p1}" stroke-width="16" fill="none" stroke-linecap="round"/>
      <path d="M60 320 Q150 ${244+(i%3)*16} 240 320" stroke="${p2}" stroke-width="16" fill="none" stroke-linecap="round"/>
      <circle cx="${86+(i%3)*20}" cy="352" r="10" fill="${p1}"/>
      <circle cx="${196-(i%3)*14}" cy="356" r="8" fill="${p2}"/>
    `, '#FFF9EF');
  },
  sevimli(i){
    const pal = ['#8A5A32','#B85C38','#6B4526'];
    const c = pal[i % pal.length];
    const y = 180 + (i%3)*20;
    return svgWrap(`
      <ellipse cx="150" cy="${y+40}" rx="46" ry="36" fill="${c}"/>
      <circle cx="${150-52}" cy="${y-24}" r="20" fill="${c}"/>
      <circle cx="${150-18}" cy="${y-40}" r="20" fill="${c}"/>
      <circle cx="${150+18}" cy="${y-40}" r="20" fill="${c}"/>
      <circle cx="${150+52}" cy="${y-24}" r="20" fill="${c}"/>
      <path d="M60 320 Q150 ${300+(i%2)*10} 240 320" stroke="${c}" stroke-width="4" fill="none" opacity=".4"/>
    `, '#F5E9D6');
  },
  romantik(i){
    const pal = ['#8B2635','#B85C56','#6B1F2A'];
    const c = pal[i % pal.length];
    const s = 1 + (i%3)*.08;
    return svgWrap(`
      <path transform="translate(150 180) scale(${s})" d="M0 40 C -60 -10 -60 -70 0 -40 C 60 -70 60 -10 0 40 Z" fill="${c}"/>
      <path d="M50 300 Q150 ${280+(i%2)*12} 250 300" stroke="${c}" stroke-width="3" fill="none" opacity=".35"/>
      <text x="150" y="350" text-anchor="middle" font-family="Georgia" font-size="20" fill="${c}" font-style="italic" opacity=".7">sevgiyle</text>
    `, '#F3E7E4');
  },
  cicek(i){
    const pals = [['#D46A8A','#F2B6C1','#8A5A32'],['#E8A2C8','#F7D774','#6B4526'],['#B85C6B','#F2B6C1','#8A5A32']];
    const [p1,p2,stem] = pals[i % pals.length];
    return svgWrap(`
      <line x1="150" y1="220" x2="150" y2="340" stroke="${stem}" stroke-width="6"/>
      ${Array.from({length:6},(_,k)=>{
        const ang = k*Math.PI/3;
        return `<ellipse cx="${150+Math.cos(ang)*38}" cy="${180+Math.sin(ang)*38}" rx="26" ry="16" fill="${p1}" transform="rotate(${k*60} ${150+Math.cos(ang)*38} ${180+Math.sin(ang)*38})"/>`;
      }).join('')}
      <circle cx="150" cy="180" r="18" fill="${p2}"/>
    `, '#FBF2E9');
  },
  yilbasi(i){
    const pal = ['#C9A227','#8B9D83','#B85C38'];
    const c = pal[i % pal.length];
    return svgWrap(`
      ${Array.from({length:6},(_,k)=>{
        const ang = k*Math.PI/3;
        return `<line x1="150" y1="180" x2="${150+Math.cos(ang)*70}" y2="${180+Math.sin(ang)*70}" stroke="${c}" stroke-width="5" stroke-linecap="round"/>`;
      }).join('')}
      <circle cx="150" cy="180" r="10" fill="${c}"/>
      <path d="M40 300 Q150 ${280+(i%2)*14} 260 300" stroke="${c}" stroke-width="3" fill="none" opacity=".4"/>
    `, '#EFF3EE');
  }
};
function artSrc(style, i, customImg){
  if(customImg) return customImg;
  return 'data:image/svg+xml;utf8,' + encodeURIComponent(ART_STYLES[style](i));
}

/* ============ ODALARI KUR ============ */
const roomsEl = document.getElementById('rooms');
const roomState = {}; // id -> {index, count}

/* Oda fotoğrafı genişliği döngüden ÖNCE bir kez: döngü içinde her odada
   innerWidth okumak, bir önceki odanın DOM'a eklenmesinden sonra zorunlu
   yerleşim hesabı tetikliyordu (ölçüldü: ~300 ms, 4x CPU). */
const ODA_FOTO_GENISLIK = odaFotoGenisligi();
ROOMS.forEach((room, odaSira)=>{
  const src = IMAGES.rooms[room.id];
  const isSeq = Array.isArray(src) && src.length > 0;
  const hasPhoto = isSeq || Boolean(src);
  const firstBg = isSeq ? src[0] : src;
  const frames = room.items.map((it,i)=>{
    const sp = ((IMAGES.frameSpots && IMAGES.frameSpots[room.id]) || [])[i] || {};
    const side = sp.lab || 'r'; // etiket yönü: r sağ, l sol
    /* 2'li set: "vitrin-ikinci" görseli varsa aynı yuvada (aynı i indeksinde,
       diğer eserlerin sırasını/konumunu etkilemeden) İKİ çerçeve yan yana
       çizilir — bkz. .frame-wrap.is-pair CSS'i (frame-inner burada flex
       olur, her çerçeve tekliden daha dar bir taban genişliği kullanır ki
       toplam alan aşırı büyümesin). */
    return `
    <button class="frame-wrap${frameClasses(it)}${it.overflow ? ' has-overflow' : ''}${it.ikinci ? ' is-pair' : ''}" data-room="${room.id}" data-i="${i}" aria-label="${attr(it.kisa || it.name)} — ${attr(fmt(it.price))}'den, incele">
      <span class="frame-spot" aria-hidden="true"></span>
      <span class="frame-inner">
        <span class="art-frame" style="display:block"><span class="art-mat">${it.overflow ? `<img class="art-overflow" data-handle="${attr(it.handle || '')}" alt="" aria-hidden="true"${odaSira === 0 ? ' fetchpriority="high"' : ''} src="${duvarGorseli(it.overflow.src)}">` : ''}
          <img class="art-img" loading="${it.overflow ? 'eager' : 'lazy'}"${odaSira === 0 ? ' fetchpriority="high"' : ''} decoding="async" src="${duvarGorseli(artSrc(room.id, i, it.img))}" alt="${attr(it.name)}">
        </span></span>${it.ikinci ? `
        <span class="art-frame" style="display:block"><span class="art-mat">
          <img class="art-img" loading="lazy" decoding="async" src="${duvarGorseli(it.ikinci)}" alt="${attr(it.name)} (2. tablo)">
        </span></span>` : ''}
      </span>
      <span class="wall-info wl-${side}">
        <span class="wall-label">
          <span class="wl-name">${attr(it.kisa || it.name)}</span>
          <span class="wl-meta">${it.old ? `<s>${fmt(it.old)}</s> ` : ''}${fmt(it.price)}'den</span>
          <span class="wl-cta">${SHOPIFY.hosted && !it.handle ? 'Yakında' : 'İncele'}</span>
        </span>
        <span class="wl-all" data-room="${room.id}">Tüm koleksiyonu gör →</span>
      </span>
    </button>`;
  }).join('');

  const cta = `
    <div class="cta-card" data-i="${room.items.length}">
      <h3>${room.items.length > 0 ? `${room.name}: turda ${room.items.length} tablo gördün.` : `${room.name}: vitrin yakında burada.`}</h3>
      <p>${room.desc}</p>
      <button class="btn open-collection" data-room="${room.id}">Kalan ${remainingCount(room)} ürünü gör →</button>
    </div>`;

  const dots = room.items.map((_,i)=>`<i data-d="${i}" class="${i===0?'on':''}" role="button" aria-label="${i+1}. tablo"></i>`).join('')
             + `<i data-d="${room.items.length}" role="button" aria-label="Tümünü gör"></i>`;

  const section = document.createElement('section');
  section.className = `room ${room.cls}${hasPhoto ? '' : ' no-photo'}`;
  section.id = room.id;
  const light = ROOM_LIGHT[room.id];
  if(light){
    section.style.setProperty('--art-shadow-x', light.shadowX);
    section.style.setProperty('--art-glare-deg', light.glareDeg + 'deg');
  }
  section.innerHTML = `
    <div class="room-sticky">
    <div class="room-photo" ${hasPhoto ? `style="background-image:url('${odaFotoUrl(firstBg, ODA_FOTO_GENISLIK)}')"` : ''}></div>
    <div class="room-photo-b"></div>
    <div class="room-fallback">
      <div class="rf-wall"></div>
      <div class="rf-window" style="left:12%"></div>
      <div class="rf-base"></div>
      <div class="rf-floor"></div>
    </div>
    <div class="room-scrim"></div>
    <div class="room-light"></div>
    <div class="photo-grain"></div>
    <div class="room-head">
      <div class="room-eyebrow">${room.eyebrow}</div>
      <h2 class="room-title">${room.ico} ${room.name}</h2>
    </div>
    <div class="stage">
      <div class="stage-cam" data-room="${room.id}">${frames}${cta}</div>
    </div>
    <button class="room-arrow prev" data-room="${room.id}" data-dir="-1" aria-label="Önceki tablo" disabled>
      <svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg>
    </button>
    <button class="room-arrow next" data-room="${room.id}" data-dir="1" aria-label="Sonraki tablo">
      <svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>
    </button>
    <div class="room-dots" data-room="${room.id}">${dots}</div>
    </div>`;
  const stepCount = room.items.length + 1;
  /* Video ile örtüşme (-100vh): videodan hemen sonra gelen ilk oda
     Çerçeveyi Aşanlar. Videonun son karesi ile bu odanın 1. görünümü
     (CERCEVE1_B64) aynı sahne — dikişsiz geçiş buradan kuruluyor.
     Salon ve sonrası normal (örtüşmesiz) oda-arası geçişle açılır. */
  const overlap = room.id === 'cerceveyiasanlar' ? 100 : 0;
  if(overlap) section.dataset.overlap = '1';
  /* Adım başına scroll mesafesi. Mobilde ölçüm: adım 824px, tipik bir
     parmak hareketi ~1464px — yani tek harekette iki eser birden
     geçiliyordu. Dar ekranda adım uzatılıyor ki bir hareket bir esere
     denk gelsin. Masaüstünde fare tekeri kademeli olduğu için 75vh
     zaten doğru çalışıyor, değiştirilmedi. */
  const adimVh = window.innerWidth < 768 ? 130 : 75;
  section.style.height = ((stepCount - 1) * adimVh + 100 + overlap) + 'vh';
  roomsEl.appendChild(section);
  roomState[room.id] = { index:0, count: stepCount };
});

/* Taşan katman (sticker), POSTERİ (art-img) yüklenene kadar gizli tutulur.
   Neden: sticker etiketsiz <img>, poster ise loading="lazy". Sticker eager
   yüklenip boyanırken poster henüz gelmemiş oluyordu; duvarda "posterin
   üzerine oturması gereken parça" boş/gri kutunun üstünde havada duruyordu
   (Bırakma'da balonun tepesi ayrı bir parça gibi). CSS sticker'ı .frame-wrap
   içinde varsayılan gizler; poster yüklenince .poster-ready ile açılır.
   Genel çözüm: gerçek Shopify ürün görselleri bağlandığında da aynı garanti
   geçerli — sticker asla posterinden önce görünmez. */
roomsEl.querySelectorAll('.frame-wrap .art-frame').forEach(fr=>{
  const ovEl = fr.querySelector('.art-overflow');
  if(!ovEl) return;                                   // yalnız taşan ürünler
  stickerYerlestir(ovEl);                             // yön/kaydırma ölçümle
  const img = fr.querySelector('.art-img');
  const ac = ()=> fr.classList.add('poster-ready');
  if(!img){ ac(); return; }
  if(img.complete && img.naturalWidth > 0){ ac(); return; }
  img.addEventListener('load', ac, {once:true});
  img.addEventListener('error', ac, {once:true});     // 404'ta bile sticker'ı sonsuza dek gizleme
});

/* Mağazada barındırıldığında, sayfa başına bir kez, her odanın gerçek
   koleksiyon ürün sayısını çekip CTA metnini günceller. Dosya olarak
   açıldığında (demo mod) hiç istek atılmaz, sabit `extra` kullanılmaya
   devam eder. */
/* CTA sayısı ARTIK sunucudan geliyor (bkz. snippet -> "remaining":
   koleksiyon toplamı eksi duvarda gösterilen). Burada eskiden ayrıca
   /collections/{collectionHandle}/products.json ile sayı çekilip metin
   güncelleniyordu; o handle'lar ("vitrin-mutfak") mağazada koleksiyon
   olarak yok, istek boş dizi dönüyor ve doğru değeri 0 ile eziyordu.
   Blok kaldırıldı. */
/* Duvar etiketindeki fiyatı en ucuz yayındaki varyanta göre tazele (yalnız
   handle'ı olan gerçek ürünlerde). Etiketler sunucuda zaten aynı kuralla
   (snippet: en ucuz satıştaki varyant) yazılıyor; bu yalnız bir tazeleme.
   ODA BAZINDA ve ihtiyaç anında çalışır: eskiden açılışta 54 ürünün verisi aynı
   anda çekiliyor, video ve ilk odanın görselleriyle bant genişliği/işlemci
   için yarışıyordu (ölçüldü). Artık yalnız aktif oda + komşuları (bkz.
   odaYakiniHazirla — updateRooms'ta oda değişince çağrılır). */
function odaFiyatlariniTazele(roomId){
  if(!SHOPIFY.hosted) return;
  const yapildi = odaFiyatlariniTazele.yapildi || (odaFiyatlariniTazele.yapildi = new Set());
  if(yapildi.has(roomId)) return;
  yapildi.add(roomId);
  const room = ROOMS.find(r=>r.id === roomId);
  if(!room) return;
  {
    room.items.forEach((it,i)=>{
      if(!it.handle) return;
      fetchProductData(it.handle).then(prod=>{
        const v = cheapestVariant(prod);
        if(!v) return;
        it.price = v.price / 100;
        it.old = v.compare_at_price ? v.compare_at_price / 100 : 0;
        const btn = document.querySelector(`.frame-wrap[data-room="${room.id}"][data-i="${i}"]`);
        if(!btn) return;
        const meta = btn.querySelector('.wl-meta');
        if(meta) meta.innerHTML = `${it.old ? `<s>${fmt(it.old)}</s> ` : ''}${fmt(it.price)}'den`;
        btn.setAttribute('aria-label', `${it.kisa || it.name} — ${fmt(it.price)}'den, incele`);
      });
    });
  }
}
/* Aktif oda değişince: o oda ve komşularının fiyatlarını tazele, komşu odaların
   tablo görsellerini önden indir (lazy görseller oda ekrana gelince inmeye
   başlıyordu, tablolar bir süre boş görünüyordu). */
function odaYakiniHazirla(roomId){
  const ri = ROOMS.findIndex(r=>r.id === roomId);
  if(ri < 0) return;
  [ri, ri + 1, ri - 1].forEach(j=>{
    const r = ROOMS[j];
    if(!r) return;
    odaFiyatlariniTazele(r.id);
    if(j !== ri) document.querySelectorAll(`#${r.id} img.art-img[loading="lazy"]`).forEach(im=>{ im.loading = 'eager'; });
  });
}

/* ============ ODA FOTOĞRAFI ÖN YÜKLEME ============
   Oda fotoğrafları CSS background-image olduğu için tarayıcı onları ancak
   atandıkları anda indirmeye başlar; crossfade de o anda başlayınca arada
   boş bir kare oluşuyordu. Burada her URL bir kez Image() ile indirilir ve
   sözü cache'lenir; layoutRoom geçişi bu söz çözülene kadar bekletir. */
/* ── ODA FOTOĞRAFLARI: CDN BOYUTLANDIRMA ──
   Fotoğraflar Shopify Files'ta PNG olarak duruyor ve ham çözünürlükte
   iniyordu: tam bir tur 69 görsel / ~5 MB. Shopify CDN'e width parametresi
   verildiğinde görseli hem istenen boyuta indirir hem de tarayıcı
   destekliyorsa WebP olarak sunar — fotoğrafik içerikte PNG'ye göre
   belirgin kazanç.
   Genişlik 400'ün katlarına yuvarlanıyor: her ekran boyutu için ayrı bir
   dosya üretip CDN önbelleğini dağıtmak yerine birkaç ortak basamak. */
function odaFotoGenisligi(){
  const dpr = Math.min(2, window.devicePixelRatio || 1);
  const hedef = Math.ceil((window.innerWidth * dpr) / 400) * 400;
  return Math.max(800, Math.min(2000, hedef));
}
function odaFotoUrl(url, genislik){
  if(!url) return url;
  if(!/\/cdn\/shop\/|cdn\.shopify\.com/.test(url)) return url;  // yerel/asset dosyalarına dokunma
  if(/[?&]width=/.test(url)) return url;                          // zaten boyutlandırılmış
  /* format=jpg denendi, ölçülebilir kazanç vermedi (3757 -> 3762 KB):
     Shopify parametreyi yok sayıyor ya da zaten optimize ediyor.
     Etkisiz parametre eklenmiyor. */
  return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (genislik || odaFotoGenisligi());
}
const photoCache = new Map();
function preloadPhoto(url){
  if(!url) return Promise.resolve();
  let p = photoCache.get(url);
  if(!p){
    p = new Promise(res=>{
      const img = new Image();
      img.onload = img.onerror = ()=>res(); // hata da olsa akışı kilitleme
      img.src = url;
    });
    photoCache.set(url, p);
  }
  return p;
}
/* Aktif adımın komşularını hazırla. Sıradaki ODANIN fotoğraflarını ayrıca
   almaya gerek yok: sayfa açılışında her odaya bir kez layoutRoom çağrıldığı
   için (bkz. ROOMS.forEach(r=>layoutRoom(r.id))) her oda kendi ilk üç
   görünümünü zaten önden yüklüyor. */
function preloadAround(st, srcCfg){
  [st.index + 1, st.index + 2, st.index - 1].forEach(j=>{
    if(j >= 0 && j < srcCfg.length) preloadPhoto(odaFotoUrl(srcCfg[j]));
  });
}

/* ============ 3B KAMERA — ODA İÇİNDE YÜRÜME ============ */
/* Etiket sahnenin dışına taşarsa önce KARŞI tarafa geçer, orası da
   sığmıyorsa içeri kaydırılır. frameSpots'taki `lab` tercihi korunur;
   yalnız sığmadığında devreye girer. Gerekçe: gerçek ürün adları temsili
   adlardan uzun, etiket ayarlanan temiz duvar alanını aşabiliyor. */
function fitWallLabel(sec, cam, index){
  const el = cam.querySelector(`.frame-wrap[data-i="${index}"]`);
  if(!el) return;
  /* Konumlanan öğe artık .wall-info (etiket kutusu + altındaki "Tüm
     koleksiyonu gör" butonunu birlikte taşır); .wall-label yalnız görsel
     kutu. Taşma hesabı bu sarmalayıcı üzerinden yapılmalı. */
  const label = el.querySelector('.wall-info');
  if(!label) return;
  if(!label.dataset.side) label.dataset.side = label.classList.contains('wl-l') ? 'l' : 'r';
  const tercih = label.dataset.side;
  label.classList.remove('wl-l','wl-r');
  label.classList.add('wl-' + tercih);
  label.style.setProperty('--wl-nudge', '0px');

  const kenar = 22;
  const sinir = sec.getBoundingClientRect();
  const tasma = ()=>{
    const r = label.getBoundingClientRect();
    return Math.max(0, (sinir.left + kenar) - r.left, r.right - (sinir.right - kenar));
  };
  if(tasma() <= 0) return;

  const diger = tercih === 'r' ? 'l' : 'r';
  label.classList.remove('wl-' + tercih);
  label.classList.add('wl-' + diger);
  if(tasma() <= 0) return;

  /* İki taraf da sığmadı: içeri kaydır. translateX, ölçekten ÖNCE
     uygulandığı için üst öğenin ölçeğiyle çarpılır; --invsc (1/ölçek)
     ile çarparak ekranda istenen piksel kadar kaydırıyoruz. */
  const invsc = parseFloat(getComputedStyle(el).getPropertyValue('--invsc')) || 1;
  const r = label.getBoundingClientRect();
  let kay = 0;
  if(r.right > sinir.right - kenar) kay = (sinir.right - kenar) - r.right;
  else if(r.left < sinir.left + kenar) kay = (sinir.left + kenar) - r.left;
  label.style.setProperty('--wl-nudge', Math.round(kay * invsc) + 'px');
}
/* ════════ MOBİL YERLEŞİM: BAŞLIK ↔ TABLO ↔ NOKTALAR ════════
   Tablo konumu fotoğraftaki boş duvara göre (frameSpots, ekranın yüzdesi)
   veriliyor. Kısa ekranlarda (ör. iPhone 13: 664 px) tablo + altındaki etiket
   yığını (~560 px) oda başlığı ile noktalar arasındaki alana (~340 px)
   sığmıyor; tablo başlığın, etiket noktaların üstüne biniyordu. Burada
   yığın ölçülür (dönüşümden bağımsız offset ölçüleriyle): sığıyorsa yalnız
   dikeyde kaydırılır, sığmıyorsa küçültülür. Masaüstüne dokunulmaz. */
const MOBIL_YERLESIM = window.matchMedia('(max-width:760px)');
function mobilSigdir(sec, el, dy, sc){
  const sahne = sec.querySelector('.stage');
  const bas = sec.querySelector('.room-head'), nokta = sec.querySelector('.room-dots');
  const cer = el.querySelector('.frame-inner'), bilgi = el.querySelector('.wall-info');
  if(!sahne || !bas || !nokta || !cer) return { dy, sc };
  const H = sahne.offsetHeight, fh = cer.offsetHeight;
  if(!H || !fh) return { dy, sc };
  const ust = bas.offsetTop + bas.offsetHeight + 12;
  const alt = nokta.offsetTop - 12;
  const ih = bilgi ? bilgi.offsetHeight : 0, ARA = 18;
  /* Taşan parça (Çerçeveyi Aşanlar) çerçevenin üstüne çıkıyorsa o pay da sayılır */
  let tasmaUst = 0;
  const ov = el.querySelector('.art-overflow');
  if(ov && ov.complete && ov.naturalWidth){
    const ri = cer.getBoundingClientRect(), ro = ov.getBoundingClientRect();
    if(ri.height > 0) tasmaUst = Math.max(0, (ri.top - ro.top) / ri.height * fh);
  }
  const invsc = k => Math.min(2.7, 1 / k);   // mobilde etiket, küçülen tabloyla birlikte küçülmesin (layoutRoom ile aynı sınır)
  const yigin = k => (tasmaUst + fh + ARA) * k + ih * invsc(k) * k;
  const alan = alt - ust;
  let k = sc;
  if(alan > 60 && yigin(k) > alan){
    k = (alan - ih) / (tasmaUst + fh + ARA);       // k ≥ 1/2.7 iken etiket ekranda sabit boyda
    k = Math.max(.38, Math.min(sc, k));
  }
  let merkez = H * .53 + dy;
  const ustKenar = () => merkez - fh * k / 2 - tasmaUst * k;
  const altKenar = () => ustKenar() + yigin(k);
  if(altKenar() > alt) merkez -= altKenar() - alt;
  if(ustKenar() < ust) merkez += ust - ustKenar();
  return { dy: merkez - H * .53, sc: k };
}
/* ════════ MASAÜSTÜ: BAŞLIK ↔ TABLO ════════
   Masaüstünde etiket tablonun YANINDA; yığın yalnız tablo (+ üstüne taşan
   parça). Tablonun üst kenarı oda başlığı yazısının altına girerse (yatayda
   yazıyla örtüşüyorsa) tablo aşağı kaydırılır; noktalara kadar yer yoksa
   küçültülür. Örtüşmeyen tablolara dokunulmaz (fotoğraftaki duvar konumu
   korunur). Mobil yerleşim (mobilSigdir) ayrı ve değişmedi. */
function masaustuSigdir(sec, el, dx, dy, sc){
  const sahne = sec.querySelector('.stage');
  const bas = sec.querySelector('.room-head'), nokta = sec.querySelector('.room-dots');
  const cer = el.querySelector('.frame-inner');
  if(!sahne || !bas || !nokta || !cer) return { dy, sc };
  const H = sahne.offsetHeight, W = sahne.offsetWidth, fh = cer.offsetHeight, fw = cer.offsetWidth;
  if(!H || !fh) return { dy, sc };
  /* Başlık yazısının gerçek alanı (kutu tam genişlikte, yazı ortada) */
  const yazi = [bas.querySelector('.room-eyebrow'), bas.querySelector('.room-title')].filter(Boolean).map(x => {
    const r = document.createRange(); r.selectNodeContents(x); return r.getBoundingClientRect();
  }).filter(r => r.width > 0);
  if(!yazi.length) return { dy, sc };
  const basRect = bas.getBoundingClientRect();
  const yaziSol = Math.min(...yazi.map(r => r.left)) - basRect.left, yaziSag = Math.max(...yazi.map(r => r.right)) - basRect.left;
  const ust = Math.max(...yazi.map(r => r.bottom)) - basRect.top + bas.offsetTop + 18;
  const alt = nokta.offsetTop - 18;
  let tasmaUst = 0;
  const ov = el.querySelector('.art-overflow');
  if(ov && ov.complete && ov.naturalWidth){
    const ri = cer.getBoundingClientRect(), ro = ov.getBoundingClientRect();
    if(ri.height > 0) tasmaUst = Math.max(0, (ri.top - ro.top) / ri.height * fh);
  }
  /* Etiket (masaüstünde tablonun yanında, dikeyde ortalı) da yığına dahil */
  const bilgi = el.querySelector('.wall-info');
  const bw = bilgi ? bilgi.offsetWidth : 0, bh = bilgi ? bilgi.offsetHeight : 0;
  const sagda = !bilgi || !bilgi.classList.contains('wl-l');
  const merkezX = W / 2 + dx;
  const olc = (k, merkez) => {
    const esk = Math.min(1.9, 1 / k) * k;               // etiketin ekrandaki ölçeği (bkz. --invsc)
    const ebW = bw * esk, ebH = bh * esk, ara = bilgi ? 36 * k : 0;
    return {
      sol: merkezX - fw * k / 2 - (sagda ? 0 : ara + ebW),
      sag: merkezX + fw * k / 2 + (sagda ? ara + ebW : 0),
      ust: Math.min(merkez - fh * k / 2 - tasmaUst * k, merkez - ebH / 2),
      alt: Math.max(merkez + fh * k / 2, merkez + ebH / 2)
    };
  };
  let k = sc, merkez = H * .53 + dy;
  let o = olc(k, merkez);
  if(o.sag < yaziSol - 24 || o.sol > yaziSag + 24 || o.ust >= ust) return { dy, sc };   // yazıyla örtüşmüyor
  for(;;){
    o = olc(k, merkez);
    merkez += ust - o.ust;                                // üst kenarı başlığın altına indir
    o = olc(k, merkez);
    if(o.alt <= alt || k <= .5) break;
    k = Math.max(.5, k - .04);                            // noktalara kadar yer yoksa küçült
    merkez = H * .53 + dy;
  }
  return { dy: merkez - H * .53, sc: k };
}
function layoutRoom(roomId, dir = 0){
  const st = roomState[roomId];
  const sec = document.getElementById(roomId);
  const cam = sec.querySelector('.stage-cam');
  const spacing = Math.min(window.innerWidth * .66, 560); // px cinsinden çerçeve aralığı
  const depth = 300;   // uzaktaki tabloların geriye kaçışı
  const angle = 26;    // duvar boyunca perspektif açısı

  const spots = (IMAGES.frameSpots && IMAGES.frameSpots[roomId]) || [];
  const vw = window.innerWidth, vh = window.innerHeight;
  /* Işık/gölge yönü: aktif GÖRÜNÜMÜN kendi fotoğrafına göre (varsa);
     yoksa (henüz fotoğrafı olmayan odalarda) oda geneli varsayılana düş */
  const spotLight = spots[st.index] && spots[st.index].light;
  const roomLight = ROOM_LIGHT[roomId];
  const shadowX = spotLight ? spotLight.x : (roomLight ? roomLight.shadowX : 0);
  const glareDeg = spotLight ? spotLight.g : (roomLight ? roomLight.glareDeg : 112);
  sec.style.setProperty('--art-shadow-x', shadowX);
  sec.style.setProperty('--art-glare-deg', glareDeg + 'deg');
  cam.querySelectorAll('.frame-wrap, .cta-card').forEach(el=>{
    const i = Number(el.dataset.i);
    const off = i - st.index;
    const a = Math.max(-2.2, Math.min(2.2, off));
    const hidden = Math.abs(off) > 2;
    const sp = el.classList.contains('cta-card') ? null : spots[i];
    const dx = sp ? (sp.x - 50) / 100 * vw : 0;
    let dy = sp ? (sp.y - 53) / 100 * vh : 0;
    let sc = sp && sp.s ? sp.s : 1;
    if(MOBIL_YERLESIM.matches && !el.classList.contains('cta-card')){
      const y = mobilSigdir(sec, el, dy, sc); dy = y.dy; sc = y.sc;
    } else if(!el.classList.contains('cta-card')){
      const y = masaustuSigdir(sec, el, dx, dy, sc); dy = y.dy; sc = y.sc;
    }
    /* Gerçekçilik: duvarda tek eser. Aktif tablo yerinde durur;
       geçişte eski eser duvar boyunca kayarak silinir, yenisi belirir. */
    const active = off === 0;
    const tilt = ((i * 37) % 5 - 2) * .16; /* eser başına ±0.3° sabit eğim */
    /* duvardaki yatay konuma göre kalıcı hafif perspektif: kamera merkezden
       ne kadar uzaktaysa çerçeve de o kadar hafifçe o açıya döner (dümdüz
       karşıdan bakılmayan görünümlerde çerçeve de düz durmaz) */
    const perspSkew = sp ? (sp.x - 50) * .1 : 0;
    el.style.transform =
      `perspective(1150px) translate(-50%,-50%) translate(${dx}px, ${dy}px) translateX(${off * spacing * .55}px) rotateY(${-a * 8 + perspSkew}deg) rotate(${tilt}deg) scale(${active ? sc : sc * .985})`;
    el.style.zIndex = String(100 - Math.round(Math.abs(off) * 10));
    el.style.pointerEvents = active ? 'auto' : 'none';
    revealFrame(el, active); /* opacity + "önce oda, sonra eser" gecikmesi (bkz. üstteki revealFrame) */
    /* Etiket, eser ölçeğinden bağımsız okunur kalsın diye ters ölçeklenir;
       ama 1/sc serbest bırakılınca küçük ölçekli eserlerde etiket ekranda
       1.7 katına çıkıp duvarın dışına taşıyordu. Üst sınır kondu. */
    el.style.setProperty('--invsc', Math.min(MOBIL_YERLESIM.matches ? 2.7 : 1.9, 1 / (sc || 1)).toFixed(3));
  });
  fitWallLabel(sec, cam, st.index);

  /* kamera adım atarken hafifçe o yöne döner, sonra toparlanır */
  if(dir !== 0 && !reduceMotion){
    cam.style.transform = `perspective(1150px) rotateY(${dir * -2.5}deg) translateX(${dir * -16}px)`;
    clearTimeout(cam._settle);
    cam._settle = setTimeout(()=>{ cam.style.transform = 'perspective(1150px) rotateY(0deg) translateX(0px)'; }, 380);
  }

  /* fotoğraf arka planı: dizi ise crossfade, tek fotoğraf ise pan */
  const srcCfg = IMAGES.rooms[roomId];
  const photoA = sec.querySelector('.room-photo');
  const photoB = sec.querySelector('.room-photo-b');
  if(Array.isArray(srcCfg) && srcCfg.length){
    const url = odaFotoUrl(srcCfg[Math.min(st.index, srcCfg.length - 1)]);
    /* Komşu görünümleri önden yükle: kullanıcı adım değiştirdiğinde
       fotoğraf çoktan hazır olsun. */
    preloadAround(st, srcCfg);
    if(sec._bg !== url){
      sec._bg = url;
      /* Crossfade, fotoğraf İNENE KADAR başlatılmaz — eskiden atama anında
         başladığı için, boş katman açılırken bir an duvar yerine sayfa zemini
         (beyaz) görünüyordu. Yeni kare hazır olana dek eski görünüm durur. */
      preloadPhoto(url).then(()=>{
        if(sec._bg !== url) return; // bu arada başka görünüme geçildiyse iptal
        sec._flip = !sec._flip;
        const showEl = sec._flip ? photoB : photoA;
        const hideEl = sec._flip ? photoA : photoB;
        showEl.style.backgroundImage = `url('${url}')`;
        showEl.style.transform = 'scale(1.1)';
        requestAnimationFrame(()=>{
          showEl.style.opacity = '1';
          showEl.style.transform = 'scale(1.03)';
          hideEl.style.opacity = '0';
        });
      });
    }
  } else if(photoA && srcCfg){
    const p = st.count > 1 ? st.index / (st.count - 1) : 0;
    photoA.style.backgroundPosition = `${8 + p * 84}% center`;
    photoA.style.transform = `scale(1.06) translateX(${(0.5 - p) * 2}%)`;
  }
  const floor = sec.querySelector('.rf-floor');
  if(floor) floor.style.backgroundPosition = `0 0, ${-st.index * 90}px 0`;
  const win = sec.querySelector('.rf-window');
  if(win) win.style.transform = `translateX(${-st.index * 11}vw)`;

  sec.querySelector('.room-arrow.prev').disabled = st.index === 0;
  sec.querySelector('.room-arrow.next').disabled = st.index === st.count - 1;
  sec.querySelectorAll('.room-dots i').forEach((d,i)=>d.classList.toggle('on', i === st.index));
}
let activeRoom = null;
/* Scroll konumundan oda içi adımı hesapla — yumuşak geçişleri CSS animasyonları yapar */
/* Odanın idx. adımının scroll konumu (updateRooms'taki ol/frac formülünün tersi). */
function adimKonumu(roomId, idx){
  const st = roomState[roomId];
  const sec = document.getElementById(roomId);
  const clamped = Math.max(0, Math.min(st.count - 1, idx));
  const span = sec.offsetHeight - window.innerHeight;
  const ol = sec.dataset.overlap ? window.innerHeight / span : 0;
  const frac = ol + (st.count > 1 ? clamped / (st.count - 1) : 0) * (1 - ol);
  return sec.offsetTop + frac * span + 2;
}
function goTo(roomId, idx){
  window.scrollTo({ top: adimKonumu(roomId, idx), behavior: reduceMotion ? 'auto' : 'smooth' });
}
function updateRooms(){
  const vh = window.innerHeight;
  let current = activeRoom;
  let merkezde = null;   // ekran ortasında GERÇEKTEN bulunan oda (kapıdayken null)
  ROOMS.forEach(r=>{
    const sec = document.getElementById(r.id);
    const rect = sec.getBoundingClientRect();
    if(rect.top <= vh * .5 && rect.bottom >= vh * .5){ current = r.id; merkezde = r.id; }
    /* 8 odalı yapıda her scroll tikinde 8 odanın tamamını hesaplamak
       yerine, görünüm alanından belirgin şekilde uzak odaları atla
       (mobilde akıcılığı korumak için) */
    if(rect.bottom < -vh || rect.top > vh * 2) return;
    const span = sec.offsetHeight - vh;
    /* geçici bir layout anında (ör. resize sırasında) span 0 veya negatif
       ölçülürse ol/pAdj Infinity/NaN'a kayıp st.index'i kalıcı olarak
       bozabilir (NaN hiçbir zaman kendine eşit değildir) — böyle bir
       anı sessizce atla, bir sonraki tikte doğru ölçüyle düzelir */
    if(span <= 0) return;
    const p = Math.min(1, Math.max(0, -rect.top / span));
    const ol = sec.dataset.overlap ? vh / span : 0; // örtüşme oranı
    if(ol){
      const sticky = sec.querySelector('.room-sticky');
      sticky.style.opacity = String(Math.min(1, p / (ol * .85)));
    }
    const pAdj = ol ? Math.min(1, Math.max(0, (p - ol) / (1 - ol))) : p;
    const st = roomState[r.id];
    const idx = Math.round(pAdj * (st.count - 1));
    if(idx !== st.index){
      const dir = Math.sign(idx - st.index);
      st.index = idx;
      layoutRoom(r.id, dir);
    }
  });
  /* Oda ekrandayken: fiyat tazeleme + komşu odaların görselleri (bkz.
     odaYakiniHazirla). Kullanıcı odada 1.5 sn DURUNCA ve tarayıcı boştayken
     çalışır — geçiş animasyonu sırasında çalışınca kareler takılıyordu
     (ölçüldü: 52.7 → 41.6 FPS). Zamanlayıcı ayrıca, betik kurulurken
     çağrılsa bile tanım sırasından bağımsız kalmasını sağlar. */
  updateRooms.merkezde = merkezde;
  /* Turun sonuna (alt bilgi) inildiyse hiçbir oda aktif görünmez */
  if(!merkezde && ROOMS.length){
    const sonOda = document.getElementById(ROOMS[ROOMS.length - 1].id);
    if(sonOda && sonOda.getBoundingClientRect().bottom < vh * .5) current = null;
  }
  if(merkezde && merkezde !== updateRooms.hazirlanan){
    clearTimeout(updateRooms.hazirlaZaman);
    updateRooms.hazirlaZaman = setTimeout(()=>{
      if(updateRooms.merkezde !== merkezde) return;   // kullanıcı başka odaya geçti
      updateRooms.hazirlanan = merkezde;
      const calis = ()=>odaYakiniHazirla(merkezde);
      if('requestIdleCallback' in window) requestIdleCallback(calis, {timeout: 2000}); else calis();
    }, 1500);
  }
  if(current !== activeRoom){
    activeRoom = current;
    document.querySelectorAll('.bn-item').forEach(b=>b.classList.toggle('active', b.dataset.room === activeRoom));
    /* Alt çubuk taşıyorsa (mobil) aktif oda görünür alanın ortasına kayar */
    const bnNav = document.getElementById('bottomNav'), bnAktif = bnNav && bnNav.querySelector('.bn-item.active');
    if(bnAktif && bnNav.scrollWidth > bnNav.clientWidth + 2){
      bnNav.scrollTo({ left: Math.max(0, bnAktif.offsetLeft - (bnNav.clientWidth - bnAktif.offsetWidth) / 2), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    const roomIdx = ROOMS.findIndex(r=>r.id === activeRoom);
    if(roomIdx > -1){
      roomProgressEl.textContent = `${roomIdx + 1} / ${ROOMS.length}`;
      roomProgressEl.classList.add('show');
    } else {
      roomProgressEl.classList.remove('show');
    }
  }
  updateRoomHint();
}
const roomProgressEl = document.getElementById('roomProgress');
/* Odanın son ürününde ve kapanış adımında beliren, dikkat dağıtmayan
   ince mikro-ipucu — tur ortasında hiç görünmez. */
const roomHintEl = document.getElementById('roomHint');
function updateRoomHint(){
  if(!activeRoom){ roomHintEl.classList.remove('show'); return; }
  const st = roomState[activeRoom];
  if(st.index === st.count - 2){
    roomHintEl.textContent = 'Daha fazlası için kaydırın ↓';
    roomHintEl.classList.add('show');
  } else {
    roomHintEl.classList.remove('show');
  }
}
ROOMS.forEach(r=>layoutRoom(r.id));
/* Etiket oturtmasını (yalnız fitWallLabel) tekrarla — tam layoutRoom'a gerek
   yok, kamera/transform değişmiyor.
   Neden gerekli: ilk yerleşim, Playfair/Jost daha yüklenmeden yedek fontun
   metrikleriyle ölçülüyordu. Yedek font dar geldiği için "taşma yok" çıkıyor,
   etiket tercih edilen tarafta bırakılıyordu; gerçek font gelince metin
   genişliyor ve etiket duvarın dışına taşıyordu. Kullanıcı bunu şöyle
   görüyordu: eser önce yazısız gelir, sonra yazı SOLDA belirir, bir ileri-geri
   adımdan sonra (yeni layoutRoom) doğru tarafa geçer. */
function etiketleriYenidenOturt(){
  ROOMS.forEach(r=>{
    const sec = document.getElementById(r.id); if(!sec) return;
    const cam = sec.querySelector('.stage-cam'); if(!cam) return;
    const st = roomState[r.id]; if(!st) return;
    fitWallLabel(sec, cam, st.index);
  });
}
if(document.fonts && document.fonts.ready) document.fonts.ready.then(etiketleriYenidenOturt).catch(()=>{});
window.addEventListener('load', etiketleriYenidenOturt);
window.addEventListener('scroll', updateRooms, {passive:true});
window.addEventListener('resize', ()=>{ ROOMS.forEach(r=>layoutRoom(r.id)); updateRooms(); });
updateRooms();

/* ============ ODA ADIMI SNAP (ScrollTrigger) ============
   Kullanıcı iki görünüm arasında bıraktığında en yakın adıma yumuşakça
   oturur (updateRooms/goTo'daki mevcut adım hesaplama mantığıyla aynı
   ol/frac formülü). Yalnızca tam hareket modunda aktif; azaltılmış
   harekette snap yok, eski serbest-scroll davranışı aynen korunur.

   YALNIZ MASAÜSTÜ (min-width:768px): mobilde ayrı bir dokunmatik adım
   kilidi var (touchstart/touchend -> oturt, aşağıda). İkisi aynı ROOMS
   elemanı üzerinde aynı anda çalışınca çekişiyordu — GSAP en yakın adıma
   çekerken touch handler basIndex±1'e çekiyor, sonuç "bazen 2-3 atlama"
   tutarsızlığı. Mobilde adım oturtma tek otorite olarak touch handler'a
   bırakıldı. */
mm.add('(prefers-reduced-motion: no-preference) and (min-width: 768px)', () => {
  const snapTriggers = ROOMS.map(room=>{
    const sec = document.getElementById(room.id);
    return ScrollTrigger.create({
      trigger: sec,
      start: 'top top',
      end: 'bottom bottom',
      snap: {
        snapTo(value){
          const vh = window.innerHeight;
          const span = sec.offsetHeight - vh;
          const ol = sec.dataset.overlap ? vh / span : 0;
          const count = roomState[room.id].count;
          let nearest = 0, min = Infinity;
          for(let i = 0; i < count; i++){
            const pt = ol + (count > 1 ? i / (count - 1) : 0) * (1 - ol);
            const d = Math.abs(pt - value);
            if(d < min){ min = d; nearest = pt; }
          }
          return nearest;
        },
        duration: .5,
        ease: 'power2.inOut'
      }
    });
  });
  return () => snapTriggers.forEach(t=>t.kill());
});

document.querySelectorAll('.room-arrow').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    const id = btn.dataset.room;
    if(mobilMi()){ adimKomutu(id, roomState[id].index + Number(btn.dataset.dir)); return; }   // mobil: tek adım + geçiş kilidi
    goTo(id, roomState[id].index + Number(btn.dataset.dir));
  });
});
document.querySelectorAll('.room-dots i').forEach(d=>{
  d.addEventListener('click', ()=>{
    const id = d.parentElement.dataset.room;
    if(mobilMi()){ adimKomutu(id, Number(d.dataset.d)); return; }   // mobil: geçiş kilidi
    goTo(id, Number(d.dataset.d));
  });
});

/* Aktif oda scroll'dan takip ediliyor (updateRooms) */

/* Klavye */
window.addEventListener('keydown', e=>{
  if(!activeRoom) return;
  if(document.getElementById('collection').classList.contains('open')) return;
  if(e.key === 'ArrowRight') goTo(activeRoom, roomState[activeRoom].index + 1);
  if(e.key === 'ArrowLeft') goTo(activeRoom, roomState[activeRoom].index - 1);
});

/* Dokunmatik */
document.querySelectorAll('.stage').forEach(stg=>{
  let sx = 0, sy = 0;
  stg.addEventListener('touchstart', e=>{ sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, {passive:true});
  stg.addEventListener('touchend', e=>{
    if(window.matchMedia('(max-width: 767px)').matches) return;   // mobilde tek-adım kilitli jest yöneticisi (bkz. MOBİL: KAPI GİRİŞİ)
    const dx = e.changedTouches[0].clientX - sx;
    const dy = e.changedTouches[0].clientY - sy;
    if(Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)){
      const id = stg.querySelector('.stage-cam').dataset.room;
      goTo(id, roomState[id].index + (dx < 0 ? 1 : -1));
    }
  }, {passive:true});
});

/* ============ HERO: KAPIYA YÜRÜ, İÇERİ GİR ============ */
const hero = document.getElementById('hero');
const heroSticky = document.getElementById('heroSticky');
const heroPhoto = document.getElementById('heroPhoto');
const heroImg = document.getElementById('heroImg');
const heroIllu = document.getElementById('heroIllu');
const heroTitle = document.getElementById('heroTitle');
const heroHint = document.getElementById('heroHint');
const heroVignette = document.getElementById('heroVignette');
const doorBloom = document.getElementById('doorBloom');
const heroFade = document.getElementById('heroFade');
const header = document.getElementById('siteHeader');
const hiL = document.getElementById('hiL');
const hiR = document.getElementById('hiR');
const hiGlow = document.getElementById('hiGlow');

const clamp01 = v => Math.min(1, Math.max(0, v));
let targetP = 0, dispP = 0;
const heroVideo = document.getElementById('heroVideo');
/* Erken tanımlanıyor: renderHero() aşağıda hemen çağrılıyor ve bu
   değişkeni kullanıyor; const daha altta bildirilirse TDZ hatası
   tüm betiği düşürür. */
const heroCrisp = document.getElementById('heroCrisp');
/* ── GİRİŞ VİDEOSU: EKRANA GÖRE SÜRÜM ──
   Masaüstü sürümü 16:9 / 10 MB. Telefonda hem bu ağırlık fazla hem de
   16:9 bir kare dikey ekranda %26 oranında görünüyor (kenarlar kırpılıyor),
   yani eve yürüyen çekimin bağlamı kayboluyor. Bu yüzden dar ekran için
   ayrı bir DİKEY sürüm var: 810x1440, 15 fps, 3.26 MB.

   Her iki dosya da her karesi anahtar kare olacak şekilde kodlanmıştır
   (-g 1); scroll ile taranan videoda bu şart, yoksa her atlamada
   çözücü en yakın anahtar kareden başlamak zorunda kalıp takılıyor.

   Dikey sürüm henüz yüklenmemişse (cdn_entrance_video_mobil boş) dar
   ekranda kapı FOTOĞRAFI yedeği çalışmaya devam eder. */
function girisVideosu(){
  const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if(c){
    if(c.saveData) return '';   // kullanıcının açık tercihi
    /* effectiveType'a GÜVENİLMİYOR: Chrome bunu ölçtüğü RTT/hıza göre
       belirliyor ve sağlıklı masaüstü bağlantılarında bile sık sık "3g"
       bildiriyor; bir kez öyle deyince giriş videosu masaüstünde de
       kapanıyordu. Yalnızca 2g sınıfı dışlanıyor. */
    if(/^(slow-2g|2g)$/.test(c.effectiveType || '')) return '';
  }
  const dar = window.innerWidth < 768;
  if(dar) return ASSETS.entranceVideoMobil || (IMAGES.facade ? '' : IMAGES.entranceVideo || '');
  return IMAGES.entranceVideo || '';
}
const girisVideoUrl = girisVideosu();
const hasVideo = Boolean(girisVideoUrl);
/* ── GİRİŞ: KARE DİZİSİ (video yerine) ──
   Video scroll ile tarandığında her atlama bir arama (seek) demek;
   telefonda çözücü yetişemeyince görüntü donuyor, dosyanın tamamı
   inmeden de ileri sarılamıyordu. Aynı çekim artık tek tek WebP kareler
   (assets/kapi1-m-NNN.webp 900x1600, kapi1-d-NNN.webp 1280x720; 15 fps,
   150'şer kare) ve bir <canvas>'a çiziliyor.
   İndirme sırası: 1. kare, son kare ve her 10. kare (bunları bölümdeki
   satır içi betik sayfa ayrıştırılırken çoktan istemiş olur; sahne
   baştan sona kaydırılabilir) → her 5. kare → kalanlar; kaydırılan yerin hemen önündeki eksik
   kareler sırayı keser. Henüz hazır olmayan bir kareye gelinirse EN
   YAKIN hazır kare çizilir; canvas hiç temizlenmediği için boş kare olmaz.
   ÇÖZME: kareler createImageBitmap ile arka planda çözülür. <img>'i
   doğrudan canvas'a çizmek her karede ana iş parçacığında çözme demekti
   (4x yavaş telefonda kare başı ~60 ms, kaydırma takılıyordu). Yalnız
   bulunulan yerin çevresindeki ~12 kare çözülmüş tutulur (+ ilk ve son
   kare); uzaklaşanlar bırakılır, telefon belleği 150 açık kareyle dolmaz.
   Dosya adlarındaki "kapi1" sürümdür: kareler değişirse kapi2 olarak
   yüklenir (adresler 1 yıl önbellekte kalır).
   Kare tanımı yoksa ya da tarayıcı createImageBitmap bilmiyorsa video
   yolu aynen çalışır.
   BİÇİM YEDEĞİ: Shopify CDN karelerin biçimini tarayıcıya göre seçiyor;
   iOS 14–17 Safari'ye WebP yerine ~5 kat büyük JPEG gönderiyor (150 kare
   ≈ 13,5 MB). 1. karenin gerçekte hangi biçimde geldiğine bakılır: WebP
   değilse kare yolu bırakılır ve o cihazlarda bugünkü video çalışır
   (tarayıcı adı tahmin edilmez; CDN'in kararı ne olursa ona uyulur). */
const kareSeti = (() => {
  const K = window.sumerKapiKareleri;
  if(!hasVideo || !K || !window.createImageBitmap || !window.fetch) return null;
  const s = window.innerWidth < 768 ? K.mobil : K.masaustu;
  return (s && s.ilk && s.adet && !s.bicimYok) ? s : null;
})();
const webpMi = r => /image\/webp/.test(r.headers.get('content-type') || '');
function kareDizisiKur(set, vazgecince){
  const canvas = document.getElementById('heroKare');
  if(!canvas) return null;
  const N = set.adet;
  canvas.width = set.en;
  canvas.height = set.boy;
  const ctx = canvas.getContext('2d', { alpha: false });
  const kok = set.ilk.split('?')[0];
  const url = i => i === 0 ? set.ilk : kok.replace(/-001\.webp$/, '-' + String(i + 1).padStart(3, '0') + '.webp');
  /* Accept ŞART: Shopify CDN biçimi Accept'e göre seçiyor; fetch'in varsayılanı
     ("her tür") ile WebP yerine ~5 kat büyük JPEG gönderiyordu. */
  const indir = (i, oncelik) => fetch(url(i), { priority: oncelik, headers: { Accept: 'image/webp' } }).then(r => {
    if(!r.ok) throw new Error(r.status);
    if(!webpMi(r)) throw new Error('bicim');
    return r.blob();
  });
  const bicimHatasi = e => e && e.message === 'bicim';
  let bitti = false;   // kare yolundan vazgeçildi (bkz. vazgec)
  const veri = new Array(N).fill(null);   // inmiş dosya (Blob)
  const bmp = new Array(N).fill(null);    // çözülmüş kare (ImageBitmap)
  const durum = new Uint8Array(N);        // 0 yok · 1 iniyor · 2 indi · 3 hata
  const cozum = new Uint8Array(N);        // 0 yok · 1 çözülüyor · 2 hazır
  let istenen = 0, cizilen = -1, yon = 1, aktif = 0, inen = 0, cozAktif = 0;
  const ONDE = 8, ARKADA = 3, TUT = 12;   // çözülmüş tutulan pencere
  const sira = [], sirada = new Set();
  const ekle = i => { if(i >= 0 && i < N && !sirada.has(i)){ sirada.add(i); sira.push(i); } };
  ekle(0); ekle(N - 1);
  for(let i = 10; i < N; i += 10) ekle(i);
  for(let i = 5; i < N; i += 5) ekle(i);
  for(let i = 0; i < N; i++) ekle(i);
  const kaba = sira.slice(0, 2 + Math.floor((N - 1) / 10));   // 0, son ve her 10. kare
  let siraPtr = 0;
  /* Performans (28.10): ziyaretçi kaydırmadan önce aynı anda en fazla 2 kare iner (ilk saniyelerde CSS, yazı tipi
     ve başlık bant genişliğini karelerle paylaşmasın); ilk kaydırmada ya da yüklemeden 4 sn sonra 8'e çıkar. */
  let serbest = false;
  const serbestBirak = () => { if(serbest || bitti) return; serbest = true; pompala(); };
  if(document.readyState === 'complete') setTimeout(serbestBirak, 4000);
  else window.addEventListener('load', () => setTimeout(serbestBirak, 4000), { once: true });
  function enYakin(i, uygun){
    for(let d = 0; d < N; d++){
      if(i - d >= 0 && uygun(i - d)) return i - d;
      if(i + d < N && uygun(i + d)) return i + d;
    }
    return -1;
  }
  function sonraki(){
    for(let d = 0; d <= 6; d++){
      const i = istenen + d * yon;
      if(i >= 0 && i < N && durum[i] === 0) return i;
    }
    while(siraPtr < sira.length && durum[sira[siraPtr]] !== 0) siraPtr++;
    return siraPtr < sira.length ? sira[siraPtr] : -1;
  }
  function baslat(i, p){
    durum[i] = 1; aktif++;
    p.then(b => {
      aktif--; durum[i] = 2; veri[i] = b; inen++;
      if(bitti) return;
      canvas.dataset.hazir = inen;
      if(!canvas.dataset.kaba && kaba.every(k => durum[k] === 2)) canvas.dataset.kaba = '1';
      pencere(); pompala();
    }, e => { aktif--; durum[i] = 3; if(bicimHatasi(e)) vazgec(); else pompala(); });
  }
  function pompala(){
    while(!bitti && aktif < (serbest ? 8 : 2)){
      const i = sonraki();
      if(i < 0) return;
      baslat(i, indir(i, (i % 10 && i !== N - 1) ? 'low' : 'auto'));
    }
  }
  function coz(i){
    cozum[i] = 1; cozAktif++;
    createImageBitmap(veri[i]).then(b => {
      cozAktif--;
      if(bitti){ b.close(); return; }
      bmp[i] = b; cozum[i] = 2;
      if(cizilen < 0 || Math.abs(i - istenen) < Math.abs(cizilen - istenen)) ciz();
      pencere();
    }, () => { cozAktif--; cozum[i] = 0; durum[i] = 3; pencere(); });
  }
  function pencere(){
    const hedef = [enYakin(istenen, k => durum[k] === 2), 0, N - 1];
    for(let d = 0; d <= ONDE; d++) hedef.push(istenen + d * yon);
    for(let d = 1; d <= ARKADA; d++) hedef.push(istenen - d * yon);
    for(const i of hedef){
      if(cozAktif >= 3) break;
      if(i >= 0 && i < N && durum[i] === 2 && !cozum[i]) coz(i);
    }
    for(let i = 1; i < N - 1; i++){
      if(bmp[i] && Math.abs(i - istenen) > TUT && i !== cizilen){ bmp[i].close(); bmp[i] = null; cozum[i] = 0; }
    }
  }
  function ciz(){
    if(bitti) return;
    const k = enYakin(istenen, i => cozum[i] === 2);
    if(k < 0 || k === cizilen) return;
    ctx.drawImage(bmp[k], 0, 0, canvas.width, canvas.height);
    cizilen = k;
    canvas.dataset.kare = k;
    if(!canvas.classList.contains('cizildi')) canvas.classList.add('cizildi');
  }
  function vazgec(){
    if(bitti) return;
    bitti = true;
    for(let i = 0; i < N; i++) if(bmp[i]){ bmp[i].close(); bmp[i] = null; }
    vazgecince();
  }
  /* Önce 1. karenin biçimi kesinleşir (satır içi betik bakar), sonra
     satır içi betiğin sayfa ayrıştırılırken istediği kareler (1. kare +
     kaba geçiş) devralınır; biri ağ yüzünden düştüyse yeniden istenir. */
  /* Satır içi ön-yükleme yoksa (kapıyı atlayan derin bağlantıdan sonra kurulum) biçime
     önce yalnız 1. kareyle bakılır: WebP gelmeyen cihazda 8 kare birden istenmesin. */
  if(!set.ilkBicim){
    const ilk = fetch(url(0), { priority: 'high', headers: { Accept: 'image/webp' } });
    set.ilkBicim = ilk.then(r => !r.ok || webpMi(r), () => true);
    set.onVeri = { 0: ilk.then(r => { if(!r.ok) throw new Error(r.status); if(!webpMi(r)) throw new Error('bicim'); return r.blob(); }) };
    set.onVeri[0].catch(() => {});
  }
  (set.ilkBicim || Promise.resolve(true)).then(ok => {
    if(!ok) return vazgec();
    const onVeri = set.onVeri || {};
    for(const k in onVeri){ const i = +k; baslat(i, onVeri[k].catch(e => bicimHatasi(e) ? Promise.reject(e) : indir(i, 'auto'))); }
    pompala();
  });
  return {
    git(oran){
      const i = Math.round(clamp01(oran) * (N - 1));
      if(i !== istenen){
        if(i > 0) serbest = true;
        yon = i > istenen ? 1 : -1;
        istenen = i;
        canvas.dataset.istenen = i;
        pencere();
        pompala();
      }
      ciz();
    }
  };
}
/* Kare yolu kullanılmıyorsa (ya da sonradan bırakılırsa) ilk-kare görseli
   kalmasın; satır içi betik de artık göstermesin. */
function ilkKareGorseliniKaldir(){
  if(window.sumerKapiKareleri) window.sumerKapiKareleri.iptal = true;
  const im = document.getElementById('heroKareIlk');
  if(im && im.getAttribute('src')){ URL.revokeObjectURL(im.src); im.removeAttribute('src'); }
}
/* ════════ KAPI MEDYASI NE ZAMAN İNER ════════
   - Kare dizisi (WebP destekleyen tarayıcılar): kapı ekranıyla açılışta.
   - Video yalnız kare yolu kullanılamayan cihazda (ör. iOS 14–17 Safari: CDN
     WebP göndermiyor) ve ancak İLK ETKİLEŞİMDE (dokunma/kaydırma/tuş) iner;
     o ana kadar yalnız afiş görseli görünür. Eskiden bu cihazlarda 3,4 MB'lık
     video, sayfa açılır açılmaz preload=auto ile tamamen iniyordu.
   - Kapıyı ATLAYAN derin bağlantılarda (?koleksiyon=, ?urun=, ?oda= — ör. reklam
     linki) ne kare ne video iner; ziyaretçi kapıya geri dönerse o anda kurulur. */
const KAPI_ATLANDI = (() => { const q = new URLSearchParams(location.search); return ['koleksiyon', 'urun', 'oda'].some(k => q.has(k)); })();
let kareDizisi = null, kapiMedyasiKuruldu = false;
function kapiMedyasiniKur(){
  if(kapiMedyasiKuruldu) return;
  kapiMedyasiKuruldu = true;
  kareDizisi = kareSeti ? kareDizisiKur(kareSeti, () => {
    /* Biçim yedeği: kareler WebP gelmiyor → videoya geç (ilk etkileşimde iner) */
    kareDizisi = null;
    hero.classList.remove('has-kare');
    ilkKareGorseliniKaldir();
    videoyuGerekinceKur();
  }) : null;
  if(kareDizisi) hero.classList.add('has-kare');
  else ilkKareGorseliniKaldir();
  if(hasVideo && !kareDizisi) videoyuGerekinceKur();
}
let videoBekliyor = false;
function videoyuGerekinceKur(){
  if(videoBekliyor || heroVideo.getAttribute('src')) return;
  videoBekliyor = true;
  if(IMAGES.facade) heroVideo.poster = IMAGES.facade;
  const olaylar = ['pointerdown', 'touchstart', 'wheel', 'keydown', 'scroll'];
  const tetik = () => { olaylar.forEach(o => window.removeEventListener(o, tetik, true)); videoyuKur(); };
  olaylar.forEach(o => window.addEventListener(o, tetik, { capture: true, passive: true }));
}
if(hasVideo){
  hero.classList.add('has-video');
  hero.classList.remove('no-photo');
}
if(!KAPI_ATLANDI) kapiMedyasiniKur();
else {
  /* Derin bağlantı sayfayı odaya taşıdıktan sonra: ziyaretçi o konumdan YUKARI,
     kapıya doğru kaydırırsa medya kurulur. */
  setTimeout(() => {
    const y0 = window.scrollY;
    const bak = () => {
      if(kapiMedyasiKuruldu){ window.removeEventListener('scroll', bak); return; }
      if(window.scrollY < y0 - 40 && hero.getBoundingClientRect().bottom > -window.innerHeight){
        window.removeEventListener('scroll', bak); kapiMedyasiniKur();
      }
    };
    window.addEventListener('scroll', bak, { passive: true });
  }, 1500);
}
function videoyuKur(){
  if(IMAGES.facade) heroVideo.poster = IMAGES.facade;
  /* preload=auto ŞART: video scroll ile taranıyor, yani rastgele
     zamanlara atlanıyor. metadata ile yalnızca ilk 0.17 saniye
     tamponlanıyordu; her atlama indirilmemiş bir aralığa denk gelip
     range isteği tetikliyor ve ilk turda gözle görülür donmalar oluyordu
     (ikinci turda dosya önbellekte olduğu için sorun görünmüyordu).
     Video kullanılmayacaksa src hiç atanmadığı için dosyaya
     dokunulmuyor (markup'ta preload=none). */
  heroVideo.preload = 'auto';
  heroVideo.src = girisVideoUrl;
  heroVideo.load();
}
if(hasVideo){
  /* Net giriş karesi (bkz. .hero-crisp): en tepede posteri video
     üzerinde tutar, kaydırınca kaybolur.
     YALNIZCA masaüstü (yatay) videoda: poster 1920x1080 yatay bir
     fotoğraf; dikey mobil videonun kadrajıyla uyuşmaz, mobilde
     kullanılırsa kaydırma başlarken görüntü sıçrar. Zaten sorun da
     videonun geniş ekranda büyütülmesinden çıkıyor. */
  if(IMAGES.facade && girisVideoUrl === IMAGES.entranceVideo){
    heroCrisp.src = IMAGES.facade;
  }
}
const hasFacade = Boolean(IMAGES.facade);
const photoBox = document.getElementById('photoBox');
const leafPersp = document.getElementById('leafPersp');
const fakeLeaf = document.getElementById('fakeLeaf');
/* Fotoğraftaki kapı aralığını örten "kapalı kanat" kutusu (görsel yüzdesi) */
const LEAF_BOX = { l:50.03, t:30.46, w:9.25, h:50.87 };
if(hasFacade){
  leafPersp.style.left = LEAF_BOX.l + '%';
  leafPersp.style.top = LEAF_BOX.t + '%';
  leafPersp.style.width = LEAF_BOX.w + '%';
  leafPersp.style.height = LEAF_BOX.h + '%';
  fakeLeaf.src = LEAF_B64;
}
/* facadeDoor FOTOĞRAF yüzdesidir; cover kırpması nedeniyle ekran yüzdesine çevrilir */
let doorVX = IMAGES.facadeDoor.x, doorVY = IMAGES.facadeDoor.y;
function updateDoorTarget(){
  if(hasFacade && heroImg.naturalWidth){
    const vw = window.innerWidth, vh = window.innerHeight;
    const iw = heroImg.naturalWidth, ih = heroImg.naturalHeight;
    const sc = Math.max(vw/iw, vh/ih);
    const dw = iw*sc, dh = ih*sc;
    const ox = (vw - dw)/2, oy = (vh - dh)/2;
    doorVX = (ox + IMAGES.facadeDoor.x/100 * dw) / vw * 100;
    doorVY = (oy + IMAGES.facadeDoor.y/100 * dh) / vh * 100;
    photoBox.style.left = ox + 'px';
    photoBox.style.top = oy + 'px';
    photoBox.style.width = dw + 'px';
    photoBox.style.height = dh + 'px';
  }
  document.documentElement.style.setProperty('--door-x', doorVX + '%');
  document.documentElement.style.setProperty('--door-y', doorVY + '%');
  renderHero();
}
if(hasFacade){
  hero.classList.remove('no-photo');
  heroImg.addEventListener('load', updateDoorTarget);
  heroImg.src = IMAGES.facade;
}
if(!hasVideo && !hasFacade) hero.classList.add('no-photo');
window.addEventListener('resize', updateDoorTarget);
updateDoorTarget();

/* Kapıdan girince ilk odanın görüntüsüne açıl */
const salonCfg = IMAGES.rooms.salon;
const salonFirst = Array.isArray(salonCfg) ? salonCfg[0] : salonCfg;
/* heroFade yalnız videosuz yedek modda (render) görünür; video modunda opaklığı
   hep 0. Eskiden her ziyarette ham boyutlu fotoğraf (772 KB) boşuna iniyordu. */
if(salonFirst){
  if(!hasVideo) heroFade.style.backgroundImage = `url('${odaFotoUrl(salonFirst)}')`;
} else {
  heroFade.style.background = 'radial-gradient(ellipse at 50% 55%, #4A3826 0%, #241A10 55%, #0E0906 100%)';
}

function heroProgress(){
  const rect = hero.getBoundingClientRect();
  const total = hero.offsetHeight - window.innerHeight;
  return Math.min(1, Math.max(0, -rect.top / total));
}

/* Sahne koreografisi (yalnızca video yokken — facade/illüstrasyon modu):
   0.00–0.30  kapıya yürüyüş (kapı kapalı)
   0.26–0.62  kanat menteşesinden içeri doğru açılır, ışık sızar
   0.55–0.90  eşiğe hızlanarak yaklaşma, kenarlar kararır
   0.90–1.00  eşikten içeri — odaya açılış                     */
function render(p){
  const zoomTarget = hasFacade ? heroPhoto : heroIllu;
  if(!reduceMotion){
    const s = 1 + Math.pow(p, 1.08) * (hasFacade ? 7.2 : 3.2);
    zoomTarget.style.transformOrigin = `${doorVX}% ${doorVY}%`;
    zoomTarget.style.transform = `scale(${s})`;

    const open = clamp01((p - .26) / .36);
    if(hasFacade && fakeLeaf){
      fakeLeaf.style.transform = `rotateY(${-open * 104}deg)`;
      fakeLeaf.style.filter = `brightness(${1 - open * .3})`;
      fakeLeaf.style.opacity = String(open > .9 ? 1 - (open - .9) / .1 : 1);
    }
    if(!hasFacade){
      hiL.style.transform = `rotateY(${-open * 108}deg)`;
      hiR.style.transform = `rotateY(${open * 108}deg)`;
      hiGlow.style.opacity = String(open);
    }

    doorBloom.style.opacity = String(clamp01(open * .6 + Math.max(0, p - .55) * 1.3));
    heroVignette.style.opacity = String(Math.min(1, p * 1.4 + Math.max(0, p - .8) * 3));

    const f = clamp01((p - .9) / .1);
    heroFade.style.opacity = String(f);
    heroFade.style.transform = `scale(${1.14 - f * .14})`;

    heroTitle.style.opacity = String(1 - clamp01(p / .25));
    heroTitle.style.transform = `translateY(${-p * 70}px)`;
  } else {
    const inside = p > .85;
    const openR = p > .35;
    heroFade.style.opacity = inside ? 1 : 0;
    heroTitle.style.opacity = inside ? 0 : 1;
    if(hasFacade && fakeLeaf) fakeLeaf.style.opacity = openR ? 0 : 1;
    if(!hasFacade){
      hiL.style.transform = openR ? 'rotateY(-108deg)' : '';
      hiR.style.transform = openR ? 'rotateY(108deg)' : '';
      hiGlow.style.opacity = openR ? 1 : 0;
    }
  }
}
function renderHero(){
  targetP = heroProgress();
  heroHint.style.opacity = targetP > .04 ? 0 : 1;
  header.classList.toggle('scrolled', window.scrollY > 40);
  /* Net giriş karesi: en tepede poster (1920x1080, net), kaydırma
     başlayınca video devralır. GSAP onUpdate yerine SCROLL olayından
     sürülüyor — onUpdate rAF'a bağlı; rAF gecikir ya da durursa katman
     videonun üstünde asılı kalıp girişi donuk fotoğrafa çevirirdi. */
  if(heroCrisp && heroCrisp.src) heroCrisp.style.opacity = String(1 - clamp01(targetP / .035));
  if(hasVideo) return; /* video modunda ilerlemeyi aşağıdaki ScrollTrigger yönetir */
  if(reduceMotion) render(targetP);
}
window.addEventListener('scroll', renderHero, {passive:true});
window.addEventListener('resize', renderHero);
renderHero();
/* Yumuşatılmış kamera (yalnızca video yokken): scroll hedefe, kamera hedefi süzülerek takip eder */
if(!hasVideo){
  if(!reduceMotion){
    (function tick(){
      dispP += (targetP - dispP) * .13;
      if(Math.abs(targetP - dispP) < .0004) dispP = targetP;
      render(dispP);
      requestAnimationFrame(tick);
    })();
  } else {
    render(targetP);
  }
}

/* ============ HERO VİDEO TARAMA — GSAP ScrollTrigger ============
   Eski targetP/dispP lerp döngüsünün (0.13 faktörlü) yerini alır.
   %0–88 video taranır (tam hareket: scrub 0.4 ile yumuşatılmış; azaltılmış
   harekette scrub:true ile anlık/1:1). %88–100 diliminde video son
   karesinde durur ve salon sahnesi kendi opaklık geçişiyle üzerine açılır
   — bu davranış updateRooms'taki data-overlap/ol mantığında yaşıyor ve
   hiç değişmedi. */
if(hasVideo){
  function heroVideoScrub(reduced){
    const heroScrub = { p: 0 };
    let lastVideoT = -1;
    return gsap.timeline({
      /* scrub = videonun scroll'u yakalama gecikmesi. Masaüstünde fare
         tekeri küçük/sık darbeler verir, 0.4 yumuşak bir his verir. Mobilde
         ise parmakla büyük/hızlı kaydırma yapılıyor; 0.4 ile video scroll'un
         çok gerisinde kalıp "takılma" hissi yaratıyordu. Mobilde 0.12: video
         scroll'u neredeyse anında takip eder, arama eşiğiyle (0.13sn) birlikte
         akıcı kalır. */
      /* start/end SAYI olarak (sayfa düzeninden; kaydırma konumundan bağımsız).
         'top top' / 'bottom bottom' ile ScrollTrigger bölümü her yenilemede
         (sayfa yüklenmesi bitince, boyut değişince) yeniden ölçüyordu; bu
         yenileme parmakla kaydırma sürerken denk gelirse başlangıç yanlış
         ölçülüp (ör. 0 yerine -1236) kalıyor ve sayfa en tepedeyken bile
         kapı sahnesi yarıdaki karede donuyordu (canlıdaki videoda da). */
      scrollTrigger: { trigger: hero, start: () => hero.offsetTop, end: () => hero.offsetTop + hero.offsetHeight - window.innerHeight, scrub: reduced ? true : (window.innerWidth < 768 ? 0.12 : 0.4) }
    }).to(heroScrub, {
      p: 1,
      ease: 'none',
      onUpdate(){
        const p = heroScrub.p;
        if(kareDizisi){
          kareDizisi.git(p / .88);   /* %88'den sonra son karede durur (videodaki gibi) */
        } else if(heroVideo.duration){
          const t = clamp01(p / .88) * Math.max(0, heroVideo.duration - .05);
          /* Arama eşiği: mobil sürüm 15 fps, yani 1/15 sn'den sık arama
             yapmak boşa iş — telefonun kod çözücüsünü yorup taramayı
             takıyordu. Masaüstünde (30 fps) eski eşik korunuyor. */
          /* 15 fps kaynakta ~2 karede bir arama yeter; daha sık arama
             telefonun kod çözücüsünü yorup taramayı takıyordu. */
          const esik = window.innerWidth < 768 ? 0.13 : 0.02;
          if(Math.abs(t - lastVideoT) > esik){
            lastVideoT = t;
            try{ heroVideo.currentTime = t; }catch(err){}
          }
        }
        heroVignette.style.opacity = '0';
        heroFade.style.opacity = '0';
        heroTitle.style.opacity = String(1 - clamp01(p / .25));
        heroTitle.style.transform = `translateY(${-p * 70}px)`;
      }
    });
  }
  mm.add('(prefers-reduced-motion: no-preference)', () => {
    const tl = heroVideoScrub(false);
    return () => tl.scrollTrigger && tl.scrollTrigger.kill();
  });
  mm.add('(prefers-reduced-motion: reduce)', () => {
    const tl = heroVideoScrub(true);
    return () => tl.scrollTrigger && tl.scrollTrigger.kill();
  });
}

/* Odaya atlarken bölümün EN TEPESİNE gidiliyordu; orası henüz 1. adımın
   kurulmadığı giriş bölgesi olduğu için kimi odada boş duvar, kimi odada
   önceki adımdan kalan yarı saydam etiket görünüyordu. Artık 1. eserin
   scroll konumu hesaplanıp oraya gidiliyor ve durum ÖNCEDEN kuruluyor.
   Atlama anlık: yumuşak kaydırmada aradaki her kare ayrı bir adım gibi
   render edilip bozuk görüntüler oluşuyordu. */
/* Dar ekran testi tek yerde. Anlık olarak sorulur (medya sorgusu sabit
   değil): cihaz döndürüldüğünde de doğru cevabı verir. */
function mobilMi(){ return window.matchMedia('(max-width: 767px)').matches; }
/* adim: odanın kaçıncı eserinde durulacağı (varsayılan 0 = oda başı).
   ?urun= derin bağlantısı duvardaki eserin kendi adımına iner. */
function goToRoomStart(roomId, anlik, adim){
  const sec = document.getElementById(roomId);
  const st = roomState[roomId];
  if(!sec || !st) return;
  const vh = window.innerHeight;
  const span = sec.offsetHeight - vh;
  if(span <= 0){ sec.scrollIntoView(); return; }
  const idx = Math.max(0, Math.min(st.count - 1, Number(adim) || 0));
  const ol = sec.dataset.overlap ? vh / span : 0;         // örtüşme payı (bkz. updateRooms)
  /* adımın ortasına biraz içeride (son adımda geriye doğru) */
  const frac = st.count > 1 ? (idx + (idx > 0 && idx === st.count - 1 ? -0.25 : 0.25)) / (st.count - 1) : 0;
  const p = ol + frac * (1 - ol);
  const hedef = Math.round(sec.getBoundingClientRect().top + window.scrollY + p * span);
  st.index = idx;
  layoutRoom(roomId, 0);
  /* Eser belirme/silinme animasyonu 0.6sn'lik bir tween; atlama anında
     beklenirse odaya boş duvarla ya da önceki adımdan kalan yarı saydam
     etiketle giriliyor. Atlamaya özel olarak anında sabitleniyor
     (overwrite: çalışan tween iptal edilir). */
  sec.querySelectorAll('.frame-wrap, .cta-card').forEach(el=>{
    const aktif = Number(el.dataset.i) === idx;
    if(window.gsap) gsap.set(el, { opacity: aktif ? 1 : 0, overwrite: 'auto' });
    else el.style.opacity = aktif ? '1' : '0';
  });
  /* MOBİLDE ANLIK. Dikkat: CSS'te html{scroll-behavior:smooth} var ve
     spec gereği behavior:'auto' CSS DEĞERİNE düşer — yani 'auto' burada
     smooth demek oluyordu ve alt navigasyondan odaya geçerken uzun bir
     kayma animasyonu görünüyordu. 'instant' bunu bypass eder.
     Masaüstünde mevcut (yumuşak) davranış korunuyor. */
  /* anlik: derin bağlantıyla gelişte masaüstünde de anında (kapıdan odaya uzun kayma olmasın) */
  window.scrollTo({ top: hedef, behavior: (anlik || mobilMi()) ? 'instant' : 'auto' });
  /* Kaydırma sonrası bir tik daha: tarayıcı konumu yuvarlarsa da
     0. adım kesin olarak yerine otursun. */
  setTimeout(()=>{ st.index = idx; layoutRoom(roomId, 0); }, 60);
}
/* ============ ALT NAV ============ */
const bottomNav = document.getElementById('bottomNav');
ROOMS.forEach(r=>{
  const b = document.createElement('button');
  b.className = 'bn-item';
  b.dataset.room = r.id;
  b.innerHTML = `<span class="bn-ico">${r.ico}</span><span class="bn-ad">${r.name}</span>`;
  b.addEventListener('click', ()=>{ closeCollection(); goToRoomStart(r.id); });
  bottomNav.appendChild(b);
});

/* ============ TUR SONU KAPANIŞ SAHNESİ ============ */
const tourEndGrid = document.getElementById('tourEndGrid');
/* Fotoğraflı oda kartları: odanın ilk duvar fotoğrafı (küçük boyutta) + sıra no +
   ad + tasarım sayısı. Fotoğraf yalnız kart ekrana yaklaşınca yüklenir (loading=lazy). */
function kartFotoUrl(src, genislik){
  if(!src || typeof src !== 'string' || src.startsWith('data:')) return src || '';
  try{
    const u = new URL(src, location.href);
    if(u.pathname.includes('/cdn/shop/') || u.hostname.endsWith('shopify.com')) u.searchParams.set('width', String(genislik));
    return u.toString();
  }catch(e){ return src; }
}
ROOMS.forEach((r, sira)=>{
  const kaynak = IMAGES.rooms[r.id];
  const foto = kartFotoUrl(Array.isArray(kaynak) ? kaynak[0] : kaynak, 640);
  const adet = roomItems(r.id).length + (Number(r.extra) || 0);
  const b = document.createElement('button');
  b.className = 'tour-end-card' + (foto ? ' has-foto' : '');
  b.type = 'button';
  b.innerHTML = `${foto ? `<img class="te-foto" src="${foto}" alt="" loading="lazy" decoding="async">` : ''}`
    + `<span class="te-govde"><span class="te-no">${String(sira + 1).padStart(2, '0')}</span>`
    + `<span class="te-name">${r.name}</span>`
    + `${adet ? `<span class="te-sayi">${adet} tasarım <span aria-hidden="true">→</span></span>` : ''}</span>`;
  b.setAttribute('aria-label', `${r.name}${adet ? `, ${adet} tasarım` : ''}`);
  b.addEventListener('click', ()=>openCollection(r.id));
  tourEndGrid.appendChild(b);
});

/* ============ KOLEKSİYON ============ */
const collection = document.getElementById('collection');
const colGrid = document.getElementById('colGrid');
const colTitle = document.getElementById('colTitle');
const colDesc = document.getElementById('colDesc');

/* ROOMS DIŞI kategoriler: duvar sahnesi yok, yalnız hamburger menüden
   openCollection() ile açılan bir koleksiyon overlay'i. ROOMS'a EKLENMEDİ
   çünkü ROOMS 9 ayrı yerde (duvar sahnesi kurulumu, layoutRoom, kaydırma
   snap noktaları, alt navigasyon vb.) kullanılıyor — oraya eklemek bu
   kategoriyi de yanlışlıkla duvara/alt nav'a sızdırma riski taşırdı.
   Bunun yerine catData() burada ayrıca bakıyor; roomItems()/roomRemaining()
   zaten yalnız PRODUCT_DATA[id]'ye göre çalıştığı için (ROOMS'a bağımlı
   değil) bu obje bir ROOMS elemanıyla aynı şekilde davranabiliyor. */
const MENU_EK_KATEGORI = [
  {
    id: 'digerUrunler',
    name: 'Çerçeveler ve Diğer Ürünler',
    desc: 'Oda temalarına uymayan çerçeve ve aksesuar ürünleri',
    get extra(){ return roomRemaining('digerUrunler'); },
    get items(){ return roomItems('digerUrunler'); }
  }
];
function catData(catId){
  const room = ROOMS.find(r=>r.id === catId) || MENU_EK_KATEGORI.find(r=>r.id === catId);
  return {name:room.name, desc:room.desc, style:room.id, base:room.items, total: room.items.length + remainingCount(room)};
}
/* ============ ODAK YÖNETİMİ (panel aç/kapat) ============
   Koleksiyon, ürün modali, sepet ve menü açıldığında odağı içeri
   taşır; kapandığında tetikleyen elemana geri döndürür. */
let lastFocusedEl = null;
/* Kart üretimi tek yerde: hem gerçek koleksiyon ürünleri hem temsili
   kartlar aynı görünümü kullanır. */
/* ════════ KOLEKSİYON IZGARASI: YANA TAŞAN PARÇA ════════
   Taşan parça yana uzanan kartlarda (Patiler'in pençesi, Dokunuş'un eli)
   parça ya ekran kenarına ya da yandaki karta çarpabilir. Çarpmıyorsa karta
   dokunulmaz: görsel kartı tam doldurur, parça sütun arasındaki boşluğa uzanır.
   Çarpıyorsa kart, aynı satırdaki (yana taşmayan) komşusuyla yer değiştirir;
   böylece parça sütun arasına düşer. O da yetmezse son çare olarak poster
   daraltılır (.kart-ov-dar). 2. turda daraltma her yana taşan karta
   uygulanıyordu; sol sütundaki Dokunuş gereksiz yere daralıp eli yarım kalıyordu. */
let kartTasmaZaman = null;
function kartTasmaPlanla(){ clearTimeout(kartTasmaZaman); kartTasmaZaman = setTimeout(kartTasmaDuzenle, 120); }
function kartTasmaDuzenle(){
  const kartlar = [...colGrid.querySelectorAll(':scope > .card')];
  if(!kartlar.length || !colGrid.offsetWidth) return;   // ızgara görünmüyorken ölçülmez (ResizeObserver yeniden çağırır)
  kartlar.forEach((k, i)=>{ if(!k.style.order) k.style.order = String(i); });
  const vw = document.documentElement.clientWidth, PAY = 4;
  const yanTasan = k => { const y = k.querySelector('.kart-gorsel-sar')?.dataset.ovYon; return y === 'sag' || y === 'sol'; };
  const ayniSatir = (a, b) => Math.abs(a.offsetTop - b.offsetTop) < 4;
  /* yön tarafındaki en yakın komşu (aynı satır) */
  const komsuBul = (k, yon) => kartlar.filter(x => x !== k && ayniSatir(x, k) && (yon === 'sag' ? x.offsetLeft > k.offsetLeft : x.offsetLeft < k.offsetLeft))
    .sort((a, b) => Math.abs(a.offsetLeft - k.offsetLeft) - Math.abs(b.offsetLeft - k.offsetLeft))[0] || null;
  for(const k of kartlar){
    const sar = k.querySelector('.kart-gorsel-sar'), ov = k.querySelector('.art-overflow');
    const yon = sar && sar.dataset.ovYon;
    if(!ov || (yon !== 'sag' && yon !== 'sol') || !ov.classList.contains('ov-ready') || sar.classList.contains('kart-ov-dar')) continue;
    const r = ov.getBoundingClientRect(); if(!r.width) continue;
    const engel = komsuBul(k, yon);
    const sinir = yon === 'sag' ? (engel ? engel.getBoundingClientRect().left - PAY : vw - PAY)
                                : (engel ? engel.getBoundingClientRect().right + PAY : PAY);
    const carpiyor = yon === 'sag' ? r.right > sinir : r.left < sinir;
    if(!carpiyor) continue;
    /* Yer değiştir: taşmanın TERS yanındaki komşu (yana taşmayan) — parça sütun arasına düşer */
    const takas = komsuBul(k, yon === 'sag' ? 'sol' : 'sag');
    if(!k.dataset.takas && takas && !yanTasan(takas)){
      const o = k.style.order; k.style.order = takas.style.order; takas.style.order = o;
      k.dataset.takas = '1';
      kartTasmaPlanla();   // yeni yerinde yeniden ölç (sütun arası dar ise daraltmaya düşer)
      return;
    }
    sar.classList.add('kart-ov-dar', 'kart-ov-' + yon);
  }
}
if('ResizeObserver' in window) new ResizeObserver(kartTasmaPlanla).observe(colGrid);
function koleksiyonKartiEkle(veri, i){
  /* Bu karttan açılan modal ÜRÜN LİSTESİNDEN geliyor: görsel mağazanın
     mockup çekimi, üstüne kendi çerçevemizi çizmeyeceğiz
     (bkz. cerceveliGosterim). */
  veri.listeden = true;
  const card = document.createElement('button');
  card.className = 'card';
  card.type = 'button';
  card.setAttribute('aria-label', `${veri.kisa || veri.name} — ${fmt(veri.price)}'den, incele`);
  card.style.transitionDelay = `${.15 + i * .04}s`;
  card.innerHTML = `
    <img class="card-img" loading="lazy" decoding="async" src="${veri.src}" alt="">
    <div class="card-body">
      <h4></h4>
      <div class="card-price">${veri.old ? `<s class="card-old">${fmt(veri.old)}</s> ` : ''}${fmt(veri.price)}'den</div>
      <span class="card-hint">İncele →</span>
    </div>`;
  /* Ürün adı metin olarak yazılır — mağazadan gelen başlıklarda tırnak ve
     < > gibi karakterler var, innerHTML'e gömülürse işaretlemeyi bozar. */
  card.querySelector('h4').textContent = veri.kisa || veri.name;
  card.querySelector('.card-img').alt = veri.name;
  /* Grid'de sadece önizleme var — boyut/çerçeve seçimi olmadan direkt
     sepete ekleme yok; sepete ekleme yalnızca modal içinden yapılır. */
  card.addEventListener('click', ()=>openModal(veri));
  colGrid.appendChild(card);
  /* "Çerçeveyi Aşanlar": tur içindeki koleksiyon ekranında da taşan parça
     görünsün. Bu ekran (#colGrid) Shopify'ın koleksiyon SAYFASINDAN ayrı bir
     görünüm; kartları burada üretiliyor ve daha önce yalnız düz poster
     gösteriyordu. Sticker ürünün kendi galerisinden (vitrin-sticker alt text)
     alınır, yön/kaydırma her zamanki gibi ölçülür. */
  if(veri.cat === CERCEVE_KATEGORI_ADI && veri.handle){
    fetchProductData(veri.handle).then(prod=>{
      const m = ((prod && prod.media) || []).find(x =>
        x.media_type === 'image' && (x.alt || '').trim() === 'vitrin-sticker');
      if(!m) return;
      /* Karttan AÇILAN MODAL de taşan parçayı çizebilsin diye ürün verisine
         yaz — kart verisinde overflow alanı yoktu, modal bu yüzden sticker'sız
         açılıyordu. */
      if(!veri.overflow) veri.overflow = {src: m.src};
      if(((prod && prod.tags) || []).indexOf(SADECE_MOCKUP_ETIKET) >= 0) veri.sadeceMockup = true;
      /* Grid verisi /collections/...products.json'dan geliyor ve orada ALT TEXT
         YOK; bu yüzden ham poster seçilemeyip raw:false işaretleniyor ve modal
         çerçeveli sunumu en baştan eliyordu (ölçüm: 8/8 photo-mode). Zaten
         çektiğimiz ürün verisinden gerçek "vitrin-duvar" posterini yaz. */
      const duvar = ((prod && prod.media) || []).find(x =>
        x.media_type === 'image' && (x.alt || '').trim() === 'vitrin-duvar');
      if(duvar){ veri.src = duvar.src; veri.raw = true; }
      const img = card.querySelector('.card-img');
      if(!img || card.querySelector('.art-overflow')) return;
      /* Görseli konumlanabilir bir sarmalayıcıya al: katman POSTERİN kutusuna
         göre ölçülüyor, kartın tamamına göre değil. */
      const sar = document.createElement('span');
      sar.className = 'kart-gorsel-sar';
      img.parentNode.insertBefore(sar, img);
      sar.appendChild(img);
      const ov = document.createElement('img');
      ov.className = 'art-overflow';
      ov.alt = ''; ov.setAttribute('aria-hidden', 'true');
      ov.src = m.src;
      sar.appendChild(ov);
      stickerYerlestir(ov);
      /* Yana taşan parça: yön kaydedilir, kenara çarpıp çarpmadığı ölçülür (bkz. kartTasmaDuzenle) */
      stickerGeo(m.src).then(g=>{
        if(!g || (g.yon !== 'sag' && g.yon !== 'sol')) return;
        sar.dataset.ovYon = g.yon;
        kartTasmaPlanla(); setTimeout(kartTasmaPlanla, 900);
      });
      /* Taşan parça kartın DIŞINA çıkabilsin: kırpan kutuları aç (satır içi,
         important — kart/grid kuralları baskın çıkabiliyor). */
      let el = sar;
      for(let k = 0; k < 4 && el; k++){
        if(getComputedStyle(el).overflow !== 'visible') el.style.setProperty('overflow', 'visible', 'important');
        el = el.parentElement;
      }
      kartBoslugunuAyarla(ov);
    });
  }
}
/* Tur içi koleksiyon grid'inin satır/sütun boşluğunu, ölçülen GERÇEK taşma
   kadar açar ki taşan parçalar komşu kartla çakışmasın. */
function kartBoslugunuAyarla(ov){
  stickerGeo(ov.getAttribute('src')).then(g=>{
    if(!g || !colGrid) return;
    const r = ov.getBoundingClientRect();
    if(!r.height) return;
    const px = Math.ceil((g.yon === 'ust' || g.yon === 'alt' ? g.pay * r.height : g.pay * r.width) + 14);
    const alan = (g.yon === 'ust' || g.yon === 'alt') ? 'rowGap' : 'columnGap';
    const simdi = parseFloat(colGrid.style[alan]) || 0;
    /* Yatay boşluk sınırlı: sütun sayısı masaüstünde 4'e sabit olduğu için
       çok geniş bir sütun boşluğu kartları gereksiz daraltıyordu. */
    const ust = (alan === 'columnGap') ? 64 : 240;
    const deger = Math.min(px, ust);
    if(deger > simdi) colGrid.style[alan] = deger + 'px';
  });
}
/* Gerçek ürün yoksa (koleksiyon bağlı değil ya da istek başarısız):
   eskisi gibi temsili kartlar. */
function temsiliGrid(cat){
  const names = cat.base.length ? cat.base : Array.from({length:6},(_,i)=>({name:`${cat.name.split(' ')[0]} No.${i+1}`, price: 449 + (i%5)*40, img:''}));
  const gridCount = Math.min(cat.total || 12, 18);
  for(let i=0;i<gridCount;i++){
    const base = names[i % names.length];
    const isBase = i < names.length;
    koleksiyonKartiEkle({
      name: isBase ? base.name : `${base.name} — Varyasyon ${Math.floor(i/names.length)+1}`,
      price: base.price + (isBase ? 0 : 20),
      old: isBase ? (base.old || 0) : 0,
      src: artSrc(cat.style, i, isBase ? base.img : ''),
      handle: isBase ? base.handle : '',
      cat: cat.name, story: isBase ? base.story : '',
      overflow: isBase ? base.overflow : null,
      raw: isBase ? base.raw : undefined
    }, i);
  }
  isiklariAc();
}
function isiklariAc(){
  /* requestAnimationFrame yerine zorlanmış reflow: sekme arka plandayken
     rAF çalışmıyor ve kartlar hiç görünmüyordu. */
  void colGrid.offsetHeight;
  setTimeout(()=>collection.classList.add('lit'), 60);
}
function openCollection(catId){
  lastFocusedEl = document.activeElement;
  const cat = catData(catId);
  colTitle.textContent = cat.name;
  colGrid.innerHTML = '';
  collection.classList.remove('lit');
  collection.classList.add('open');
  document.body.style.overflow = 'hidden';
  document.getElementById('colClose').focus();
  const kolParams = {koleksiyon: roomCollection(catId) || catId};
  if(!katmanAdresiniGuncelle('kol', kolParams)) pushOverlay(koleksiyonDomKapat, 'kol', kolParams);

  const handle = roomCollection(catId);
  /* Duvarda zaten gösterilen (vitrin-{oda} etiketli) ürünler burada
     tekrarlanmaz — kullanıcı "kalan"ları görmeyi bekliyor. */
  /* Duvardaki 6 ürün de listede yer alır: kullanıcı turda gördüğü eseri
     bu ekranda tekrar bulabilmeli. Buton sayısı yine "kalan" (henüz
     görülmemiş) ürünleri anlatır; grid ise koleksiyonun tamamıdır. */
  if(!handle || !SHOPIFY.hosted){
    colDesc.textContent = cat.desc + ' · ' + cat.total + ' tasarım';
    temsiliGrid(cat);
    return;
  }
  colDesc.textContent = cat.desc + ' · yükleniyor…';
  fetchCollectionProducts(handle).then(list=>{
    if(!collection.classList.contains('open')) return;   // kullanıcı kapattıysa
    const kalan = list || [];
    if(!kalan.length){
      colDesc.textContent = cat.desc + ' · ' + cat.total + ' tasarım';
      temsiliGrid(cat);
      return;
    }
    colDesc.textContent = cat.desc + ' · ' + kalan.length + ' tasarım';
    kalan.forEach((p,i)=>koleksiyonKartiEkle(koleksiyonKarti(p, cat.name), i));
    isiklariAc();
  });
}
/* Dışarıdan çağrılan kapatma: katmanı (ve adres kaydını) da kapatır */
function closeCollection(){
  if(!katmanTipiniKapat('kol')) koleksiyonDomKapat();
}
function koleksiyonDomKapat(){
  collection.classList.remove('open','lit');
  document.body.style.overflow = '';
  if(lastFocusedEl){ lastFocusedEl.focus({preventScroll:true}); lastFocusedEl = null; }
}
document.getElementById('colClose').addEventListener('click', closeCollection);
document.addEventListener('click', e=>{
  const t = e.target.closest('.open-collection');
  if(t) openCollection(t.dataset.room);
});
/* Logo: koleksiyon açıksa kapat, sonra girişe (footer'daki "Tura Yeniden
   Başla" ile aynı davranış) yumuşak scroll et */
document.getElementById('logoHome').addEventListener('click', e=>{
  e.preventDefault();
  closeCollection();
  window.scrollTo({top: 0, behavior: reduceMotion ? 'auto' : 'smooth'});
});

/* ============ ÜRÜN MODAL ============ */
const modalBackdrop = document.getElementById('modalBackdrop');
const modalImgWrap = document.getElementById('modalImgWrap');
const bgSwatches = document.getElementById('bgSwatches');
/* "Bu tabloyu odanda gör" — duvar rengi önizlemesi (beyaz/gri/pastel/koyu) */
bgSwatches.querySelectorAll('.bg-swatch').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    modalImgWrap.style.background = btn.dataset.bg;
    bgSwatches.querySelectorAll('.bg-swatch').forEach(b=>b.classList.toggle('on', b===btn));
  });
});
let modalProduct = null, selSize = 0, selFrame = 0;
/* Modal açılışında koyu duvarla gelecek serinin kategori adı. Ürün nesnesinin
   cat alanı hem duvar turunda (room.name) hem koleksiyon gridinde bu adı taşır,
   yani tek kontrolle her iki açılış yolu kapsanır. */
const CERCEVE_KATEGORI_ADI = (ROOMS.find(r => r.id === 'cerceveyiasanlar') || {}).name;

/* "Ürün Detayları" yan penceresi — modalin üstüne sağdan kayar. Amaç
   kullanıcının açıklamayı okumak için mağazanın eski ürün sayfasına
   çıkmak zorunda kalmaması; pencere kapanınca seçimine kaldığı yerden
   devam eder. */
const pdOpen = document.getElementById('pdOpen');
const pdDrawer = document.getElementById('pdDrawer');
const pdClose = document.getElementById('pdClose');
const pdDrawerTitle = document.getElementById('pdDrawerTitle');
const pdBody = document.getElementById('pdBody');
const modalGallery = document.getElementById('modalGallery');
/* Üstüne binen modda pencere TAM olarak görsel sütununu kaplamalı: bir
   piksel taşarsa fiyat/boyut sütununu örter. Yüzdeyle hesaplamak modalin
   kaydırma çubuğu yüzünden şaşıyordu — sütunun gerçek genişliği ölçülüyor.
   Yan yana modda (position:static) genişlik CSS'ten gelir. */
function syncDrawerWidth(){
  const yanYana = getComputedStyle(pdDrawer).position === 'static';
  pdDrawer.style.width = yanYana ? '' : modalImgWrap.offsetWidth + 'px';
}
window.addEventListener('resize', ()=>{ if(pdDrawer.classList.contains('open')) syncDrawerWidth(); });
function openDetails(){
  pdDrawer.hidden = false;
  syncDrawerWidth();
  /* hidden kaldırıldığı karede transform animasyonu başlamaz; kapalı
     konumun hesaplanmasını zorlayıp .open'ı hemen ekliyoruz. Burada
     requestAnimationFrame kullanılmıyor: sekme arka plandayken rAF
     çalışmaz ve pencere hiç açılmazdı. */
  void pdDrawer.offsetWidth;
  pdDrawer.classList.add('open');
  pdOpen.setAttribute('aria-expanded', 'true');
  pdClose.focus();
}
function closeDetails(){
  pdDrawer.classList.remove('open');
  pdOpen.setAttribute('aria-expanded', 'false');
  pdOpen.focus();
  if(reduceMotion){ pdDrawer.hidden = true; return; }
  setTimeout(()=>{ if(!pdDrawer.classList.contains('open')) pdDrawer.hidden = true; }, 400);
}
/* Aynı düğme hem açar hem kapatır (çarpıya gitmek zorunda kalınmasın). */
pdOpen.addEventListener('click', ()=>{
  if(pdDrawer.classList.contains('open')) requestCloseTop();
  else { openDetails(); pushOverlay(closeDetails, ''); }
});
pdClose.addEventListener('click', requestCloseTop);

/* Ürün fotoğrafı galerisi. İlk küçük resim her zaman bizim duvar
   render'ımız; kalanlar mağazadaki diğer çekimler. Fotoğraf seçilince
   .photo-mode ile kendi çerçevemizi çizmeyi bırakırız — mağazanın çekimi
   zaten kendi sunumunu içeriyor, üstüne çerçeve koymak çift çerçeve olur. */
let galleryPhotos = [];
let galleryOfset = 1;   // duvar görünümü küçük resmi varsa 1, yoksa 0
function cdnSized(u, w){ return u ? u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w : u; }
/* Shopify CDN görselini w piksel genişlikte iste (varsa mevcut width'i değiştirir).
   CDN dışı adreslere (data:, yerel) dokunmaz. */
function cdnGenislik(u, w){
  if(!u || !/\/cdn\/shop\/|cdn\.shopify\.com/.test(u)) return u;
  return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
}
/* Duvardaki tablo/taşan parça: ekranda en fazla ~520 piksel gerekiyor (ölçüldü:
   Pixel 7'de 488). 1200 px yerine 640 px istenir; modal tam boyu ayrıca ister. */
function duvarGorseli(u){ return cdnGenislik(u, 640); }
/* Büyük boy galeri görsellerini arka planda indir. Eskiden küçük resme
   basıldığı anda 900px'lik dosya ilk kez isteniyordu; indirme + çözme
   süresince arayüz donuyordu. Önden indirilince geçiş anında oluyor. */
function preloadGaleri(urls){
  (urls || []).forEach(u=>{ const im = new Image(); im.decoding = 'async'; im.src = cdnSized(u, 900); });
}
function setActiveThumb(n){
  modalGallery.querySelectorAll('.mg-thumb').forEach((b,i)=>b.classList.toggle('on', i === n));
}
function showWallView(){
  if(!modalProduct) return;
  const img = document.getElementById('modalImg');
  img.src = modalProduct.src;
  img.alt = modalProduct.name;
  /* Listeden açıldıysa çerçevesiz kalır (bkz. cerceveliGosterim). */
  modalImgWrap.classList.toggle('photo-mode', !cerceveliGosterim(modalProduct));
  /* Sticker payı (has-overflow) yalnız duvar görünümünde: bu görsel
     vitrin-duvar posteri ve sticker onun üzerine ait. */
  modalImgWrap.classList.toggle('has-overflow', Boolean(modalProduct.overflow) && cerceveliGosterim(modalProduct));
  setActiveThumb(0);
  zoomReset();   // görsel değişti: yakınlaştırmayı sıfırla
}
function showPhoto(i){
  const img = document.getElementById('modalImg');
  img.src = cdnSized(galleryPhotos[i], 900);
  img.alt = modalProduct.name + ' — ürün fotoğrafı ' + (i + 1);
  modalImgWrap.classList.add('photo-mode');
  /* Mağazanın diğer çekimine geçildi: sticker payını kaldır (sticker CSS ile
     photo-mode'da zaten gizli; padding de kalmasın ki fotoğraf ortalı dursun). */
  modalImgWrap.classList.remove('has-overflow');
  setActiveThumb(i + galleryOfset);
  zoomReset();
}
/* Kullanıcıya gösterilecek galeri görsellerini seçer.
   "Çerçeveyi Aşanlar" serisinde alt text'i "vitrin-duvar" (ham poster) veya
   "vitrin-sticker" (şeffaf zeminde tek taşan parça) olan görseller GİZLENİR —
   bunlar tek başına yarım/bozuk görünür ve yalnız bizim poster+sticker'ı
   BİRLEŞTİRİP çizdiğimiz ana görünümün ham verisidir (o veri çekme mantığına
   dokunulmadı). Diğer 8 kategori aynen eski davranışta kalır (prod.images).
   Alt text yalnız prod.media'da var; prod.images sadece URL dizisidir. */
function galeriGorselleri(prod, p){
  if(!prod) return [];
  const seri = Boolean(p) && p.cat === CERCEVE_KATEGORI_ADI;
  if(!seri) return prod.images || [];
  const gizli = new Set(['vitrin-duvar','vitrin-sticker']);
  return (prod.media || [])
    .filter(m => m.media_type === 'image' && !gizli.has((m.alt || '').trim()))
    .map(m => m.src);
}
function buildGallery(urls){
  galleryPhotos = urls || [];
  modalGallery.innerHTML = '';
  if(!galleryPhotos.length){
    modalGallery.hidden = true;
    modalImgWrap.classList.remove('has-gallery');
    return;
  }
  /* "Duvarda görünümü" küçük resmi yalnızca DUVAR TURUNDAN açılan modalde
     anlamlı. Listeden açıldığında böyle bir render yok; ayrıca oradaki ana
     görsel zaten mağaza fotoğraflarından biri olduğu için küçük resim
     tekrarlanıyordu. */
  galleryOfset = cerceveliGosterim(modalProduct) ? 1 : 0;
  if(galleryOfset){
    const wall = document.createElement('button');
    wall.type = 'button'; wall.className = 'mg-thumb on'; wall.dataset.i = '-1';
    wall.setAttribute('aria-label', 'Duvarda görünümü');
    wall.innerHTML = '<img alt="">';
    wall.firstChild.src = modalProduct.src;
    modalGallery.appendChild(wall);
  }
  preloadGaleri(galleryPhotos);
  galleryPhotos.forEach((u, i)=>{
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'mg-thumb'; b.dataset.i = String(i);
    b.setAttribute('aria-label', 'Ürün fotoğrafı ' + (i + 1));
    b.innerHTML = '<img alt="" loading="lazy">';
    b.firstChild.src = cdnSized(u, 140);
    modalGallery.appendChild(b);
  });
  modalGallery.hidden = false;
  modalImgWrap.classList.add('has-gallery');
}
modalGallery.addEventListener('click', e=>{
  const b = e.target.closest('.mg-thumb'); if(!b) return;
  const i = Number(b.dataset.i);
  if(i < 0) showWallView(); else showPhoto(i);
});

/* ============ GÖRSEL YAKINLAŞTIRMA (zoom + pan) ============
   Modal ana görselinde (hem duvar turundan hem listeden açılan modalde aynı
   #modalFrame) tek seviye yakınlaştırma. Hafif: yalnız CSS transform + pointer
   olayları, kütüphane yok.
   - Masaüstü: görsele tıkla → yakınlaş; yakınken sürükle → gez (pan); tekrar
     tıkla → normal. Küçült düğmesi de var.
   - Mobil: iki parmak pinch → yakınlaş/uzaklaş; tek parmak sürükle → gez.
   Modal açıkken oda dokunma kontrolcüsü zaten pasif (ustteAcikKatmanVar), o
   yüzden çakışma yok; yalnız modalin kendi scroll'unu pan sırasında bastırırız.
   Yakınlaştırma görsel bir katman: düzeni (poster oturması, sticker hizası)
   etkilemez; transform yalnız #modalFrame'e uygulanır. */
const ZOOM_KAT = 2.4, ZOOM_MAX = 4;
let zScale = 1, zTx = 0, zTy = 0;
/* Sticker'ın çerçeveyi (frame) HANGİ yönde ne kadar aştığı (ölçeksiz px).
   Pan sınırı bu kadar genişletilir ki yakınken taşan parça da görülebilsin.
   "Çerçeveyi Aşanlar"da sticker üstten/sağdan/soldan/alttan taşabilir; bu
   ölçüm yöne bakmaz, her yönü ayrı hesaplar. Sticker'sız üründe hepsi 0 →
   eski simetrik sınır. */
let zTasma = { t:0, b:0, l:0, r:0 };
const zoomHedef = document.getElementById('modalFrame');
const zoomSahne = document.querySelector('.modal-stage');
function zoomUygula(){
  zoomHedef.style.transform = zScale === 1 ? '' : `translate(${zTx}px,${zTy}px) scale(${zScale})`;
  modalImgWrap.classList.toggle('zoomed', zScale > 1.01);
}
function zoomReset(){ zScale = 1; zTx = 0; zTy = 0; zTasma = { t:0, b:0, l:0, r:0 }; if(zoomHedef){ zoomHedef.style.transition = ''; zoomUygula(); } }
/* Sticker taşmasını ÖLÇEK 1'de (yakınlaşmadan ÖNCE) ölç ve sakla — çağrıldığı
   an transform yok, rect'ler ölçeksiz. */
function zoomTasmaOlc(){
  zTasma = { t:0, b:0, l:0, r:0 };
  if(!zoomHedef) return;
  const ov = zoomHedef.querySelector('.art-overflow');
  if(!ov || getComputedStyle(ov).display === 'none') return;
  const fr = zoomHedef.getBoundingClientRect(), or = ov.getBoundingClientRect();
  if(!or.width || !or.height) return;
  zTasma = {
    t: Math.max(0, fr.top - or.top),
    b: Math.max(0, or.bottom - fr.bottom),
    l: Math.max(0, fr.left - or.left),
    r: Math.max(0, or.right - fr.right)
  };
}
function zoomSinirla(){
  if(zScale <= 1){ zTx = 0; zTy = 0; return; }
  const sr = zoomSahne.getBoundingClientRect();
  const bw = zoomHedef.offsetWidth, bh = zoomHedef.offsetHeight;
  const m = 24;   // taşan parçayı kenara yapışık değil, rahat görme payı
  /* +tx içeriği SAĞA taşır → SOL kenarı (soldan taşan sticker) açar; vb.
     Her yön çerçeve yarısı + o yöndeki sticker taşması, ölçekle çarpılır. */
  const maxSag  = Math.max(0, (bw / 2 + zTasma.l) * zScale - sr.width  / 2 + m); //  tx üst sınır
  const maxSol  = Math.max(0, (bw / 2 + zTasma.r) * zScale - sr.width  / 2 + m); // -tx alt sınır
  const maxAsagi= Math.max(0, (bh / 2 + zTasma.t) * zScale - sr.height / 2 + m); //  ty üst sınır (üst sticker)
  const maxYukari=Math.max(0, (bh / 2 + zTasma.b) * zScale - sr.height / 2 + m); // -ty (alt sticker)
  zTx = Math.max(-maxSol, Math.min(maxSag, zTx));
  zTy = Math.max(-maxYukari, Math.min(maxAsagi, zTy));
}
/* Tıklanan/dokunulan NOKTAYA yakınlaştır: o nokta ekranda yerinde kalsın.
   transform-origin center olduğu için, merkeze göre ofset*(1-ölçek) kadar
   ötele — böylece basılan yer büyürken kaçmaz, ortaya sıçramaz. */
function zoomNoktaya(clientX, clientY){
  if(zScale <= 1) zoomTasmaOlc();   // ölçek 1'deyken taşmayı ölç
  const sr = zoomSahne.getBoundingClientRect();
  const cx = sr.left + sr.width / 2, cy = sr.top + sr.height / 2;
  zScale = ZOOM_KAT;
  zTx = (clientX - cx) * (1 - zScale);
  zTy = (clientY - cy) * (1 - zScale);
  zoomSinirla(); zoomUygula();
}
if(zoomHedef && zoomSahne){
  /* Küçült düğmesi (yalnız yakınken görünür — CSS .zoomed) */
  const zoomBtn = document.createElement('button');
  zoomBtn.type = 'button'; zoomBtn.className = 'zoom-out-btn'; zoomBtn.setAttribute('aria-label', 'Küçült');
  zoomBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21M7.5 10.5h6"/></svg>';
  modalImgWrap.appendChild(zoomBtn);
  /* Tarayıcının native görsel sürüklemesini kes (Firefox dahil): aksi halde
     çekme, pan yerine <img>'i sürükleyip yarı-saydam kopya oluşturuyor. */
  zoomSahne.addEventListener('dragstart', e=>e.preventDefault());
  const ESIK = 4;   // px: bunun altındaki hareket "tıklama", üstü "sürükleme"
  /* — Masaüstü / fare —
     Akış (en kolay): uzak→ basılan NOKTAYA yakınlaş; AYNI harekette çekersen
     hemen gezinir (ek tıklama yok). Yakınken: çek→gez, hareketsiz tık→uzaklaş. */
  let sX = 0, sY = 0, bTx = 0, bTy = 0, surukAktif = false, cekildi = false, yakindiBaslangic = false;
  zoomSahne.addEventListener('pointerdown', e=>{
    if(e.pointerType === 'touch') return;   // dokunma ayrı ele alınıyor
    e.preventDefault();                     // native görsel-sürükleme/seçim başlamasın
    yakindiBaslangic = zScale > 1;
    cekildi = false; surukAktif = true;
    if(!yakindiBaslangic) zoomNoktaya(e.clientX, e.clientY);   // uzaksa: basılan yere yakınlaş
    sX = e.clientX; sY = e.clientY; bTx = zTx; bTy = zTy;
    try{ zoomSahne.setPointerCapture(e.pointerId); }catch(_){}
  });
  zoomSahne.addEventListener('pointermove', e=>{
    if(!surukAktif || zScale <= 1) return;
    const dx = e.clientX - sX, dy = e.clientY - sY;
    if(!cekildi && Math.abs(dx) + Math.abs(dy) > ESIK){ cekildi = true; zoomHedef.style.transition = 'none'; }
    if(!cekildi) return;
    zTx = bTx + dx; zTy = bTy + dy; zoomSinirla(); zoomUygula();
  });
  zoomSahne.addEventListener('pointerup', e=>{
    if(e.pointerType === 'touch') return;
    zoomHedef.style.transition = '';
    if(yakindiBaslangic && !cekildi) zoomReset();   // yakınken hareketsiz tık → uzaklaş
    surukAktif = false;
  });
  /* — Mobil / dokunma —
     Tek parmak: yakınken çek→gez; hareketsiz dokunuş→ (uzaksa) dokunulan noktaya
     yakınlaş / (yakınsa) uzaklaş. İki parmak: pinch (serbest oran). */
  let ikiParmak = false, pinchBaz = 0, pinchScale = 1, tX = 0, tY = 0, tbTx = 0, tbTy = 0, tCekildi = false, tYakindiBaslangic = false;
  const mesafe = ts => Math.hypot(ts[0].clientX - ts[1].clientX, ts[0].clientY - ts[1].clientY);
  zoomSahne.addEventListener('touchstart', e=>{
    if(e.touches.length === 2){ ikiParmak = true; if(zScale <= 1) zoomTasmaOlc(); pinchBaz = mesafe(e.touches); pinchScale = zScale; zoomHedef.style.transition = 'none'; }
    else if(e.touches.length === 1){
      ikiParmak = false; tCekildi = false; tYakindiBaslangic = zScale > 1;
      tX = e.touches[0].clientX; tY = e.touches[0].clientY; tbTx = zTx; tbTy = zTy;
    }
  }, { passive:true });
  zoomSahne.addEventListener('touchmove', e=>{
    if(ikiParmak && e.touches.length === 2){
      zScale = Math.max(1, Math.min(ZOOM_MAX, pinchScale * (mesafe(e.touches) / pinchBaz)));
      zoomSinirla(); zoomUygula(); e.preventDefault();
    } else if(!ikiParmak && e.touches.length === 1 && zScale > 1){
      const dx = e.touches[0].clientX - tX, dy = e.touches[0].clientY - tY;
      if(!tCekildi && Math.abs(dx) + Math.abs(dy) > ESIK){ tCekildi = true; zoomHedef.style.transition = 'none'; }
      if(!tCekildi) return;
      zTx = tbTx + dx; zTy = tbTy + dy; zoomSinirla(); zoomUygula(); e.preventDefault();
    }
  }, { passive:false });
  zoomSahne.addEventListener('touchend', e=>{
    zoomHedef.style.transition = '';
    if(e.touches.length > 0) return;                 // hâlâ parmak var (pinch'in biri kalktı)
    if(ikiParmak){ ikiParmak = false; if(zScale < 1.05) zoomReset(); return; }
    if(!tCekildi){                                    // hareketsiz dokunuş
      if(tYakindiBaslangic) zoomReset();
      else zoomNoktaya(tX, tY);
    }
  });
  if(zoomBtn) zoomBtn.addEventListener('click', e=>{ e.stopPropagation(); zoomReset(); });
}

/* Biçimlendirici bir kez kurulur (toLocaleString her çağrıda yeniden kuruyordu;
   açılışta ölçülebilir işlemci). Fonksiyon özelliğinde tutulur: fmt, bu satırdan
   önce (oda kurulumunda) çağrıldığı için const/let tanım sırası hatası verirdi. */
function fmt(n){
  const nf = fmt.nf || (fmt.nf = new Intl.NumberFormat('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}));
  return nf.format(n) + ' ₺';
}
/* Açık modalin ürününe ait TÜM Shopify varyantları — openModal() içinde
   /products/{handle}.js yanıtından doldurulur (bkz. aşağıdaki fetchProductData
   çağrısı). Fiyat artık boyut ÇARPANIYLA tahmin edilmiyor: seçilen boyut+
   çerçeveye uyan GERÇEK varyant matchVariant() ile bulunup o varyantın
   gerçek fiyatı gösteriliyor — sepete eklenen varyantla modalde görünen
   fiyat böylece her zaman birebir aynı olur. Veri henüz gelmediyse (ilk
   render, dosya modu, handle'sız ürün) eski çarpan tahminine düşülür. */
let modalVariants = null;
function eslesenVaryant(){
  if(!modalVariants || !modalProduct) return null;
  return matchVariant({variants: modalVariants}, {sizeKey: SIZES[selSize].key, frameKey: FRAME_KEYS[selFrame]});
}
function modalCurrentPrice(){
  const v = eslesenVaryant();
  if(v) return birimFiyat(v.price) / 100;
  return Math.round(modalProduct.price * SIZES[selSize].mult * 100) / 100;
}
function modalOldPrice(){
  const v = eslesenVaryant();
  if(v) return v.compare_at_price ? birimFiyat(v.compare_at_price) / 100 : 0;
  return modalProduct.old ? Math.round(modalProduct.old * SIZES[selSize].mult * 100) / 100 : 0;
}
/* Seçilen çerçeve (selFrame) modal görselini gerçekten değiştirir. Her
   seçenek adıyla tutarlı görünür: çerçevesiz = sade baskı, siyah = ince
   siyah kenar, ahşap/beyaz = o renkte fiziksel çerçeve.
   Taşan katman (sticker) DÖRT çerçevede de görünür. Serinin adı zaten
   "Çerçeveyi Aşanlar" — taşan parça ürünün kendisi; ahşap/beyazda gizlemek
   müşteriye "o çerçevede bu ürün yok" gibi görünüyordu. */
/* Görseli KENDİ çerçevemizle çizecek miyiz?
   HAYIR ise: mağazanın kendi fotoğrafı olduğu gibi gösterilir.
   - listeden: modal ÜRÜN LİSTESİNDEN açıldı. Oradaki görseller mağazanın
     mockup çekimleri (ürün zaten bir duvarda/çerçevede görünüyor); üstüne
     bir çerçeve daha çizmek "çerçeve içinde çerçeve" oluyordu ve çerçeve
     renk seçimi görselde hiçbir şey değiştirmiyordu. Çerçeveli sunum
     yalnızca DUVAR TURUNDAKİ eserlere ait.
   - raw === false: ürünün ham "vitrin-duvar" baskısı yok, eldeki görsel
     zaten kendi çerçevesini içeriyor.
   Not: çerçeve BUTONLARI her iki durumda da durur ve seçim sepete/varyanta
   yansımaya devam eder — sadece görsel değişmez. */
function cerceveliGosterim(p){
  if(!p || p.raw === false) return false;
  /* Sadece-mockup ürünlerde ham poster HİÇ gösterilmez: çerçeveli sunum ve
     "duvarda görünümü" küçük resmi devre dışı — modal doğrudan mağazanın
     mockup fotoğrafıyla açılır (bkz. openModal içindeki showPhoto(0)). */
  if(sadeceMockupMu(p)) return false;
  /* "Çerçeveyi Aşanlar" İSTİSNASI: bu seride poster+taşan parça kompozisyonu
     ürünün kendisi. Listeden (koleksiyon kartından) açıldığında da çerçeveli
     sunum ve sticker gösterilir — aksi halde modal photo-mode'a düşüp taşan
     parçayı hiç çizmiyordu (ölçüm: kartlardan açılan modalde photo-mode:true,
     fw-mockup, sticker elemanı yok). Bu serinin kart görseli zaten
     "vitrin-duvar" ham posteri olduğu için hizalama doğru.
     Diğer kategoriler eskisi gibi: listeden açılınca mağaza mockup'ı. */
  /* Ölçüt "kategori adı" değil, TAŞAN PARÇASI olması: grid yolunda cat alanı
     her zaman seri adını taşımıyordu (ölçüm: photo-mode true kalıyordu).
     overflow yalnız bu seride var, dolayısıyla kapsam yine seriye kilitli. */
  if(p.listeden && !p.overflow) return false;
  return true;
}
function applyModalFrame(){
  const p = modalProduct; if(!p) return;
  if(!cerceveliGosterim(p)){
    modalImgWrap.classList.remove('fw-black','fw-wood','fw-white','fw-frameless');
    modalImgWrap.classList.add('fw-mockup','photo-mode');
    return;
  }
  /* Galeriden bir mağaza fotoğrafına geçilmişken çerçeve değiştirilirse
     seçim ekranda görünmez — duvar görünümüne dönülür. */
  if(modalImgWrap.classList.contains('photo-mode')) showWallView();
  const key = FRAME_KEYS[selFrame];
  modalImgWrap.classList.toggle('has-overflow', Boolean(p.overflow));
  modalImgWrap.classList.remove('fw-black','fw-wood','fw-white','fw-frameless','fw-mockup');
  /* Mockup görselde (ürünün ham "vitrin-duvar" baskısı yok) kendi çerçevemizi
     çizmeyiz — görsel zaten kendi çerçevesini içeriyor. Seçim görseli
     değiştirmez ama sepete/varyanta yansımaya devam eder. */
  if(p.raw === false){ modalImgWrap.classList.add('fw-mockup'); return; }
  modalImgWrap.classList.add('fw-' + key); // frameless | black | wood | white
}
/* "Çerçeveyi Aşanlar" serisinde 30×40 önerilen ölçüdür: tasarım kompozisyonu
   bu ölçüde kuruluyor. Rozet metni + açıklaması burada tek yerden yönetilir —
   hem sizeRow butonunda hem sizeGuide kutusunda aynı içerik kullanılır. */
const ONERI_OLCU_INDEX = 2; // SIZES[2] = 30×40 cm
const ONERI_ACIKLAMA = 'Bu tasarım kompozisyonunu en uyumlu şekilde 30×40 ölçüsünde tamamlıyor; yine de duvarınıza en uygun ölçüyü seçmek size kalmış.';
function oneriRozetiHtml(){
  return `<span class="oneri-badge" tabindex="0" role="button" aria-expanded="false" aria-label="Önerimiz — neden?">Önerimiz<span class="oneri-tip" role="tooltip">${ONERI_ACIKLAMA}</span></span>`;
}
var modalSecimDegisti = false;   // kullanıcı boyut/çerçeve seçtiyse gerçek veri gelince varsayılan ezilmez
/* Seçili boyutta kapalı olmayan en uygun çerçeve: gerçek varyantlardan en ucuz satılabilir (eşitlikte varyant
   sırası); veri yoksa mağazadaki seçenek sırasına göre ilk açık çerçeve (Çerçevesiz, Ahşap, Siyah, Beyaz) */
function kapaliAlternatif(sizeIdx){
  const acik = FRAMES.map((_, i) => i).filter(i => !kapaliSecim(sizeIdx, i));
  if(modalVariants){
    const aday = modalVariants.filter(v => v.available && !kapaliBaslik(v.title))
      .map(v => ({ v, sec: secimIndeksi(v.title) })).filter(x => x.sec && x.sec.s === sizeIdx && acik.includes(x.sec.f))
      .reduce((en, x) => (!en || birimFiyat(x.v.price) < birimFiyat(en.v.price)) ? x : en, null);
    if(aday) return aday.sec.f;
  }
  const sira = ['frameless', 'wood', 'black', 'white'].map(k => FRAME_KEYS.indexOf(k)).filter(i => acik.includes(i));
  return sira.length ? sira[0] : selFrame;
}
function renderOpts(){
  const sizeRow = document.getElementById('sizeRow');
  const frameRow = document.getElementById('frameRow');
  /* "Çerçeveyi Aşanlar" serisinde YALNIZ Siyah Çerçeve sunulur: bu eserler
     ince siyah kenar için tasarlandı, diğer çerçeveler seride anlamsız. Tek
     buton (Siyah, seçili) gösterilir; selFrame zorla siyaha sabitlenir, sepete
     de her zaman "black" varyantı gider. Diğer 8 kategoride 4 seçenek aynen. */
  const sadeceSiyah = Boolean(modalProduct) && modalProduct.cat === CERCEVE_KATEGORI_ADI;
  sizeRow.innerHTML = SIZES.map((s,i)=>`<button class="opt ${i===selSize?'on':''} ${sadeceSiyah && i===ONERI_OLCU_INDEX?'has-oneri':''}" data-i="${i}">${s.label}${sadeceSiyah && i===ONERI_OLCU_INDEX?oneriRozetiHtml():''}</button>`).join('');
  const siyahIdx = FRAME_KEYS.indexOf('black');
  if(sadeceSiyah) selFrame = siyahIdx;
  if(!sadeceSiyah && kapaliSecim(selSize, selFrame)) selFrame = kapaliAlternatif(selSize);
  const cerceveIdxler = sadeceSiyah ? [siyahIdx] : FRAMES.map((_,i)=>i).filter(i => !kapaliSecim(selSize, i));
  /* Çerçeveyi Aşanlar: tek çerçevenin bilinçli bir tasarım tercihi olduğunu söyleyen not */
  document.getElementById('cerceveNotu').hidden = !sadeceSiyah;
  /* Tek seçenek varsa seçilecek bir şey yok: düğme yerine düz bilgi */
  frameRow.innerHTML = cerceveIdxler.length === 1
    ? `<span class="opt-tek">${FRAMES[cerceveIdxler[0]]} çerçeve</span>`
    : cerceveIdxler.map(i=>`<button class="opt opt-cerceve ${i===selFrame?'on':''}" data-i="${i}"><span class="sumer-cita sumer-cita--${CITA_SINIFI[FRAME_KEYS[i]] || 'yok'}" aria-hidden="true"></span>${FRAMES[i]}</button>`).join('');
  sizeRow.querySelectorAll('.opt').forEach(o=>o.addEventListener('click', ()=>{modalSecimDegisti = true; selSize = Number(o.dataset.i); renderOpts(); modalAdresiniGuncelle();}));
  frameRow.querySelectorAll('.opt').forEach(o=>o.addEventListener('click', ()=>{modalSecimDegisti = true; selFrame = Number(o.dataset.i); renderOpts(); modalAdresiniGuncelle();}));
  document.getElementById('modalPrice').textContent = fmt(modalCurrentPrice());
  const oldEl = document.getElementById('modalOld');
  const eskiFiyat = modalOldPrice();
  oldEl.textContent = eskiFiyat ? fmt(eskiFiyat) : '';
  /* boyut rehberi: oranlı dikdörtgenler — sizeRow ile aynı selSize state'ini
     günceller, tıklanabilir (bkz. .sg buton + click listener aşağıda) */
  const dims = [[13,18],[21,30],[30,40],[40,50]];
  /* Kutular ekran yuksekligiyle olceklenir: uzun ekranda bilgi
     sutununun altinda kalan bosluk doluyor, kisa ekranda tasmiyor. */
  const sgK = Math.max(1, Math.min(2.4, window.innerHeight / 520));
  const sizeGuide = document.getElementById('sizeGuide');
  /* Rozet yalnız sizeRow'a eklenir, sizeGuide'a değil: .sg kutuları seçili
     değilken opacity ile soluyor (bkz. CSS), bu da içindeki rozeti okunaksız
     kılardı — opacity ebeveynden çocuğa sızar, çocuk kendi opacity'siyle
     bunu geri alamaz. */
  sizeGuide.innerHTML = dims.map(([w,h],i)=>
    `<button type="button" class="sg ${i===selSize?'on':''}" data-i="${i}" aria-label="${w}×${h} cm boyutunu seç" aria-pressed="${i===selSize}"><i style="width:${Math.round(w*sgK)}px;height:${Math.round(h*sgK)}px"></i>${w}×${h}</button>`).join('');
  sizeGuide.querySelectorAll('.sg').forEach(o=>o.addEventListener('click', ()=>{modalSecimDegisti = true; selSize = Number(o.dataset.i); renderOpts(); modalAdresiniGuncelle();}));
  applyModalFrame();
  modalEkBilgileriGuncelle();
}
/* Mobil sabit çubuk (ad + fiyat + Sepete Ekle), "en az sipariş" satırı ve
   askı aparatı satırı (çerçevesiz baskıda askı aparatı yok → gizli). */
function modalEkBilgileriGuncelle(){
  if(!modalProduct) return;
  const fiyat = modalCurrentPrice();
  document.getElementById('msAd').textContent = modalProduct.kisa || modalProduct.name;
  document.getElementById('msFiyat').textContent = fmt(fiyat);
  const ekle = document.getElementById('modalAdd');
  const msEkle = document.getElementById('msEkle');
  msEkle.disabled = ekle.disabled; msEkle.textContent = ekle.textContent;
  const askiSatiri = document.getElementById('modalGuvenAski');
  askiSatiri.hidden = FRAME_KEYS[selFrame] === 'frameless';
  /* Çerçeveyi Aşanlar: taşan parça dikey kompozisyonun parçası → "dikey ya da yatay" metni gösterilmez */
  const seriAski = modalProduct.cat === CERCEVE_KATEGORI_ADI;
  askiSatiri.querySelector('[data-aski-genel]')?.toggleAttribute('hidden', seriAski);
  askiSatiri.querySelector('[data-aski-seri]')?.toggleAttribute('hidden', !seriAski);
  const kalanEl = document.getElementById('modalMinKalan');
  const min = Number(document.getElementById('cartDrawer').dataset.minSepet) || 0;
  let sepetteki = 0;
  try{ sepetteki = cart.reduce((t, c)=>t + (c.orig != null ? c.orig : c.price), 0); }catch(e){}   // sepet henüz kurulmadıysa (erken derin bağlantı) 0
  const kalan = min - (sepetteki + fiyat);
  if(min > 0 && kalan > 0.004 && !ekle.disabled){
    kalanEl.innerHTML = `En az sipariş ${min} TL · bu tabloyla <b>${fmt(kalan)}</b> kalıyor. Bir tablo daha ekleyin, siparişiniz verilebilsin.`;
    kalanEl.hidden = false;
  } else kalanEl.hidden = true;
}
/* Varyant değişince adres: ?urun=<handle>&variant=<id> (aynı kayıt, replaceState) */
function modalAdresiniGuncelle(){
  if(!modalProduct || !modalProduct.handle) return;
  const v = eslesenVaryant();
  katmanAdresiniGuncelle('urun', {urun: modalProduct.handle, variant: v ? v.id : null});
}
/* ============ ÜRÜN MODALİ ve TARAYICI "GERİ" ============
   Modal (ve üstüne açılan "Detaylı ürün bilgisi" paneli) yalnızca CSS class'ı
   ile açılıp kapanıyordu, tarayıcı geçmişine hiç dokunmuyordu. Sonuç: mobilde
   kenardan geri kaydırınca ya da masaüstünde geri tuşuna basınca modal
   kapanmıyor, kullanıcı doğrudan SİTEDEN ÇIKIYORDU (ölçüldü: popstate hiç
   dinlenmiyordu). Çözüm bir "üst üste katman" yığını: her açılan katman
   (modal, sonra üstüne pdDrawer) history'ye bir durum ekler; X/backdrop/Escape/
   "Sepete Ekle" gibi KULLANICI kapatmalarında bu durum history.back() ile
   tüketilir (yoksa siteden çıkmak için "geri"ye iki kez basmak gerekirdi —
   hayalet bir kayıt kalırdı); tarayıcının GERÇEK geri jesti/tuşuyla gelindiğinde
   ise popstate yakalanır, yalnızca en üstteki katman kapatılır — modal + panel
   birlikte açıksa önce panel kapanır, siteden hiç çıkılmaz. */
/* ADRES ÇUBUĞU: koleksiyon ekranı, ürün modalı, kategori menüsü ve rehber
   paneli artık kendi adresini taşır (?koleksiyon= / ?urun=&variant= / ?menu=
   koleksiyonlar / ?rehber=1). Adres kopyalanıp açılınca ya da sayfa yenilenince
   aynı ekran açılır (bkz. derinBaglanti). Yalnız bu beş parametre değişir;
   utm_*, fbclid, gclid vb. olduğu gibi kalır. Kapı ve odalar arasında kaydırmak
   adresi DEĞİŞTİRMEZ.
   Katman yığını: her katman bir geçmiş kaydı (pushState) ekler. Kullanıcı
   kapatmasında (X, Esc, arka plan, "Sepete Ekle", alt menü ...) katman hemen
   kapanır ve kaydı history.go(-n) ile tüketilir; tarayıcının gerçek geri
   tuşunda ise yalnız en üstteki katman kapanır (önce modal, sonra koleksiyon,
   en son siteden çıkış).
   Geçmiş işlemleri SIRAYLA yürür: geri adımı eşzamansızdır; hemen ardından
   gelen pushState (ör. menü kapanıp koleksiyon açılınca) geri adımı bitmeden
   çalışırsa yeni kayıt silinirdi — bu yüzden geri sonrası işlemler popstate'i
   bekler. Katman açıkken kaydırma geri yüklemesi kapalı (manual): koleksiyon
   açıkken alt menüden başka odaya geçilince tarayıcı eski kaydın kaydırma
   konumunu geri yükleyip kullanıcıyı önceki odaya atıyordu. */
const overlayStack = [];   // {tip, kapat, params}
const KENDI_PARAMLAR = ['koleksiyon', 'urun', 'variant', 'menu', 'rehber', 'oda'];
function katmanAdresi(params){
  const eski = new URLSearchParams(location.search);
  KENDI_PARAMLAR.forEach(k => eski.delete(k));
  const q = new URLSearchParams();
  Object.keys(params || {}).forEach(k => { if(params[k] != null && params[k] !== '') q.set(k, params[k]); });
  eski.forEach((deger, ad) => q.append(ad, deger));
  const s = q.toString();
  return location.pathname + (s ? '?' + s : '') + location.hash;
}
const gecmisKuyrugu = [];
let geriBekleniyor = false, geriZamani = null;
/* 'auto'ya dönüş GECİKMELİ: Safari kaydırma konumunu popstate'ten SONRA geri
   yüklüyor; hemen 'auto' yapılırsa alt menüden geçilen oda yerine eski konuma
   atıyordu (ölçüldü: iPhone, koleksiyon açıkken alt menü → Mutfak, Banyo'da kaldı). */
let kaydirmaZamani = null;
function kaydirmaGeriYukleme(){
  clearTimeout(kaydirmaZamani);
  const bos = () => !overlayStack.length && !gecmisKuyrugu.length && !geriBekleniyor;
  if(!bos()){ try{ history.scrollRestoration = 'manual'; }catch(e){} return; }
  kaydirmaZamani = setTimeout(()=>{ if(bos()) try{ history.scrollRestoration = 'auto'; }catch(e){} }, 800);
}
function gecmisCalistir(){
  while(!geriBekleniyor && gecmisKuyrugu.length){
    const op = gecmisKuyrugu.shift();
    try{
      if(op.geri){
        geriBekleniyor = true;
        geriZamani = setTimeout(geriTamam, 1500);   // popstate gelmezse kuyruk kilitlenmesin
        history.go(-op.geri);
      }else if(op.push){
        try{ history.scrollRestoration = 'manual'; }catch(e){}
        history.pushState({sumerOverlay: true}, '', op.params ? katmanAdresi(op.params) : undefined);
      }else{
        history.replaceState(history.state, '', katmanAdresi(op.params));
      }
    }catch(e){ geriBekleniyor = false; }
  }
  if(!geriBekleniyor) kaydirmaGeriYukleme();
}
function geriTamam(){
  clearTimeout(geriZamani);
  geriBekleniyor = false;
  gecmisCalistir();
}
function gecmis(op){ gecmisKuyrugu.push(op); gecmisCalistir(); }
/* tip: 'kol' | 'urun' | 'menu' | 'rehber' | '' (adressiz; ör. detay penceresi) */
function pushOverlay(closeFn, tip, params){
  overlayStack.push({tip: tip || '', kapat: closeFn, params: params || null});
  gecmis({push: true, params: params || null});
}
/* i. katmanı ve üstündekileri kapat, kayıtlarını tek geri adımıyla tüket */
function katmanKapat(i){
  const n = overlayStack.length - i;
  if(n <= 0) return;
  for(let k = 0; k < n; k++) overlayStack.pop().kapat();   // DOM'u hemen kapat, gecikme hissettirmesin
  gecmis({geri: n});
}
function requestCloseTop(){ katmanKapat(overlayStack.length - 1); }
function katmanTipiniKapat(tip){
  for(let i = overlayStack.length - 1; i >= 0; i--){
    if(overlayStack[i].tip === tip){ katmanKapat(i); return true; }
  }
  return false;
}
/* En üstteki katman bu tipteyse adresini (aynı kayıt üzerinde) güncelle */
function katmanAdresiniGuncelle(tip, params){
  const ust = overlayStack[overlayStack.length - 1];
  if(!ust || ust.tip !== tip) return false;
  ust.params = params;
  gecmis({replace: true, params});
  return true;
}
window.addEventListener('popstate', ()=>{
  if(geriBekleniyor){ geriTamam(); return; }   // kendi geri adımımız: katman zaten kapatıldı
  if(!overlayStack.length){ kaydirmaGeriYukleme(); return; }   // bizim eklediğimiz bir durum değildi, dokunma
  /* kullanıcının gerçek geri hareketi: yalnız en üstteki katman kapanır */
  overlayStack.pop().kapat();
  kaydirmaGeriYukleme();
});
function openModal(p){
  lastFocusedEl = document.activeElement;
  /* Shopify'da karşılığı olmayan (handle'ı boş) temsili ürün, mağazada
     YAYINDAYKEN satın alınamaz. Eskiden sepete ekleniyor, "eklendi ✓"
     deniyor ve kullanıcı sorunu ancak ödeme adımında anlıyordu. Artık
     düğme en baştan kapalı ve nedeni yazıyor. */
  const satilabilir = !SHOPIFY.hosted || Boolean(p.handle);
  const ekleBtn = document.getElementById('modalAdd');
  ekleBtn.disabled = !satilabilir;
  ekleBtn.textContent = satilabilir ? 'Sepete Ekle' : 'Yakında Satışta';
  ekleBtn.classList.toggle('yakinda', !satilabilir);
  modalShare.hidden = !p.handle;   // mağazada karşılığı olmayan temsili ürün paylaşılamaz
  modalProduct = p; selSize = (p.cat === CERCEVE_KATEGORI_ADI) ? VARSAYILAN_BOYUT : 0; selFrame = DEFAULT_FRAME;
  /* Seri dışı: kalan satılabilir varyantların en ucuzu (duvar etiketindeki "…'den" fiyatının varyantı) */
  const pvs = p.vsec || (p.vbaslik ? secimIndeksi(p.vbaslik) : null);
  if(p.cat !== CERCEVE_KATEGORI_ADI && pvs){ selSize = pvs.s; selFrame = pvs.f; }
  if(p.cat !== CERCEVE_KATEGORI_ADI && kapaliSecim(selSize, selFrame)){ const ilk = FRAMES.findIndex((_, i) => !kapaliSecim(selSize, i)); if(ilk >= 0) selFrame = ilk; }
  modalSecimDegisti = false;
  modalVariants = null; // önceki ürünün varyantları yeni ürüne miras kalmasın; gerçek fiyat gelene dek çarpan tahmini kullanılır
  zoomReset();   // yeni ürün: önceki yakınlaştırma kalmasın
  document.getElementById('modalImg').src = p.src;
  document.getElementById('modalImg').alt = p.name;
  /* Duvardaki render ile birebir aynı kompozisyon: çerçeve stili (fw-black
     vb.) ve çerçeveden taşan katman (art-overflow) modalde de uygulanır —
     duvar şablonuyla aynı class/stil mantığı (bkz. oda kurulumundaki frames
     template'i). Overflow'suz ürünlerde her ikisi de temizlenir. */
  const modalFrame = document.getElementById('modalFrame');
  /* #modalFrame PAYLAŞILAN eleman: taşan üründe sıfırlanan kenar payı (bkz.
     stickerYerlestir) bir sonraki ürüne — hatta başka odadaki taşmasız bir
     ürüne — miras kalıyordu. Her açılışta satır içi payı temizle. */
  modalFrame.style.padding = '';
  modalFrame.querySelector('.art-overflow')?.remove();
  modalFrame.querySelector('.art-overflow-kagit')?.remove();   // önceki ürünün kağıt altlığı kalmasın
  modalFrame.querySelector('.art-overflow-on')?.remove();      // v3: şerit önündeki poster parçası
  modalFrame.classList.remove('ca-v3'); modalFrame.style.removeProperty('--ca-pad');
  if(p.overflow && !sadeceMockupMu(p)){
    const ov = document.createElement('img');
    ov.className = 'art-overflow';
    ov.alt = ''; ov.setAttribute('aria-hidden', 'true');
    ov.dataset.handle = p.handle || '';
    ov.src = p.overflow.src;
    stickerYerlestir(ov);   // yön/kaydırma görselin şeffaflığından ölçülür
    /* .art-mat içine: taşan katmanın yüzde konumları POSTERİN kutusuna göre
       ölçüldü. .art-frame'in dolgusu çerçeve stiline göre değiştiği için
       (çerçevesiz 0, siyah/ahşap/beyaz 10px) oraya konursa her stilde kayar. */
    modalFrame.querySelector('.art-mat').prepend(ov);
  }
  document.getElementById('modalName').textContent = p.name;
  document.getElementById('modalCat').textContent = p.cat || '';
  /* Kısa özet (p.story) artık gösterilmiyor: açıklamanın kırpılmış bir
     kopyasıydı ve tamamı detay penceresinde duruyor.
     Kaldırılması modalin kaydırmasız sığmasına yer açtı. */
  /* Duvar rengi önizlemesi her ürün açılışında AÇIK (ilk) swatch'ta başlar.
     "Çerçeveyi Aşanlar" bir dönem koyu zeminde açılıyordu; taşan parçalar gri
     tonlarda olduğu için koyu zeminde seçilmiyordu, açık zemine alındı. */
  const swatchlar = bgSwatches.querySelectorAll('.bg-swatch');
  modalImgWrap.style.background = '';
  swatchlar.forEach((b,i)=>b.classList.toggle('on', i === 0));
  /* Önceki üründen kalan taşma yön/pay bilgisini temizle (taşmasız ürün ya da
     başka oda açılırsa modal layout'u eski değerle kalmasın). */
  modalImgWrap.classList.remove('ov-ust','ov-alt','ov-sag','ov-sol');
  modalImgWrap.style.removeProperty('--ov-pay');
  renderOpts();
  /* Modal açıkken üstünde hiçbir katman kalmasın: önceki eklemenin bildirimi
     hâlâ ekrandaysa kapanır; WhatsApp düğmesi ve "%10 indirim" rozeti gizlenir
     (düğmenin köşelerini örtüyorlardı — bkz. CSS body.tur-modal-acik). */
  clearTimeout(toastTimer);
  toast.classList.remove('show');
  document.body.classList.add('tur-modal-acik');
  modalBackdrop.classList.add('open');
  pushOverlay(closeModal, 'urun', {urun: p.handle}); // "geri" jesti/tuşu siteden çıkmadan önce bunu kapatsın
  document.getElementById('modalClose').focus();
  track('view_item', {item_name: p.name, price: p.price, currency: 'TRY'});
  turUrunGoruntulendi(p);   // tek açılış = 1 olay (Meta ViewContent için; bkz. turUrunGoruntulendi)
  /* Detay penceresi ve galeri her açılışta sıfırlanır; önceki ürünün
     içeriği/fotoğrafları taşınmamalı. */
  pdDrawer.classList.remove('open');
  pdDrawer.hidden = true;
  pdOpen.hidden = true;
  pdBody.innerHTML = '';
  pdDrawerTitle.textContent = p.name;
  buildGallery([]);
  yorumPuaniGoster(p);   // yorumu varsa yıldız + (X yorum); yoksa satır gizli kalır
  if(SHOPIFY.hosted && p.handle){
    /* Sayfa yüklenirken başlatılan arka plan fiyat çekimi henüz bitmemişse
       (nadiren, çok hızlı tıklanırsa) modal açıkken sonuçlanınca fiyatı
       günceller — ürün hâlâ görüntülenen ürünse. Aynı /products/{handle}.js
       yanıtından açıklamayı ve diğer ürün fotoğraflarını da alır; ayrı bir
       istek atılmaz (fetchProductData handle başına cache'li). */
    fetchProductData(p.handle).then(prod=>{
      if(modalProduct !== p) return;
      const v = cheapestVariant(prod);
      if(v){
        const newPrice = v.price / 100, newOld = v.compare_at_price ? v.compare_at_price / 100 : 0;
        modalProduct.price = newPrice;
        modalProduct.old = newOld;
      }
      /* Gerçek varyant listesi: artık fiyat çarpanla tahmin edilmiyor, seçilen
         boyut+çerçeveye uyan varyant burada bulunup onun GERÇEK fiyatı
         gösteriliyor (bkz. eslesenVaryant/modalCurrentPrice). */
      if(prod && Array.isArray(prod.variants) && prod.variants.length){
        modalVariants = prod.variants;
        if(!modalSecimDegisti && !modalProduct.varyantId && modalProduct.cat !== CERCEVE_KATEGORI_ADI){
          const vs = varsayilanSecim(modalVariants);
          if(vs){ selSize = vs.s; selFrame = vs.f; }
        }
      }
      /* Paylaşılan linkteki ?variant= : o varyantın boyut/çerçevesi seçili gelsin */
      if(modalProduct.varyantId && modalVariants){
        const hv = modalVariants.find(x => String(x.id) === String(modalProduct.varyantId));
        if(hv){
          const t = normVariant(hv.title);
          const si = SIZES.findIndex(sz => t.includes(normVariant(sz.key)));
          if(si >= 0) selSize = si;
          const fi = FRAME_KEYS.findIndex(k => (FRAME_ALIASES[k] || []).some(a => t.includes(normVariant(a))));
          if(fi >= 0) selFrame = fi;
        }
        delete modalProduct.varyantId;
        renderOpts();
        modalAdresiniGuncelle();   // yenilenince/kopyalanınca aynı seçim gelsin
      }
      renderOpts();
      /* Shopify'ın /products/{handle}.js yanıtında alan adı "description".
         Eskiden "body_html" okunuyordu; o alan bu yanıtta olmadığı için
         panel her üründe boş kalıyor ve hiç görünmüyordu. */
      const html = (prod && (prod.description || prod.body_html)) || '';
      pdBody.innerHTML = html;
      pdOpen.hidden = !pdBody.textContent.trim();
      buildGallery(galeriGorselleri(prod, modalProduct).slice(0, 8));
      /* Sadece-mockup ürün: büyük alanda ham poster yerine ilk gerçek
         mockup fotoğrafı açılsın. */
      if(sadeceMockupMu(modalProduct) && galleryPhotos.length) showPhoto(0);
    });
  }
}
function closeModal(){
  pdDrawer.classList.remove('open');
  pdDrawer.hidden = true;
  pdOpen.setAttribute('aria-expanded', 'false');
  modalBackdrop.classList.remove('open');
  document.body.classList.remove('tur-modal-acik');
  if(lastFocusedEl){ lastFocusedEl.focus({preventScroll:true}); lastFocusedEl = null; }
}
document.getElementById('modalClose').addEventListener('click', requestCloseTop);
document.getElementById('msEkle').addEventListener('click', ()=>document.getElementById('modalAdd').click());
if('IntersectionObserver' in window){
  const msGozcu = new IntersectionObserver(girdiler=>{
    girdiler.forEach(g=>document.getElementById('modalSabit').classList.toggle('gizli', g.isIntersecting));
  }, { root: document.querySelector('#modalBackdrop .modal'), threshold: .6 });
  msGozcu.observe(document.getElementById('modalAdd'));
}
modalBackdrop.addEventListener('click', e=>{ if(e.target === modalBackdrop) requestCloseTop(); });
document.getElementById('modalAdd').addEventListener('click', function(){
  if(this.disabled) return;
  this.disabled = true;
  addToCart({
    name: modalProduct.name,
    price: modalCurrentPrice(),
    size: SIZES[selSize].label,
    sizeKey: SIZES[selSize].key,
    frame: FRAMES[selFrame],
    frameKey: FRAME_KEYS[selFrame],
    handle: modalProduct.handle || '',
    src: modalProduct.src
  });
  requestCloseTop();
});

/* ============ ÜRÜN PAYLAŞ ============
   Link ana sayfaya ?urun=<handle>&variant=<id> ile döner: tur açılır, ürünün
   odası konumlanır ve modal seçili boyut/çerçeveyle açık gelir (bkz.
   derinBaglanti). Dokunmatik cihazda telefonun paylaşım menüsü (Web Share
   API), masaüstünde panoya kopyalama + kısa bildirim. Bildirim tıklanamaz
   (bkz. showToast / .toast pointer-events). */
const modalShare = document.getElementById('modalShare');
/* Paylaşılan adres ürünün PAYLAŞIM sayfası (templates/product.paylas.liquid):
   WhatsApp/Facebook önizlemesi ürünün kendi görselini, adını ve fiyatını
   gösterir; gerçek ziyaretçi anında /?urun=<handle>&variant=<id> turuna geçer. */
function paylasimLinki(){
  const q = new URLSearchParams();
  q.set('view', 'paylas');
  const v = eslesenVaryant();
  if(v) q.set('variant', v.id);
  q.set('utm_source', 'paylasim');
  q.set('utm_medium', 'share');
  q.set('utm_campaign', 'urun-paylas');
  return 'https://sumerartdecoration.com/products/' + encodeURIComponent(modalProduct.handle) + '?' + q.toString();
}
function eskiKopyala(metin){
  const ta = document.createElement('textarea');
  ta.value = metin;
  ta.setAttribute('readonly', '');
  ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try{ ok = document.execCommand('copy'); }catch(e){}
  ta.remove();
  modalShare.focus({preventScroll:true});
  return ok;
}
function panoyaKopyala(metin){
  if(navigator.clipboard && window.isSecureContext){
    return navigator.clipboard.writeText(metin).then(()=>true, ()=>eskiKopyala(metin));
  }
  return Promise.resolve(eskiKopyala(metin));
}
modalShare.addEventListener('click', ()=>{
  if(!modalProduct || !modalProduct.handle) return;
  const url = paylasimLinki();
  const ad = modalProduct.name;
  const handle = modalProduct.handle;
  const kopyala = () => panoyaKopyala(url).then(ok=>{
    showToast(ok ? 'Link kopyalandı' : 'Link kopyalanamadı');
    if(ok) track('share', {method: 'kopyala', content_type: 'product', item_id: handle});
  });
  const dokunmatik = window.matchMedia('(pointer: coarse)').matches;
  if(dokunmatik && navigator.share){
    navigator.share({title: ad, text: ad + ' – ' + fmt(modalCurrentPrice()), url})
      .then(()=>track('share', {method: 'web_share', content_type: 'product', item_id: handle}))
      .catch(err=>{ if(!err || err.name !== 'AbortError') kopyala(); });   // vazgeçildiyse sessiz
    return;
  }
  kopyala();
});

/* Duvar etiketindeki "Tüm koleksiyonu gör" kısayolu. CAPTURE fazında
   dinleniyor: tıklama .frame-wrap'in içinde olduğu için aşağıdaki
   (bubble fazındaki) "tabloya tıklayınca modal aç" işleyicisine de
   ulaşırdı; stopPropagation ile onu kesiyoruz.
   Not: .wl-all bir <span> — üst öğe zaten <button> olduğundan içine
   ikinci bir odaklanabilir eleman koymuyoruz (geçersiz iç içe
   etkileşim olurdu). Klavye/okuyucu için koleksiyona giden diğer üç yol
   duruyor: CTA kartı, alt navigasyon, menü. */
document.addEventListener('click', e=>{
  const a = e.target.closest('.wl-all');
  if(!a) return;
  e.stopPropagation();
  e.preventDefault();
  openCollection(a.dataset.room);
}, true);

/* "Önerimiz" rozeti: dokunmatikte tıklayınca açıklama açılır/kapanır.
   CAPTURE fazında dinleniyor çünkü rozet, ölçü seçen .opt/.sg butonunun
   İÇİNDE — capture olmazsa tıklama önce butonun kendi (bubble fazındaki)
   dinleyicisine ulaşır ve ölçüyü değiştirip renderOpts() ile DOM'u yeniden
   kurar, rozet açılmadan kaybolur (bkz. yukarıdaki .wl-all ile aynı sorun).
   Masaüstünde zaten CSS :hover ile görünür; bu yalnız dokunmatik/klavye içindir. */
document.addEventListener('click', e=>{
  const b = e.target.closest('.oneri-badge');
  document.querySelectorAll('.oneri-badge.open').forEach(x=>{
    if(x !== b){ x.classList.remove('open'); x.setAttribute('aria-expanded','false'); }
  });
  if(!b) return;
  e.stopPropagation();
  e.preventDefault();
  const acik = b.classList.toggle('open');
  b.setAttribute('aria-expanded', acik ? 'true' : 'false');
}, true);
document.addEventListener('keydown', e=>{
  if(e.key !== 'Enter' && e.key !== ' ') return;
  const b = e.target.closest && e.target.closest('.oneri-badge');
  if(!b) return;
  e.preventDefault();
  const acik = b.classList.toggle('open');
  b.setAttribute('aria-expanded', acik ? 'true' : 'false');
});

/* Duvardaki tabloya tıklayınca */
document.addEventListener('click', e=>{
  const f = e.target.closest('.frame-wrap');
  if(!f) return;
  const room = ROOMS.find(r=>r.id === f.dataset.room);
  const idx = Number(f.dataset.i);
  const st = roomState[room.id];
  if(idx !== st.index){ goTo(room.id, idx); return; } // yandaki tabloya tıklarsanız önce ona yürü
  openModal(duvarEseriVerisi(room, idx));
});
/* Duvardaki eserin modal verisi (tıklama ve ?urun= derin bağlantısı aynı nesneyi kullanır) */
function duvarEseriVerisi(room, idx){
  const it = room.items[idx];
  return {name: it.name, price: it.price, old: it.old, handle: it.handle, src: artSrc(room.id, idx, it.img), cat: room.name, story: it.story, overflow: it.overflow, raw: it.raw};
}

/* ============ SEPET ============ */
/* Turun sepeti, Shopify'ın GERÇEK sepetinin bir görüntüsüdür — ayrı bir
   kopya değil. Eskiden yalnız bellekte tutuluyordu ve iki sorun çıkıyordu:
   - Sayfa yenilenince (ör. ödeme sayfasından logoyla dönünce) liste
     sıfırlanıyor, ama mağaza sepeti dolu kalıyordu; müşteri sepetini
     boş sanıyordu.
   - "Kaldır" yalnız yerel listeden siliyordu; ürün mağaza sepetinde
     kalmaya devam ediyor, ödeme adımında karşısına çıkıyordu.
   Artık her değişiklikten sonra /cart.js'ten okunur. */
let cart = [];
const cartDrawer = document.getElementById('cartDrawer');
const cartBackdrop = document.getElementById('cartBackdrop');
const cartItems = document.getElementById('cartItems');
const cartBadge = document.getElementById('cartBadge');
const cartBtn = document.getElementById('cartBtn'); // uçma animasyonunun hedefi + zıplama efektinin uygulandığı buton
const toast = document.getElementById('toast');
let toastTimer = null;

/* opts.thumb: küçük ürün görseli (varsa toast'a yuvarlak thumbnail eklenir).
   Bildirim YALNIZ BİLGİLENDİRİR, hiçbir dokunuşu almaz. Eskiden "eklendi ✓"
   bildirimi tıklanınca sepeti açıyordu; söndükten sonra (opaklık 0) bu
   tıklanabilirlik KALIYORDU ve görünmez bildirim, bir sonraki modalda
   "Sepete Ekle"nin üstüne denk gelince dokunuşu yutup sepeti açıyordu —
   ürün eklenmiyordu (ölçüldü: Çerçeveyi Aşanlar modalinde düğme tam o alanda). */
function showToast(msg, opts){
  opts = opts || {};
  toast.textContent = msg;
  toast.classList.toggle('has-thumb', Boolean(opts.thumb));
  const eski = toast.querySelector('.toast-thumb');
  if(eski) eski.remove();
  if(opts.thumb){
    const img = document.createElement('img');
    img.className = 'toast-thumb'; img.src = opts.thumb; img.alt = '';
    toast.prepend(img);
  }
  toast.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(()=>toast.classList.remove('show'), 2600);
}
/* ============ SEPETE EKLEME: UÇMA ANİMASYONU + İKON ZIPLAMASI ============
   "Sepete Ekle"ye basılan anda ekrandaki ürün görselinin bir kopyası kısa bir
   animasyonla sepet ikonuna doğru uçup küçülerek kaybolur — "ürünüm nereye
   gitti" sorusunu gözle cevaplar. reduceMotion'da anında (animasyonsuz)
   kaybolur, yalnızca ikon zıplaması çalışır. */
function bounceCartIcon(){
  if(!cartBtn) return;
  cartBtn.classList.remove('cart-bounce');
  void cartBtn.offsetWidth; // reflow: sınıf tekrar eklenince animasyon yeniden tetiklensin
  cartBtn.classList.add('cart-bounce');
}
function flyToCart(sourceImg){
  if(!cartBtn) return;
  if(!sourceImg || reduceMotion){ bounceCartIcon(); return; }
  const sRect = sourceImg.getBoundingClientRect();
  const tRect = cartBtn.getBoundingClientRect();
  if(!sRect.width || !sRect.height){ bounceCartIcon(); return; }
  const clone = document.createElement('img');
  clone.className = 'fly-to-cart-clone';
  clone.src = sourceImg.currentSrc || sourceImg.src;
  clone.alt = '';
  clone.style.left = sRect.left + 'px';
  clone.style.top = sRect.top + 'px';
  clone.style.width = sRect.width + 'px';
  clone.style.height = sRect.height + 'px';
  clone.style.opacity = '1';
  document.body.appendChild(clone);
  const dx = (tRect.left + tRect.width / 2) - (sRect.left + sRect.width / 2);
  const dy = (tRect.top + tRect.height / 2) - (sRect.top + sRect.height / 2);
  const hedefKenar = Math.max(22, tRect.width * .7);
  const scale = Math.min(1, hedefKenar / sRect.width);
  let bitti = false;
  const temizle = ()=>{
    if(bitti) return; bitti = true;
    clone.remove();
    bounceCartIcon();
  };
  requestAnimationFrame(()=>requestAnimationFrame(()=>{
    clone.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;
    clone.style.opacity = '0.15';
  }));
  clone.addEventListener('transitionend', temizle, {once:true});
  setTimeout(temizle, 900); // güvenlik: transitionend bir sebeple tetiklenmezse animasyon sonsuza dek asılı kalmasın
}
/* Shopify sepetinden oku ve çekmeceyi ona göre çiz. */
/* Shopify sepet JSON'unu (cart.js veya cart/change.js yanıtı) tur listesine
   çevirir ve çekmeceyi çizer. Tek doğruluk kaynağı mağaza sepetidir. */
function sepetiUygula(d){
  cart = ((d && d.items) || []).map(it=>{
    const v = (it.variant_title || '').split('/');
    return {
      key: it.key,                                   // satır anahtarı — silmek için gerekli
      name: it.product_title || it.title || '',
      price: (it.final_line_price != null ? it.final_line_price : it.line_price) / 100,
      // minimum sepet kuralı indirim kodundan ÖNCEKİ tutarla karşılaştırır
      orig: (it.original_line_price != null ? it.original_line_price : it.line_price) / 100,
      size: (v[0] || '').trim(),
      frame: (v[1] || '').trim(),
      handle: it.handle || '',
      src: it.image || '',
      adet: it.quantity || 1
    };
  });
  renderCart();
}
async function sepetiSunucudanYenile(){
  if(!SHOPIFY.hosted) return false;
  try{
    const res = await fetch('/cart.js', { headers:{ 'Accept':'application/json' }, cache:'no-store' });
    if(!res.ok) return false;
    sepetiUygula(await res.json());
    return true;
  }catch(err){ return false; }
}
/* Mağaza sepetinden satır siler (adet 0). change.js GÜNCEL sepeti döndürür;
   onu doğrudan uygularız — ayrıca cart.js çekmeye gerek yok (tek istek). */
async function sepettenSil(key){
  try{
    const res = await fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    if(!res.ok) return false;
    sepetiUygula(await res.json());
    return true;
  }catch(err){ return false; }
}
function renderCart(){
  const toplamAdet = cart.reduce((t,c)=>t + (c.adet || 1), 0);
  cartBadge.textContent = toplamAdet;
  cartBadge.classList.toggle('show', toplamAdet > 0);
  if(!cart.length){
    cartItems.innerHTML = '<div class="cart-empty"><svg class="rico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="4" y="4.5" width="16" height="15" rx="1.2"/><path d="M7.5 15.5l3.2-3.8 2.3 2.6 1.8-2 2.2 3.2z"/></svg><br>Sepetiniz henüz boş.<br>Evi gezerken beğendiğiniz tabloları buraya ekleyin.</div>';
  } else {
    cartItems.innerHTML = cart.map((c,i)=>`
      <div class="cart-item">
        <img src="${c.src}" alt="">
        <div class="ci-info">
          <h5 class="line-clamp-2">${c.name}</h5>
          <div class="ci-meta">${[c.size, c.frame].filter(Boolean).join(' · ')}${c.adet > 1 ? ` · ${c.adet} adet` : ''}</div>
          <div class="ci-price">${fmt(c.price)}</div>
        </div>
        <button class="ci-remove" data-i="${i}">Kaldır</button>
      </div>`).join('');
    cartItems.querySelectorAll('.ci-remove').forEach(b=>b.addEventListener('click', async ()=>{
      const i = Number(b.dataset.i);
      const satir = cart[i];
      if(!satir) return;
      /* İYİMSER kaldırma: satır anında listeden çıkar ve çizilir, ağ isteği
         arkada döner. Eskiden önce POST /cart/change.js sonra GET /cart.js —
         iki ardışık istek bitene kadar satır ekranda kalıyordu; yavaş bağlantıda
         "Kaldır'a bastım ama gitmiyor" hissi veriyordu. Anahtara göre çıkarıyoruz
         (yeniden çizimlerde indeks kayabilir). Mağaza yetkili kaynak: sepettenSil,
         change.js'in döndürdüğü GÜNCEL sepeti uygular; hata olursa geri alınır. */
      if(SHOPIFY.hosted && satir.key){
        const yedek = cart.slice();
        cart = cart.filter(c=>c.key !== satir.key);
        renderCart();
        const ok = await sepettenSil(satir.key);
        if(!ok){ cart = yedek; renderCart(); showToast('Ürün kaldırılamadı, tekrar deneyin.'); }
        return;
      }
      cart.splice(i, 1); renderCart();
    }));
  }
  document.getElementById('cartTotal').textContent = fmt(cart.reduce((s,c)=>s+c.price, 0));
  /* Minimum sepet tutarı (Tema ayarları; KDV dahil, indirim kodundan önce).
     İyimser eklenen satırda orig yok — onun price'ı zaten katalog fiyatı. */
  const minSepet = Number(document.getElementById('cartDrawer').dataset.minSepet) || 0;
  const araToplam = cart.reduce((s,c)=>s + (c.orig != null ? c.orig : c.price), 0);
  const minAltinda = minSepet > 0 && cart.length > 0 && araToplam < minSepet;
  const odemeBtn = document.getElementById('checkoutBtn');
  odemeBtn.disabled = minAltinda;
  /* Boş sepette ödeme yerine koleksiyonlara yönlendir (turdaki kategori menüsü) */
  odemeBtn.textContent = cart.length ? 'Ödemeye Geç' : 'Koleksiyonlara göz at';
  odemeBtn.dataset.bos = cart.length ? '' : '1';
  const kalanEl = document.querySelector('#cartMinUyari .cart-min-kalan');
  if(kalanEl) kalanEl.textContent = fmt(Math.max(0, minSepet - araToplam));
  document.getElementById('cartMinUyari').hidden = !minAltinda;
  if(modalBackdrop.classList.contains('open')) modalEkBilgileriGuncelle();
}
/* Shopify'da barındırıldığında gerçek sepete ekler:
   handle'dan ürünü çeker, seçilen boyut+çerçeveye uyan varyantı bulur */
/* Seçilen boyut+çerçeveye uyan varyantı bulur. Bulamazsa null döner —
   "yakın olanı" tahmin etmek yanlış ürünün satılması demek olurdu.
   Tek varyantlı ürünlerde seçenek zaten yok, o varyant kullanılır. */
function matchVariant(prod, item){
  const vs = prod.variants || [];
  if(vs.length === 1) return vs[0];
  const wantSize  = normVariant(item.sizeKey);
  const wantFrame = (FRAME_ALIASES[item.frameKey] || []).map(normVariant);
  const hit = vs.filter(v=>{
    const t = normVariant(v.title);
    const sizeOk  = !wantSize  || t.includes(wantSize);
    const frameOk = !wantFrame.length || wantFrame.some(a=>t.includes(a));
    return sizeOk && frameOk;
  });
  if(hit.length) return hit.find(v=>v.available) || hit[0];
  /* Çerçeve boyutu olmayan ürünler (ör. sadece boyut varyantı) için
     yalnız boyuta göre eşleşmeye izin ver. */
  if(wantSize && vs.every(v=>!wantFrame.some(a=>normVariant(v.title).includes(a)))){
    const bySize = vs.filter(v=>normVariant(v.title).includes(wantSize));
    const frameless = vs.some(v=>/cercevesiz|siyah|ahsap|beyaz/.test(normVariant(v.title)));
    if(bySize.length && !frameless) return bySize.find(v=>v.available) || bySize[0];
  }
  return null;
}
async function shopifyAdd(item){
  if(!SHOPIFY.hosted || !item.handle) return false;
  try{
    let prod = await fetchProductData(item.handle);
    if(!prod) prod = await fetchProductData(item.handle);   // önceki deneme başarısızdı: bir kez taze istek
    if(!prod) return false;
    const v = matchVariant(prod, item);
    /* Eşleşme yoksa rastgele varyant EKLENMEZ: müşteri Beyaz seçip
       Çerçevesiz satın almış olurdu. Sessiz kalmak yerine uyarılır. */
    if(!v){
      showToast('Bu seçenek için varyant bulunamadı — ürün sayfasından seçebilirsiniz.');
      return false;
    }
    /* keepalive: "Sepete Ekle" tıklamasının hemen ardından requestCloseTop()
       modalı kapatırken history.back() çağırıyor (geri jesti düzeltmesi).
       Masaüstünde zararsız ama MOBİL tarayıcılar (özellikle iOS Safari) bir
       history hareketini sayfadan ayrılma sinyali sayıp devam eden fetch'i
       kesintiye uğratabiliyor — ölçüm: "panel her zaman açılıyor ama ürün
       bazen sepete girmiyor" şikayeti yalnız mobilde, tek tıklamada,
       ağ hızından bağımsız oluyordu; tam da bu kesintinin imzası.
       keepalive:true isteğin sayfa/nav olaylarından etkilenmeden
       tamamlanmasını garanti eder. */
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: v.id, quantity: 1}),
      keepalive: true
    });
    return res.ok;
  }catch(err){ return false; }
}
function addToCart(item){
  /* Optimistic UI: önce yerel listeye eklenip anında gösterilir (his hızlı
     kalsın), gerçek ekleme arkaplanda yürür. BAŞARISIZ olursa aşağıda bu
     satır GERİ ALINIR — eskiden yalnız toast gösterilip "hayalet" satır
     panelde kalıcı kalıyordu (gerçek Shopify sepetine hiç girmemiş bir
     ürün eklenmiş gibi görünüyordu). */
  cart.push(item);
  renderCart();
  flyToCart(document.getElementById('modalImg'));
  showToast(`"${item.name}" sepete eklendi ✓`, {thumb: item.src});
  return shopifyAdd(item).then(async ok=>{
    /* Ekleme başarılıysa listeyi sunucudan tazele: fiyat, adet ve satır
       anahtarı mağazadan gelsin (tek doğruluk kaynağı). add_to_cart olayı
       yalnız BAŞARILI eklemeden sonra (iyimser ekleme anında değil). */
    if(ok){
      track('add_to_cart', {item_name: item.name, price: item.price, currency: 'TRY'});
      await sepetiSunucudanYenile();
    } else {
      const i = cart.indexOf(item);
      if(i > -1) cart.splice(i, 1);   // hayalet satırı geri al
      renderCart();
      if(SHOPIFY.hosted) showToast(`"${item.name}" sepete eklenemedi — lütfen tekrar deneyin.`);
    }
  });
}
function openCart(){
  lastFocusedEl = document.activeElement;
  cartDrawer.classList.add('open');
  cartBackdrop.classList.add('open');
  document.body.classList.add('tur-sepet-acik');   // WhatsApp düğmesi panelin üstüne binmesin (bkz. CSS)
  document.getElementById('cartClose').focus();
}
function closeCart(){
  cartDrawer.classList.remove('open');
  cartBackdrop.classList.remove('open');
  document.body.classList.remove('tur-sepet-acik');
  if(lastFocusedEl){ lastFocusedEl.focus({preventScroll:true}); lastFocusedEl = null; }
}
document.getElementById('cartBtn').addEventListener('click', openCart);
document.getElementById('cartClose').addEventListener('click', closeCart);
cartBackdrop.addEventListener('click', closeCart);
document.getElementById('checkoutBtn').addEventListener('click', ()=>{
  if(document.getElementById('checkoutBtn').disabled) return;   // minimum sepet tutarı altında
  if(document.getElementById('checkoutBtn').dataset.bos === '1'){ closeCart(); openMenu(false); return; }   // boş sepet → koleksiyonlar
  track('begin_checkout', {value: cart.reduce((t,c)=>t+c.price,0), currency: 'TRY'});
  /* Sepette gerçek (handle'lı) ürün yoksa mağaza sepeti de boştur — kullanıcıyı
     boş bir /cart sayfasına göndermek yerine durumu açıkça söyleriz. Bu, tur
     henüz temsili ürünlerle yayındayken (koleksiyonlar kurulmadan) olur. */
  if(SHOPIFY.hosted && !cart.some(c=>c.handle)){
    showToast('Bu eserler yakında satışta — sepete eklemek için birazdan tekrar bakın.');
    return;
  }
  /* DOĞRUDAN /checkout: /cart Shopify'ın (Dawn kökenli) sepet sayfasını
     açıyordu ve oradaki menüden müşteri turun dışına, eski tema
     görünümündeki koleksiyon sayfalarına düşüyordu. Turun kendi sepet
     çekmecesi zaten var; ara sayfaya gerek yok. Ödeme adımına hiç
     dokunulmuyor. */
  if(SHOPIFY.hosted){ location.href = shopUrl('/checkout'); }
  else if(cart.some(c=>c.handle)){ window.open(shopUrl('/checkout'), '_blank'); }
  else { showToast('Demo mod — Shopify sayfası olarak yayınlandığında gerçek sepete gider.'); }
});
renderCart();
sepetiSunucudanYenile();   // sayfa açılışında mağaza sepetini yansıt

/* ============ MENÜ ============ */
const menuOverlay = document.getElementById('menuOverlay');
const menuList = document.getElementById('menuList');
function openMenu(focusSearch){
  lastFocusedEl = document.activeElement;
  if(!menuOverlay.classList.contains('open')) pushOverlay(menuDomKapat, 'menu', {menu: 'koleksiyonlar'});
  menuOverlay.classList.add('open');
  document.body.classList.add('tur-menu-acik');   // WhatsApp düğmesi menü linklerinin üstüne binmesin (bkz. CSS)
  if(focusSearch) setTimeout(()=>menuOverlay.querySelector('input')?.focus(), 500);
  else document.getElementById('menuClose').focus();
}
function closeMenu(){
  if(!katmanTipiniKapat('menu')) menuDomKapat();
}
function menuDomKapat(){
  menuOverlay.classList.remove('open');
  document.body.classList.remove('tur-menu-acik');
  if(lastFocusedEl){ lastFocusedEl.focus({preventScroll:true}); lastFocusedEl = null; }
}

/* Menüden kategori seçimi artık DUVAR TURUNA değil, doğrudan o kategorinin
   ÜRÜN LİSTESİNE (koleksiyon görünümü) gider — "Kalan N Ürüne Ulaşın"ın
   açtığı ekranın aynısı. Gerekçe: menüden bir kategori seçen kullanıcının
   amacı genelde o kategorideki TÜM ürünleri görmek, turu baştan gezmek
   değil. Hem mobil hem masaüstünde aynı davranış.
   <a href="#oda"> yerine <button>: artık sayfa içi bağlantı değil, bir
   eylem — ayrıca mobilde smooth-scroll ile uzun kayma sorununu da
   tamamen ortadan kaldırır. */
ROOMS.forEach(r=>{
  const li = document.createElement('li');
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.innerHTML = `<span class="mi-ico">${r.ico}</span>${r.name}`;
  btn.addEventListener('click', ()=>{ closeMenu(); openCollection(r.id); });
  li.appendChild(btn);
  menuList.appendChild(li);
});

/* "Çerçeveler ve Diğer Ürünler" — ROOMS'a dahil DEĞİL (bkz. MENU_EK_KATEGORI
   tanımı yukarıda), o yüzden duvar sahnesi/alt navigasyon döngülerine hiç
   girmiyor. Artık diğer 9 oda ile BİREBİR AYNI mekanizmayı kullanıyor:
   sayfa değişmez, openCollection() aynı overlay'i açar — kullanıcı isteği
   üzerine gerçek sayfa linkinden bu davranışa çevrildi. */
MENU_EK_KATEGORI.forEach(r=>{
  const li = document.createElement('li');
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.innerHTML = `<span class="mi-ico"><svg class="rico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3.5" y="3.5" width="17" height="17" rx="1.4"/><rect x="7" y="7" width="10" height="10" rx=".6"/></svg></span>${r.name}`;
  btn.addEventListener('click', ()=>{ closeMenu(); openCollection(r.id); });
  li.appendChild(btn);
  menuList.appendChild(li);
});

document.getElementById('burgerBtn').addEventListener('click', ()=>{ acikPaneliKapat(); openMenu(false); });
/* Panel tam ekran sabit bir katman; logoya veya hamburgere basıldığında
   kapanmazsa kullanıcı tıkladığı halde hiçbir şey olmamış gibi görür
   (logo #hero'ya gider ama panel önde durmaya devam eder). */
function acikPaneliKapat(){
  const acik = document.querySelector('.info-panel.open');
  if(acik) closePanel(acik.id);
}
document.querySelector('.site-header .logo')?.addEventListener('click', e=>{
  acikPaneliKapat();
  /* MOBİLDE ANLIK: logo <a href="#hero"> olduğu için tarayıcı
     html{scroll-behavior:smooth} yüzünden tüm sayfa boyunca (on binlerce
     piksel) yavaşça kaydırıyordu. Mobilde varsayılan atlamayı iptal edip
     doğrudan tepeye koyuyoruz. Masaüstünde davranış değişmedi. */
  if(!mobilMi()) return;
  e.preventDefault();
  window.scrollTo({ top: 0, behavior: 'instant' });
});
document.getElementById('menuClose').addEventListener('click', closeMenu);
document.getElementById('menuCartBtn').addEventListener('click', ()=>{ closeMenu(); openCart(); });

/* ============ BİLGİ PANELLERİ (İletişim / Rehber) ============
   Menüdeki bağlantılar eskiden mağazanın diğer sayfalarına gidiyordu ve
   tur bölünüyordu. Artık aynı sayfada, koleksiyon paneliyle aynı görsel
   dilde açılıyorlar. */
function openPanel(id){
  const el = document.getElementById(id);
  if(!el) return;
  lastFocusedEl = document.activeElement;
  closeMenu();
  el.classList.add('open');
  /* Panel açıkken başlık üstte kalır (logo ile ana sayfaya, menüyle
     odalara dönülebilsin); koyu metne zorlanır çünkü panelin zemini krem. */
  document.body.classList.add('panel-open');
  document.body.style.overflow = 'hidden';
  const kapat = el.querySelector('.ip-close');
  if(kapat) kapat.focus();
  if(id === 'guidePanel' && !katmanAdresiniGuncelle('rehber', {rehber: '1'})) pushOverlay(()=>panelDomKapat('guidePanel'), 'rehber', {rehber: '1'});
}
function closePanel(id){
  if(id === 'guidePanel' && katmanTipiniKapat('rehber')) return;
  panelDomKapat(id);
}
function panelDomKapat(id){
  const el = document.getElementById(id);
  if(!el) return;
  el.classList.remove('open');
  document.body.classList.remove('panel-open');
  document.body.style.overflow = '';
  if(lastFocusedEl){ lastFocusedEl.focus({preventScroll:true}); lastFocusedEl = null; }
}
document.addEventListener('click', e=>{
  const b = e.target.closest('[data-close-panel]');
  if(b) closePanel(b.dataset.closePanel);
});
const menuGuideBtn = document.getElementById('menuGuideBtn');
if(menuGuideBtn) menuGuideBtn.addEventListener('click', ()=>openPanel('guidePanel'));
const menuContactBtn = document.getElementById('menuContactBtn');
/* menuContactBtn artık gerçek bir link (/pages/contact; tarayıcılar ve Google
   için). Normal dokunuş/tıklamada sayfaya gitmeden paneli açar; yeni sekmede
   açma (Ctrl/Cmd/orta tuş) ise sayfaya gider. */
if(menuContactBtn) menuContactBtn.addEventListener('click', e=>{
  if(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
  e.preventDefault();
  openPanel('contactPanel');
});

/* Rehber: liste -> yazı okuyucu. Yazı içerikleri sayfada gizli duruyor
   (#guideData), böylece tıklamada ek istek atılmıyor. */
const guideList = document.getElementById('guideList');
const guideArticle = document.getElementById('guideArticle');
const guideData = document.getElementById('guideData');
function showArticle(i){
  if(!guideData || !guideArticle) return;
  const kaynak = guideData.content.children[i];
  if(!kaynak) return;
  document.getElementById('gaTitle').textContent = kaynak.dataset.title || '';
  document.getElementById('gaDate').textContent = kaynak.dataset.date || '';
  document.getElementById('gaBody').innerHTML = kaynak.innerHTML;
  guideList.style.display = 'none';
  guideArticle.classList.add('on');
  document.getElementById('guidePanel').scrollTop = 0;
}
function showGuideList(){
  if(!guideArticle) return;
  guideArticle.classList.remove('on');
  guideList.style.display = '';
  document.getElementById('guidePanel').scrollTop = 0;
}
if(guideList) guideList.addEventListener('click', e=>{
  const it = e.target.closest('.guide-item');
  if(!it) return;
  /* .guide-item gerçek yazı bağlantısı (SEO): düz tıklamada tur içi okuyucu, Ctrl/orta tık yeni sekmede yazı sayfası */
  if(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
  e.preventDefault();
  showArticle(Number(it.dataset.article));
});
const guideBack = document.getElementById('guideBack');
if(guideBack) guideBack.addEventListener('click', showGuideList);

/* Esc ile açık paneli kapat */
document.addEventListener('keydown', e=>{
  if(e.key !== 'Escape') return;
  const acik = document.querySelector('.info-panel.open');
  if(acik) closePanel(acik.id);
});

/* Shopify contact formu gönderilince sayfa yeniden yüklenir ve URL'e
   ?contact_posted=true eklenir. Kullanıcı başarı mesajını görebilsin diye
   paneli otomatik açıyoruz. */
if(location.search.indexOf('contact_posted=true') > -1){
  setTimeout(()=>openPanel('contactPanel'), 350);
}
/* Prototipte (mağaza dışında) formun gideceği bir yer yok — sayfayı boşuna
   yeniden yüklemesin diye gönderimi durdurup bilgi veriyoruz. Mağazada
   Liquid gerçek bir action ürettiği için bu dal çalışmaz. */
const tourForm = document.getElementById('tourContactForm');
if(tourForm && !tourForm.getAttribute('action')){
  tourForm.addEventListener('submit', e=>{
    e.preventDefault();
    showToast('Demo mod — mağazada yayınlandığında mesaj gerçekten gönderilir.');
  });
}


document.getElementById('searchBtn').addEventListener('click', ()=>openMenu(true));

function activeOverlayPanel(){
  if(modalBackdrop.classList.contains('open')) return modalBackdrop;
  if(cartDrawer.classList.contains('open')) return cartDrawer;
  if(menuOverlay.classList.contains('open')) return menuOverlay;
  if(collection.classList.contains('open')) return collection;
  return null;
}
window.addEventListener('keydown', e=>{
  if(e.key === 'Escape'){
    /* Detay penceresi açıksa Esc önce onu kapatır; kullanıcı ürün
       seçimini kaybetmez. */
    if(pdDrawer.classList.contains('open')) requestCloseTop();
    else if(modalBackdrop.classList.contains('open')) requestCloseTop();
    else if(cartDrawer.classList.contains('open')) closeCart();
    else if(menuOverlay.classList.contains('open')) closeMenu();
    else if(collection.classList.contains('open')) closeCollection();
    return;
  }
  if(e.key === 'Tab'){
    const panel = activeOverlayPanel();
    if(!panel) return;
    const focusables = panel.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
    if(!focusables.length) return;
    const first = focusables[0], last = focusables[focusables.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }
});

/* ════════ MOBİL: KAPI GİRİŞİ + TEK HAREKET = TEK ADIM ════════
   Yalnız dar ekranda (max-width:767px). Masaüstünün kaydırma modeli,
   kapı taraması ve snap'i HİÇ değişmedi.

   NEDEN (ölçüldü, Pixel 7 · CDP gerçek dokunma):
   1) Kapı sahnesi kaydırmayla taranıyordu ve doğal kaydırmadaydı. Kapının
      sonunda tek bir fırlatma tarayıcı momentumuyla sayfayı 1.400+ px
      sürüklüyor, momentum odaya taşınca updateRooms'taki kaydırma→indeks
      eşlemesi (Math.round) ürünleri art arda ilerletiyordu.
   2) Oda komut modunun kilidi 400 ms'ydi, geçiş ise ~1 sn (oda fotoğrafı
      crossfade 1 sn + eser belirmesi 0,22+0,6 sn). Kilit sırasındaki
      dokunuşlar yakalanmıyor (oda0=null, preventDefault yok) ve doğal
      kaydırma+momentuma düşüyordu: 3 fırlatma → 4 ürün, üst üste geçişler.

   ŞİMDİ:
   - Kapı: kaydırmayla taranmaz. İlk dokunuş ya da ilk kaydırma hareketi
     playDoorIntro()'yu başlatır; giriş sabit hızda kendiliğinden oynar,
     ardından mevcut crossfade ile ilk odaya geçer. Bu sırada tam ekran
     görünmez bir kilit tüm girdileri yutar. Kapı yalnız girişte görünür:
     odadan geri kaydırma kapıya dönmez (bilinçli dönüş: logo → sayfa başı).
   - Oda: bir hareket = en fazla bir adım (eşik ~50 px ya da belirgin hız).
     Kilit, kaydırma hedefe oturup geçiş animasyonu bitene dek (+150 ms)
     sürer; bu sürede gelen dokunuşlar da doğal kaydırmaya DÜŞMEZ, yok
     sayılır. Yatay kaydırma aynı kurala uyar. İki parmak hareketi adım
     sayılmaz ve sahneyi kaydırmaz. */
const MOBIL_GECIS_MS = 1000;      // oda fotoğrafı crossfade süresi (CSS .room-photo opacity 1s) ≥ eser belirmesi (0,22+0,6 sn)
const MOBIL_GECIS_PAYI_MS = 150;  // geçiş bittikten sonra ek bekleme
const mobilAdim = { kilit: false };   // ok/nokta tıklamaları da bu kilide uyar (bkz. adimKomutu)
/* Mobilde tek adımlık geçişi başlat ve kilitle. Kaydırma, tarayıcının
   yumuşak kaydırması yerine kendi animasyonumuzla yapılır: tarayıcınınki yeni
   bir dokunuşla yarıda kesilebiliyor, sayfa iki adımın arasında kalıyordu
   (ölçüldü). Kilit, kaydırma bitip geçiş animasyonu tamamlanınca (+pay)
   açılır; kare döngüsü durursa (ör. sekme arka planda) 3 sn'lik yedek
   zamanlayıcı kilidi her koşulda açar — sahne asla donmaz. */
const MOBIL_KAYDIRMA_MS = 600;
function adimKomutu(oda, idx){
  if(mobilAdim.kilit) return false;
  mobilAdim.kilit = true;
  const bas = performance.now();
  const birak = () => { mobilAdim.kilit = false; };
  const yedek = setTimeout(birak, 3000);
  kaydirAnim(adimKonumu(oda, idx), reduceMotion ? 0 : MOBIL_KAYDIRMA_MS, yumusak).then(() => {
    const kalan = Math.max(0, MOBIL_GECIS_MS - (performance.now() - bas));
    setTimeout(() => { clearTimeout(yedek); birak(); }, kalan + MOBIL_GECIS_PAYI_MS);
  });
  return true;
}

/* ── KAPI GİRİŞİ ──
   Tek entegrasyon noktası: window.sumerKapiIntro (ör. bölüm Liquid'inden):
     { tip: 'kaydirma' }                       → bugünkü kare dizisi / iOS video yedeği,
                                                 sabit hızda kendiliğinden taranır (varsayılan)
     { tip: 'video', url: '…mp4', azamiSure }  → tek bir video dosyası (ör. Kling kapı geçişi)
                                                 kapının üstünde baştan sona oynar, sonra crossfade
   sure: kapı animasyonu (ms), gecis: odaya crossfade (ms). */
const KAPI_INTRO = Object.assign({ tip: 'kaydirma', sure: 1800, gecis: 750 }, window.sumerKapiIntro || {});
const kapiGiris = { durum: 'yok' };   // 'bekliyor' · 'oynuyor' · 'bitti'  (masaüstünde 'yok')
const kapiKilidi = document.createElement('div');
kapiKilidi.className = 'kapi-kilit';
kapiKilidi.setAttribute('aria-hidden', 'true');
['touchstart', 'touchmove', 'touchend', 'wheel', 'click'].forEach(t => kapiKilidi.addEventListener(t, e => { e.preventDefault(); e.stopPropagation(); }, { passive: false }));

/* Animasyonlu kaydırma (html'deki scroll-behavior:smooth'tan bağımsız; her
   kare 'instant'). Kapı karesi, video taraması ve odanın crossfade'i zaten
   kaydırma konumundan çizildiği için girişin bütün görseli aynen yeniden
   kullanılır. */
function kaydirAnim(hedef, sure, egri){
  return new Promise(res => {
    const y0 = window.scrollY, fark = hedef - y0, bas = performance.now();
    if(sure <= 0 || Math.abs(fark) < 1){ window.scrollTo({ top: hedef, behavior: 'instant' }); return res(); }
    (function kare(){
      const t = Math.min(1, (performance.now() - bas) / sure);
      window.scrollTo({ top: y0 + fark * (egri ? egri(t) : t), behavior: 'instant' });
      if(t < 1) requestAnimationFrame(kare); else res();
    })();
  });
}
function yumusak(t){ return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
/* Giriş başlamadan kapı görseli hazır olsun (ağ yavaşsa en fazla ~1,2 sn beklenir) */
function kapiHazir(){
  return new Promise(res => {
    const bas = performance.now();
    (function bak(){
      const kanvas = document.getElementById('heroKare');
      const hazir = kareDizisi ? (kanvas && kanvas.dataset.kaba === '1')
                  : (hasVideo ? heroVideo.readyState >= 3 : true);
      if(hazir || performance.now() - bas > 1200) return res();
      setTimeout(bak, 60);
    })();
  });
}
function videoGirisi(url, azami){
  return new Promise(res => {
    const v = document.createElement('video');
    v.className = 'hero-intro-video';
    v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.preload = 'auto'; v.src = url;
    heroSticky.appendChild(v);
    let bitti = false;
    const bit = () => { if(!bitti){ bitti = true; res(v); } };
    v.addEventListener('ended', bit, { once: true });
    v.addEventListener('error', bit, { once: true });
    setTimeout(bit, azami || 9000);
    const oyna = v.play(); if(oyna && oyna.catch) oyna.catch(bit);
  });
}
function playDoorIntro(kaynak){
  kaynak = kaynak || KAPI_INTRO;
  if(kapiGiris.durum !== 'bekliyor') return;
  kapiGiris.durum = 'oynuyor';
  document.body.appendChild(kapiKilidi);
  heroHint.classList.add('kapi-gizli');
  const ilkOda = ROOMS[0] && ROOMS[0].id;
  const bitis = ilkOda ? adimKonumu(ilkOda, 0) : hero.offsetTop + hero.offsetHeight;
  const kapiSonu = hero.offsetTop + (hero.offsetHeight - window.innerHeight) * .88;   // son kare (bkz. heroVideoScrub: p/.88)
  let akis;
  if(reduceMotion){
    akis = kaydirAnim(bitis, 0);
  } else if(kaynak.tip === 'video' && kaynak.url){
    akis = videoGirisi(kaynak.url, kaynak.azamiSure).then(v => kaydirAnim(bitis, kaynak.gecis || 750, yumusak).then(() => v.remove()));
  } else {
    akis = kapiHazir()
      .then(() => kaydirAnim(kapiSonu, kaynak.sure || 1800))          // kapı sabit hızda sonuna kadar
      .then(() => kaydirAnim(bitis, kaynak.gecis || 750, yumusak));   // mevcut crossfade ile ilk odaya
  }
  akis.then(() => {
    if(ilkOda) goToRoomStart(ilkOda, true);   // 0. adımı kesinleştir (indeks + eser opaklığı)
    setTimeout(() => {
      kapiGiris.durum = 'bitti';
      kapiKilidi.remove();
      heroHint.classList.remove('kapi-gizli');
    }, MOBIL_GECIS_PAYI_MS);
  });
}

if(window.matchMedia('(max-width: 767px)').matches){
  /* Kapı ipucu: mobilde dokunmayı da söyler (mevcut ipucu stili) */
  if(heroHint && heroHint.firstChild && heroHint.firstChild.nodeType === 3) heroHint.firstChild.nodeValue = 'Kaydır ya da dokun ';
  kapiGiris.durum = window.scrollY > 10 ? 'bitti' : 'bekliyor';
  /* Kapı beklerken sayfa programla kaydırılırsa (derin bağlantı, alt oda
     şeridi, geri yüklenen konum) giriş atlanmış sayılır; kapının ortasında
     kalınmışsa ilk odaya oturtulur. Sayfa başına bilinçli dönüşte (logo)
     kapı yeniden bekler. */
  window.addEventListener('scroll', ()=>{
    if(kapiGiris.durum === 'bekliyor' && window.scrollY > 10){
      kapiGiris.durum = 'bitti';
      /* Programla yapılan (yumuşak) kaydırma yarıda kesilmesin: kaydırma
         tamamen DURDUKTAN sonra hâlâ kapının içinde kalınmışsa ilk odaya oturt. */
      const ilk = ROOMS[0] && ROOMS[0].id;
      let sonY = -1, sabit = 0;
      const bak = setInterval(() => {
        const y = window.scrollY;
        sabit = y === sonY ? sabit + 1 : 0; sonY = y;
        if(sabit < 2) return;
        clearInterval(bak);
        if(ilk && y > 10 && y < adimKonumu(ilk, 0) - 5 && !ustteAcikKatmanVar()) goToRoomStart(ilk, true);
      }, 100);
    } else if(kapiGiris.durum === 'bitti' && window.scrollY < 2){
      kapiGiris.durum = 'bekliyor';
    }
  }, { passive:true });
  if(kapiGiris.durum === 'bitti'){
    const ilk = ROOMS[0] && ROOMS[0].id;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if(ilk && window.scrollY > 10 && window.scrollY < adimKonumu(ilk, 0) - 5 && !ustteAcikKatmanVar()) goToRoomStart(ilk, true);
    }));
  }

  /* Ekran ortasındaki GERÇEK oda (hero değil); yoksa null. */
  function merkezOda(){
    const orta = window.innerHeight / 2;
    for(const r of ROOMS){
      const sec = document.getElementById(r.id);
      if(!sec || !roomState[r.id]) continue;
      const q = sec.getBoundingClientRect();
      if(q.top <= orta && q.bottom >= orta) return r.id;
    }
    return null;
  }
  /* Hareketin ait olduğu bölge:
     'kapi'  → giriş bekliyor/oynuyor (hareket girişi başlatır, kaydırmaz)
     <oda>   → oda bandı: her hareket tek adım komutu
     'kuyruk'→ son odanın hemen altı (tur sonu): geri yönde hareket son
               odanın son adımına komut olur (momentum odaya taşınmasın);
               ileri yön doğal kaydırma (tur sonu, footer)
     null    → açık katman ya da sayfanın geri kalanı: doğal kaydırma */
  const UST_ARAYUZ = '.site-header, .announce-bar, .bottom-nav, #wfb-widget-container, .menu-overlay, .modal-backdrop, .cart-drawer, .collection, .info-panel, .kapi-kilit, shopify-forms-embed, .kapi-koleksiyon';
  function bolge(hedefEl){
    if(ustteAcikKatmanVar()) return null;
    if(hedefEl && hedefEl.closest && hedefEl.closest(UST_ARAYUZ)) return null;
    if(kapiGiris.durum === 'bekliyor' || kapiGiris.durum === 'oynuyor') return 'kapi';
    const oda = merkezOda();
    if(oda) return oda;
    const son = ROOMS[ROOMS.length - 1] && document.getElementById(ROOMS[ROOMS.length - 1].id);
    if(son){
      const q = son.getBoundingClientRect();
      if(q.bottom < window.innerHeight / 2 && q.bottom > -window.innerHeight * 1.2) return 'kuyruk';
    }
    return null;
  }

  const ESIK_PX = 50, HIZ_ESIGI = 0.45, HIZ_MIN_PX = 20;   // px · px/ms · px
  let jest = null;   // { bolge, x0, y0, t0, eksen, iptal }

  /* SIZINTI: dokunuş üst şeritte, başlıkta ya da alt oda çubuğunda başlarsa bolge()
     null döner ve hareket TARAYICIYA kalıyordu. Kapı/oda bandında bu, doğal
     kaydırma + momentum demekti: hızlı harekette sayfa en üstü aşıp (iOS lastik
     geri sekmesi) sabit üst şeridi ve başlığı aşağı itiyor, boşalan yerde html
     tuvalinin açık rengi görünüyordu ("üstte beyaz bant"); ortada da adımlar
     kayıyordu. Bu öğelerde artık yalnız dokunma/tıklama ve alt çubuğun YATAY
     kaydırması serbest; dikey hareket iptal edilir (katmanlar — menü, sepet,
     ürün penceresi, koleksiyon — kendi kaydırmalarını korur). */
  const SABIT_UI = '.site-header, .announce-bar, .bottom-nav, .room-progress';
  let sabitJest = null;
  window.addEventListener('touchstart', e=>{
    const el = e.target && e.target.closest ? e.target.closest(SABIT_UI) : null;
    sabitJest = (el && !ustteAcikKatmanVar()) ? { x0: e.touches[0].clientX, y0: e.touches[0].clientY, alt: el.classList.contains('bottom-nav'), eksen: null } : null;
  }, { passive:true, capture:true });
  window.addEventListener('touchmove', e=>{
    if(!sabitJest || !e.cancelable) return;
    if(e.touches.length > 1){ e.preventDefault(); return; }
    const t = e.touches[0], dx = t.clientX - sabitJest.x0, dy = t.clientY - sabitJest.y0;
    if(!sabitJest.eksen && (Math.abs(dx) > 4 || Math.abs(dy) > 4)) sabitJest.eksen = (sabitJest.alt && Math.abs(dx) > Math.abs(dy)) ? 'x' : 'y';
    if(sabitJest.eksen !== 'x') e.preventDefault();   // alt çubukta yatay kaydırma serbest, dikey hiçbir yerde değil
  }, { passive:false, capture:true });
  window.addEventListener('touchend', ()=>{ sabitJest = null; }, { passive:true, capture:true });

  window.addEventListener('touchstart', e=>{
    const b = bolge(e.target);
    if(!b){ jest = null; return; }
    const t = e.touches[0];
    jest = { bolge: b, x0: t.clientX, y0: t.clientY, t0: performance.now(), eksen: null, iptal: e.touches.length > 1 };
  }, { passive:true });

  window.addEventListener('touchmove', e=>{
    if(!jest) return;
    if(e.touches.length > 1){ jest.iptal = true; if(jest.bolge !== 'kuyruk') e.preventDefault(); return; }   // iki parmak: adım sayılmaz, sahne kaymaz
    const t = e.touches[0];
    const dx = t.clientX - jest.x0, dy = t.clientY - jest.y0;
    if(!jest.eksen && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) jest.eksen = Math.abs(dy) >= Math.abs(dx) ? 'y' : 'x';
    if(jest.bolge === 'kuyruk'){
      /* Kuyrukta yalnız GERİ (parmak aşağı) dikey hareket komuttur; karar
         İLK harekette verilir — ilk touchmove iptal edilmezse tarayıcı
         kaydırmayı başlatır ve sonrakiler artık iptal edilemez. */
      if(jest.geri === undefined) jest.geri = dy > 0 && Math.abs(dy) >= Math.abs(dx);
      if(jest.geri) e.preventDefault(); else jest = null;
      return;
    }
    /* Kapı ve oda bandında doğal kaydırma ve momentum hiç başlamaz — ilk
       hareketten itibaren (eksen belli olmadan da), kilit sürerken gelen
       hareketler dahil (yok sayılır). */
    e.preventDefault();
  }, { passive:false });

  window.addEventListener('touchend', e=>{
    const j = jest; jest = null;
    if(!j || j.iptal || e.touches.length > 0) return;
    const t = e.changedTouches[0];
    const dx = t.clientX - j.x0, dy = t.clientY - j.y0;
    const sure = Math.max(1, performance.now() - j.t0);
    if(j.bolge === 'kapi'){
      /* İlk dokunuş ya da ilk kaydırma girişi başlatır (giriş sürerken yok sayılır) */
      if(kapiGiris.durum === 'bekliyor') playDoorIntro();
      return;
    }
    const eksen = j.eksen || (Math.abs(dy) >= Math.abs(dx) ? 'y' : 'x');
    const d = eksen === 'y' ? dy : dx;
    const yeterli = Math.abs(d) >= ESIK_PX || (Math.abs(d) >= HIZ_MIN_PX && Math.abs(d) / sure >= HIZ_ESIGI);
    if(!yeterli || mobilAdim.kilit) return;          // eşik altı ya da geçiş sürüyor: adım yok
    const yon = d < 0 ? 1 : -1;                       // yukarı/sola = ileri
    if(j.bolge === 'kuyruk'){
      if(eksen !== 'y' || yon > 0) return;
      const son = ROOMS[ROOMS.length - 1];
      adimKomutu(son.id, roomState[son.id].count - 1);
      return;
    }
    const oda = merkezOda();
    if(!oda) return;
    const st = roomState[oda];
    let hedefIdx = st.index + yon;
    /* Kapı↔oda geçiş bölgesinde (0. adıma henüz varılmamış) ileri hareket önce 0. adıma oturtur */
    if(yon > 0 && st.index === 0 && document.getElementById(oda).dataset.overlap
       && window.scrollY < adimKonumu(oda, 0) - 20) hedefIdx = 0;
    /* İlk odanın ilk adımında geri hareket kapıya DÖNMEZ (kapı yalnız girişte) */
    if(yon < 0 && hedefIdx < 0 && ROOMS[0] && ROOMS[0].id === oda) return;
    if(hedefIdx >= 0 && hedefIdx < st.count){
      adimKomutu(oda, hedefIdx);                      // aynı oda içinde tek adım
      return;
    }
    if(eksen === 'x') return;                         // yatay hareket oda sınırını geçmez (eski davranış)
    /* ODA SINIRI: son adımdan ileri → sonraki odanın 0. adımı; ilk adımdan geri → önceki odanın son adımı */
    const ri = ROOMS.findIndex(r=>r.id === oda);
    const komsu = ROOMS[ri + yon];
    if(komsu && roomState[komsu.id]){
      adimKomutu(komsu.id, yon > 0 ? 0 : roomState[komsu.id].count - 1);
    } else if(yon > 0 && !mobilAdim.kilit){
      /* Tur bandının ucu: tur sonu sahnesine bir ekran kaydır, oradan doğal kaydırma devralır */
      mobilAdim.kilit = true;
      kaydirAnim(window.scrollY + window.innerHeight, reduceMotion ? 0 : MOBIL_KAYDIRMA_MS, yumusak);
      setTimeout(()=>{ mobilAdim.kilit = false; }, MOBIL_GECIS_MS + MOBIL_GECIS_PAYI_MS);
    }
  }, { passive:true });

  /* Dokunma iptal edilirse (sistem hareketi vb.) yarım jest kalmasın */
  window.addEventListener('touchcancel', ()=>{ jest = null; }, { passive:true });
  /* Mobilde fare tekeri / dokunmatik yüzey: kapı beklerken girişi başlatır,
     oynarken ve oda geçişi sürerken yok sayılır. */
  window.addEventListener('wheel', e=>{
    if(ustteAcikKatmanVar()) return;
    if(kapiGiris.durum === 'oynuyor'){ e.preventDefault(); return; }
    if(kapiGiris.durum === 'bekliyor' && e.deltaY > 0){ e.preventDefault(); playDoorIntro(); }
  }, { passive:false });
}

/* ════════ AÇILIR PENCERE (Shopify Forms) AÇIKKEN ARKA PLAN SABİT ════════
   Pencere bir gölge DOM içinde (shopify-forms-embed); dokunma/teker olayları
   ona gelir. Olay yolunda pencerenin kendi kayan bir alanı yoksa hareket
   arka plandaki tura geçmez (önceden tur, pencerenin arkasında ilerliyordu). */
function formsKayanVar(e){
  const yol = e.composedPath ? e.composedPath() : [];
  for(const el of yol){
    if(el === document.documentElement || el === document.body || el === window || el === document) break;
    if(el.nodeType === 1 && el.scrollHeight > el.clientHeight + 2 && /(auto|scroll)/.test(getComputedStyle(el).overflowY)) return true;
  }
  return false;
}
['touchmove', 'wheel'].forEach(tur => window.addEventListener(tur, e=>{
  const t = e.target;
  if(t && t.tagName === 'SHOPIFY-FORMS-EMBED' && !formsKayanVar(e) && e.cancelable) e.preventDefault();
}, { passive:false }));

/* Kapı ekranındaki ikincil yol: turu atlayıp koleksiyon menüsünü açar */
document.getElementById('kapiKoleksiyon')?.addEventListener('click', e=>{
  e.preventDefault(); e.stopPropagation(); openMenu(false);
});

/* ════════ İNDİRİM PENCERESİ ZAMANLAMASI ════════
   Forms penceresi süreyle açılıyor (mağaza ayarı: 25 sn) ve turun ortasında
   odanın akışını kesiyordu. Turda pencere yalnız SAKİN anlarda görünür:
   bir odanın son adımı (kapanış kartı), turun sonu, koleksiyon listesi
   (üstünde ürün/sepet/menü yokken) ya da masaüstünde çıkış niyeti (fare
   pencerenin üstünden çıkınca). Bu anların dışında açıldıysa gizli bekler ve
   ilk sakin anda görünür; bir kez göründükten sonra bir daha gizlenmez. */
let popupSerbest = false, cikisNiyetiAni = 0;
function popupSakinMi(){
  if(popupSerbest || Date.now() - cikisNiyetiAni < 8000) return true;
  if(cartDrawer.classList.contains('open')) return false;
  const ust = overlayStack[overlayStack.length - 1];
  if(ust) return ust.tip === 'kol';
  const oda = updateRooms.merkezde;
  if(oda){ const st = roomState[oda]; return st.index >= st.count - 1; }
  const son = ROOMS.length && document.getElementById(ROOMS[ROOMS.length - 1].id);
  return Boolean(son) && son.getBoundingClientRect().bottom < window.innerHeight / 2;
}
function popupGorunurMu(){
  const f = document.querySelector('shopify-forms-embed')?.shadowRoot?.querySelector('form');
  return Boolean(f && f.getBoundingClientRect().width > 0);
}
function popupKapisi(){
  const sakin = popupSakinMi();
  document.documentElement.classList.toggle('sumer-popup-bekle', !sakin);
  if(sakin && !popupSerbest && popupGorunurMu()) popupSerbest = true;
}
popupKapisi();
setInterval(popupKapisi, 400);
document.addEventListener('mouseout', e=>{
  if(!e.relatedTarget && e.clientY <= 0){ cikisNiyetiAni = Date.now(); popupKapisi(); }
});

/* ════════ YATAY KAYDIRMA → TURDA İLERLEME ════════
   Eserler duvarda sağdan geldiği için touchpad'de refleks olarak yana
   kaydırılıyor. Turda yatay içerik yok (body overflow-x:clip), yani bu
   hareket normalde hiçbir işe yaramıyor — dikey ilerlemeye çeviriyoruz.

   Dikkat edilen noktalar:
   - html'de scroll-behavior:smooth var; scrollBy varsayılan davranışla
     çağrılırsa her tık için ayrı bir yumuşak animasyon kuyruğa girer ve
     kaydırma takılarak ilerler. Bu yüzden behavior:'auto'.
   - Çapraz hareketlerde dikey niyeti çalmamak için yatay bileşenin
     belirgin şekilde baskın olması aranır.
   - Alt navigasyon çubuğu gerçekten yatay kaydırılabilir; oranın üstünde
     olay ona bırakılır.
   - Üstte açık bir katman varsa (modal, sepet, menü, koleksiyon, panel)
     karışmayız; onların kendi kaydırmaları var. */
const YATAY_BASKINLIK = 1.2;   // |deltaX| bunun katı kadar deltaY'yi geçmeli
const YATAY_ESIK_PX   = 2;     // gürültü eşiği
function ustteAcikKatmanVar(){
  return modalBackdrop.classList.contains('open')
      || cartDrawer.classList.contains('open')
      || menuOverlay.classList.contains('open')
      || collection.classList.contains('open')
      || Boolean(document.querySelector('.info-panel.open'));
}
window.addEventListener('wheel', e=>{
  const dx = e.deltaX;
  if(Math.abs(dx) < YATAY_ESIK_PX) return;
  if(Math.abs(dx) < Math.abs(e.deltaY) * YATAY_BASKINLIK) return;
  if(ustteAcikKatmanVar()) return;
  if(e.target.closest && e.target.closest('.bottom-nav')) return;
  /* deltaMode 1 = satır birimi (bazı fareler): piksele çevir */
  const mesafe = e.deltaMode === 1 ? dx * 16 : dx;
  e.preventDefault();
  window.scrollBy({ top: mesafe, left: 0, behavior: 'auto' });
}, { passive: false });

/* ============ DERİN BAĞLANTI (Dawn sayfalarından tura dönüş) ============
   Dawn sayfaları (sayfa, politika, koleksiyon, ürün, blog, sepet) üst menüden
   ve "Sanal turda gör" bağlantılarından tura şu parametrelerle döner:
     /?menu=koleksiyonlar    → tur kapıda açılır, hamburger menü (kategori listesi) açık gelir
     /?koleksiyon=<handle>   → kapı sahnesi atlanır: sayfa doğrudan o odanın başına konumlanır ve
                               odanın koleksiyon ekranı açık gelir; kapatınca kullanıcı turun
                               içinde, o odadadır. <handle> oda kimliği (salon) ya da Shopify
                               koleksiyon handle'ı (modern-yasam-alani) olabilir. Oda olmayan
                               "Çerçeveler ve Diğer Ürünler"de sayfa kapıda kalır, yalnız ekran açılır.
     /?rehber=1              → tur kapıda açılır, rehber paneli açık gelir
   Geçersiz/bilinmeyen değerde tur normal açılır. Parametreler uygulandıktan sonra
   adresten temizlenir (replaceState — yeni geçmiş kaydı oluşmaz): "geri" yine bir
   önceki sayfaya döner, sayfa yenilenince ekran tekrar açılmaz. */
(function derinBaglanti(){
  const q = new URLSearchParams(location.search);
  const menu = q.get('menu'), kol = q.get('koleksiyon'), rehber = q.get('rehber');
  const urun = q.get('urun'), varyant = q.get('variant');
  /* ?oda=<oda id | koleksiyon handle>: turda doğrudan o odanın başı (ürün/koleksiyon
     sayfalarındaki oda şeridi ve "Gezintiye devam et" buraya gelir). Ekran açmaz,
     adres kaydı eklemez; parametre adresten silinir. */
  const oda = q.get('oda');
  if(menu === null && kol === null && rehber === null && urun === null && oda === null) return;
  /* Açılış kaydı ekransız (temel) adrese çevrilir; açılan ekranlar kendi
     adreslerini yeni kayıt olarak ekler — geri tuşu önce ekranı kapatır,
     sonra siteden çıkar. Yalnız kendi parametrelerimiz silinir. */
  KENDI_PARAMLAR.forEach(k => q.delete(k));
  const kalan = q.toString();
  try{ history.replaceState(history.state, '', location.pathname + (kalan ? '?' + kalan : '') + location.hash); }catch(e){}
  const uygula = () => {
    if(oda && /^[a-z0-9-]{1,80}$/i.test(oda)){
      const r = ROOMS.find(x => x.id === oda || roomCollection(x.id) === oda);
      if(r){ goToRoomStart(r.id, true); return; }
    }
    if(urun && /^[a-z0-9-]{1,200}$/i.test(urun)){ urunAc(urun.toLowerCase(), /^\d{1,20}$/.test(varyant || '') ? varyant : null); return; }
    if(kol && /^[a-z0-9-]{1,80}$/i.test(kol)){
      const hedef = [...ROOMS, ...MENU_EK_KATEGORI].find(r => r.id === kol || roomCollection(r.id) === kol);
      if(hedef){
        if(ROOMS.includes(hedef)) goToRoomStart(hedef.id, true);
        openCollection(hedef.id);
        return;
      }
    }
    if(rehber === '1'){ openPanel('guidePanel'); return; }
    if(menu === 'koleksiyonlar'){ openMenu(false); return; }
  };
  /* ?urun=<handle>: önce duvarlarda ara (oda + eserin adımı), yoksa
     koleksiyonlarda (odalar sırasıyla, sonra "Çerçeveler ve Diğer Ürünler").
     Geçersiz handle → hiçbir şey yapılmaz, tur normal açılır. */
  function urunAc(h, varyantId){
    for(const room of ROOMS){
      const idx = room.items.findIndex(it => it.handle === h);
      if(idx < 0) continue;
      goToRoomStart(room.id, true, idx);
      const veri = duvarEseriVerisi(room, idx);
      veri.varyantId = varyantId;
      openModal(veri);
      return;
    }
    if(!SHOPIFY.hosted) return;
    fetchProductData(h).then(async prod => {
      if(!prod) return;                                     // böyle bir ürün yok
      const adaylar = [...ROOMS, ...MENU_EK_KATEGORI].filter(r => roomCollection(r.id));
      const listeler = adaylar.map(r => fetchCollectionProducts(roomCollection(r.id)));   // paralel; öncelik sırayla
      for(let i = 0; i < adaylar.length; i++){
        const liste = await listeler[i];
        const p = (liste || []).find(x => x.handle === h);
        if(!p) continue;
        const cat = adaylar[i];
        const veri = koleksiyonKarti(p, cat.name);
        veri.listeden = true;
        veri.varyantId = varyantId;
        /* "Çerçeveyi Aşanlar": taşan parça + ham poster ürün verisinden (bkz. koleksiyonKartiEkle) */
        if(veri.cat === CERCEVE_KATEGORI_ADI){
          const med = (prod.media || []).filter(x => x.media_type === 'image');
          const st = med.find(x => (x.alt || '').trim() === 'vitrin-sticker');
          const dv = med.find(x => (x.alt || '').trim() === 'vitrin-duvar');
          if(st) veri.overflow = {src: st.src};
          if(dv){ veri.src = dv.src; veri.raw = true; }
          if((prod.tags || []).indexOf(SADECE_MOCKUP_ETIKET) >= 0) veri.sadeceMockup = true;
        }
        if(ROOMS.includes(cat)) goToRoomStart(cat.id, true);
        else { goToRoomStart(ROOMS[0].id, true); openCollection(cat.id); }
        openModal(veri);
        return;
      }
    });
  }
  /* Odalar ve ScrollTrigger kurulduktan sonra (iki kare sonra) uygula */
  requestAnimationFrame(() => requestAnimationFrame(uygula));
})();
